<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.student.edit')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">
                <back-button></back-button>
                <b-alert v-model="showDisableAlert" variant="info">
                    {{ disableEditFormMessage }}
                    <button v-if="!firstLoad && sessionCreated" @click="checkForEdit(true)">
                        <i class="fas fa-sync"></i>
                    </button>
                </b-alert>

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{ alertMessage }}
                </b-alert>

                <div class="card">
                    <div class="card-header bg-light">
                        <div class="card-title">{{ cardTitle }}</div>
                        <div class="text-right">
                            <button class="btn btn-primary" @click="updateStudent()"
                                :disabled="disableEditForm || readonly">
                                {{ $t("button.update") }}
                            </button>
                            <button class="btn btn-info" @click="updateStudent(true)"
                                :disabled="disableEditForm || readonly">
                                {{ $t("button.updateClose") }}
                            </button>
                        </div>
                    </div>

                    <div class="card-body">
                        <b-tabs content-class="mt-3" v-model="tabIndex">
                            <b-tab :title="$t('form.student.tabPersonal')" active>
                                <personal :student.sync="student" :permissions="permissions"
                                    :readonly="readonlypersonalinformation" :isLoading.sync="isLoading"
                                    :image.sync="image" :dateFormat="dateFormat" :onChangeStatus="onChangeStatus"
                                    :statusList="statusList" :status.sync="status" :studentStatus="studentStatus"
                                    :titles="titles" :countries="countries" :partners="partners"
                                    :partnercampus="partnercampus" :statusDate="statusDate"
                                    :partnersDisabled="partnersDisabled" :selectedPartner="selectedPartner"
                                    :studentProgram="studentProgram" :markGraduated="markGraduated"
                                    :getStudent="getStudent" :showAlert="showAlert" @deleteStatus="deleteStatus"
                                    @Withdraw="Withdraw" />
                            </b-tab>

                            <b-tab :title="$t('form.student.tabBusiness')">
                                <div class="row">
                                    <div class="col-sm-8" v-if="
                                        parseInt(student.MailAddress) === 2
                                    ">
                                        <div class="form-group">
                                            <label for="CompanyName:">
                                                {{
                                                    $t(
                                                        "form.student.companyName"
                                                    )
                                                }}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input :disabled="showBusinessTab" id="CompanyName" type="text"
                                                v-model.trim="$v.studentBussiness
                                                        .CompanyName.$model
                                                    " name="CompanyName" class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness
                                                            .CompanyName.$error
                                                }" />
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness
                                                    .CompanyName.required
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness
                                                    .CompanyName.maxLength
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.maxLength",
                                                        {
                                                            num:
                                                                $v
                                                                    .studentBussiness
                                                                    .CompanyName
                                                                    .$params
                                                                    .maxLength
                                                                    .max
                                                        }
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessDepartment">
                                                {{
                                                    $t(
                                                        "form.student.department"
                                                    )
                                                }}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" id="BusinessDepartment"
                                                v-model.trim="$v.studentBussiness
                                                        .Department.$model
                                                    " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness
                                                            .Department.$error
                                                }" />
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness
                                                    .Department.required
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness
                                                    .Department.maxLength
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.maxLength",
                                                        {
                                                            num:
                                                                $v
                                                                    .studentBussiness
                                                                    .Department
                                                                    .$params
                                                                    .maxLength
                                                                    .max
                                                        }
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessPosition:">
                                                {{
                                                    $t("form.student.position")
                                                }}
                                                <span class="req text-danger">*</span>
                                            </label>

                                            <input :disabled="showBusinessTab" id="BusinessPosition:"
                                                name="BusinessPosition" v-model.trim="$v.studentBussiness.Position
                                                        .$model
                                                    " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness
                                                            .Position.$error
                                                }" />
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness
                                                    .Position.required
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness
                                                    .Position.maxLength
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.maxLength",
                                                        {
                                                            num:
                                                                $v
                                                                    .studentBussiness
                                                                    .Position
                                                                    .$params
                                                                    .maxLength
                                                                    .max
                                                        }
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="StreetAddress:">
                                                {{
                                                    $t(
                                                        "form.student.streetAddress"
                                                    )
                                                }}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" v-model.trim="$v.studentBussiness
                                                    .StreetAddress.$model
                                                " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness
                                                            .StreetAddress
                                                            .$error
                                                }" />
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness
                                                    .StreetAddress.required
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="City:">
                                                {{ $t("form.student.city") }}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" id="City" v-model.trim="$v.studentBussiness.City
                                                    .$model
                                                " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness.City
                                                            .$error
                                                }" />
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.City
                                                    .required
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.City
                                                    .maxLength
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.maxLength",
                                                        {
                                                            num:
                                                                $v
                                                                    .studentBussiness
                                                                    .City
                                                                    .$params
                                                                    .maxLength
                                                                    .max
                                                        }
                                                    )
                                                }}
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class for="Zip:">
                                                {{ $t("form.student.zip") }}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" v-model.trim="$v.studentBussiness.Zip
                                                    .$model
                                                " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness.Zip
                                                            .$error
                                                }" />
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.Zip
                                                    .required
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.Zip
                                                    .maxLength
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.maxLength",
                                                        {
                                                            num:
                                                                $v
                                                                    .studentBussiness
                                                                    .Zip.$params
                                                                    .maxLength
                                                                    .max
                                                        }
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Country:">
                                                {{ $t("form.student.country") }}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <v-select :disabled="showBusinessTab" label="printable_name"
                                                :options="countries" v-model.trim="$v.studentBussiness.Country
                                                        .$model
                                                    " :reduce="countries =>
                                                        countries.printable_name
                                                    " class="BussinessCountry">
                                            </v-select>
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.Country
                                                    .required
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Phone:">
                                                {{ $t("form.student.phone") }}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" v-model.trim="$v.studentBussiness.Phone
                                                    .$model
                                                " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness
                                                            .Phone.$error
                                                }" />
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.Phone
                                                    .required
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.Phone
                                                    .maxLength
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.maxLength",
                                                        {
                                                            num:
                                                                $v
                                                                    .studentBussiness
                                                                    .Phone
                                                                    .$params
                                                                    .maxLength
                                                                    .max
                                                        }
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Mobile:">
                                                {{ $t("form.student.mobile") }}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" v-model.trim="$v.studentBussiness.Mobile
                                                    .$model
                                                " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness
                                                            .Mobile.$error
                                                }" />
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.Mobile
                                                    .required
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.Mobile
                                                    .maxLength
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.maxLength",
                                                        {
                                                            num:
                                                                $v
                                                                    .studentBussiness
                                                                    .Mobile
                                                                    .$params
                                                                    .maxLength
                                                                    .max
                                                        }
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Fax:">{{
                                                $t("form.student.fax")
                                                }}</label>

                                            <input id="Fax:" name="Fax" v-model="studentBussiness.Fax" type="text"
                                                class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId31" :disabled="showBusinessTab" />
                                            <span id="errId31" class="error"></span>
                                        </div>
                                        <div class="form-group">
                                            <label>
                                                {{ $t("form.student.email") }}
                                                <span class="req text-danger">*</span>
                                            </label>
                                            <input :disabled="showBusinessTab" type="email" v-model.trim="$v.studentBussiness.Email
                                                    .$model
                                                " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness
                                                            .Email.$error
                                                }" />
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.Email
                                                    .required
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness.Email
                                                    .email
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.validEmail"
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="BussinessWebAddress:">
                                                {{
                                                    $t(
                                                        "form.student.webAddress"
                                                    )
                                                }}
                                            </label>

                                            <input :disabled="showBusinessTab" id="BussinessWebAddress:"
                                                name="BussinessWebAddress" v-model="studentBussiness.WebAddress
                                                    " type="text" class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId33" />
                                        </div>
                                        <div class="form-group">
                                            <h5>
                                                <b>
                                                    <u>{{
                                                        $t(
                                                            "form.student.contactPerson"
                                                        )
                                                    }}</u>
                                                </b>
                                            </h5>
                                            <p id="field89" data-default-label="Header" data-default-is-header="true"
                                                data-control-type="header"></p>
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonTitle:">{{
                                                $t("form.student.title")
                                            }}</label>
                                            <v-select :disabled="showBusinessTab" :options="titles" v-model="studentBussiness.ContactPersonTitle
                                                " :reduce="titles => titles">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class for="FirstName:">
                                                {{
                                                    $t("form.student.firstName")
                                                }}
                                            </label>

                                            <input :disabled="showBusinessTab" type="text"
                                                id="ContactPersonFirstNameField" v-model.trim="$v.studentBussiness
                                                        .ContactPersonFirstName
                                                        .$model
                                                    " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness
                                                            .ContactPersonFirstName
                                                            .$error
                                                }" />

                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness
                                                    .ContactPersonFirstName
                                                    .maxLength
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.maxLength",
                                                        {
                                                            num:
                                                                $v
                                                                    .studentBussiness
                                                                    .ContactPersonFirstName
                                                                    .$params
                                                                    .maxLength
                                                                    .max
                                                        }
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="LastName:">
                                                {{
                                                    $t("form.student.lastName")
                                                }}
                                            </label>

                                            <input :disabled="showBusinessTab" type="text"
                                                id="ContactPersonLastNameField" v-model.trim="$v.studentBussiness
                                                        .ContactPersonLastName
                                                        .$model
                                                    " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness
                                                            .ContactPersonLastName
                                                            .$error
                                                }" />

                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness
                                                    .ContactPersonLastName
                                                    .maxLength
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.maxLength",
                                                        {
                                                            num:
                                                                $v
                                                                    .studentBussiness
                                                                    .ContactPersonLastName
                                                                    .$params
                                                                    .maxLength
                                                                    .max
                                                        }
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonDepartment:">
                                                {{
                                                    $t(
                                                        "form.student.department"
                                                    )
                                                }}
                                            </label>

                                            <input :disabled="showBusinessTab" type="text" id="ContactPersonDepartment"
                                                v-model.trim="$v.studentBussiness
                                                        .ContactPersonDepartment
                                                        .$model
                                                    " class="form-control" :class="{
                                                    'is-invalid':
                                                        $v.studentBussiness
                                                            .ContactPersonDepartment
                                                            .$error
                                                }" />

                                            <div class="invalid-feedback" v-if="
                                                !$v.studentBussiness
                                                    .ContactPersonDepartment
                                                    .maxLength
                                            ">
                                                {{
                                                    $t(
                                                        "form.validation.maxLength",
                                                        {
                                                            num:
                                                                $v
                                                                    .studentBussiness
                                                                    .ContactPersonDepartment
                                                                    .$params
                                                                    .maxLength
                                                                    .max
                                                        }
                                                    )
                                                }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-8" v-else>
                                        <div class="form-group">
                                            <label for="CompanyName:">
                                                {{
                                                    $t(
                                                        "form.student.companyName"
                                                    )
                                                }}
                                            </label>
                                            <input :disabled="showBusinessTab" id="CompanyName" type="text"
                                                v-model.trim="studentBussiness.CompanyName
                                                    " name="CompanyName" class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessDepartment">
                                                {{
                                                    $t(
                                                        "form.student.department"
                                                    )
                                                }}
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" id="BusinessDepartment"
                                                v-model.trim="studentBussiness.Department
                                                    " class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label class for="BusinessPosition:">
                                                {{
                                                    $t("form.student.position")
                                                }}
                                            </label>

                                            <input :disabled="showBusinessTab" id="BusinessPosition:"
                                                name="BusinessPosition" v-model.trim="studentBussiness.Position
                                                    " class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label class for="StreetAddress:">
                                                {{
                                                    $t(
                                                        "form.student.streetAddress"
                                                    )
                                                }}
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" v-model.trim="studentBussiness.StreetAddress
                                                " class="form-control" />
                                        </div>

                                        <div class="form-group">
                                            <label for="City:">
                                                {{ $t("form.student.city") }}
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" id="City" v-model.trim="studentBussiness.City
                                                " class="form-control" />
                                        </div>

                                        <div class="form-group">
                                            <label class for="Zip:">
                                                {{ $t("form.student.zip") }}
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" v-model.trim="studentBussiness.Zip
                                                " class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label class for="Country:">
                                                {{ $t("form.student.country") }}
                                            </label>
                                            <v-select :disabled="showBusinessTab" label="printable_name"
                                                :options="countries" v-model.trim="studentBussiness.Country
                                                    " :reduce="countries =>
                                                        countries.printable_name
                                                    " class="BussinessCountry">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class for="Phone:">
                                                {{ $t("form.student.phone") }}
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" v-model.trim="studentBussiness.Phone
                                                " class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label class for="Mobile:">
                                                {{ $t("form.student.mobile") }}
                                            </label>
                                            <input :disabled="showBusinessTab" type="text" v-model.trim="studentBussiness.Mobile
                                                " class="form-control" />
                                        </div>
                                        <div class="form-group">
                                            <label class for="Fax:">{{
                                                $t("form.student.fax")
                                                }}</label>

                                            <input id="Fax:" name="Fax" v-model="studentBussiness.Fax" type="text"
                                                class="form-control" data-role="text"
                                                data-parsley-errors-container="#errId31" :disabled="showBusinessTab" />
                                            <span id="errId31" class="error"></span>
                                        </div>
                                        <div class="form-group">
                                            <label>
                                                {{ $t("form.student.email") }}
                                            </label>
                                            <input type="email" v-model.trim="studentBussiness.Email
                                                " class="form-control" :disabled="showBusinessTab" />
                                        </div>
                                        <div class="form-group">
                                            <label class for="BussinessWebAddress:">
                                                {{
                                                    $t(
                                                        "form.student.webAddress"
                                                    )
                                                }}
                                            </label>

                                            <input id="BussinessWebAddress:" name="BussinessWebAddress" v-model="studentBussiness.WebAddress
                                                " type="text" class="form-control" data-role="text"
                                                :disabled="showBusinessTab" data-parsley-errors-container="#errId33" />
                                        </div>
                                        <div class="form-group">
                                            <h5>
                                                <b>
                                                    <u>{{
                                                        $t(
                                                            "form.student.contactPerson"
                                                        )
                                                    }}</u>
                                                </b>
                                            </h5>
                                            <p id="field89" data-default-label="Header" data-default-is-header="true"
                                                data-control-type="header"></p>
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonTitle:">{{
                                                $t("form.student.title")
                                            }}</label>
                                            <v-select :disabled="showBusinessTab" :options="titles" v-model="studentBussiness.ContactPersonTitle
                                                " :reduce="titles => titles">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class for="FirstName:">
                                                {{
                                                    $t("form.student.firstName")
                                                }}
                                            </label>

                                            <input type="text" id="ContactPersonFirstNameField" v-model.trim="studentBussiness.ContactPersonFirstName
                                                " class="form-control" :disabled="showBusinessTab" />
                                        </div>
                                        <div class="form-group">
                                            <label class for="LastName:">
                                                {{
                                                    $t("form.student.lastName")
                                                }}
                                            </label>

                                            <input type="text" id="ContactPersonLastNameField" v-model.trim="studentBussiness.ContactPersonLastName
                                                " class="form-control" :disabled="showBusinessTab" />
                                        </div>
                                        <div class="form-group">
                                            <label class for="ContactPersonDepartment:">
                                                {{
                                                    $t(
                                                        "form.student.department"
                                                    )
                                                }}
                                            </label>

                                            <input type="text" id="ContactPersonDepartment" v-model.trim="studentBussiness.ContactPersonDepartment
                                                " class="form-control" :disabled="showBusinessTab" />
                                        </div>
                                    </div>

                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class for="Notes:">{{
                                                $t("form.student.notes")
                                                }}</label>
                                            <textarea id="Notes:" name="Notes" v-model="studentBussiness.Notes"
                                                rows="15" class="form-control" data-role="textarea"
                                                data-parsley-errors-container="#errId39"
                                                :disabled="showBusinessTab"></textarea>
                                            <span id="errId39" class="error"></span>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.student.tabRemarks')">
                                <div class="form-group" v-if="student.ID" :key="student.ID">
                                    <div class="mb-3">
                                        <label>{{
                                            $t("form.student.remarks")
                                            }}</label>
                                        <b-button :disabled="!permissions.editStudentsRemarks
                                            " @click="downloadRemarks" class="float-right">
                                            {{
                                                $t("button.exportPDF")
                                            }}</b-button>
                                    </div>
                                    <summernote id="summernoteRemarks" v-model="student.Remarks" :disabled="!permissions.editStudentsRemarks
                                        "></summernote>
                                    <p class="text-muted">
                                        {{
                                            $t("form.student.remarksExportNote")
                                        }}
                                    </p>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.student.tabAdmission')" class="position-relative">
                                <div class="graduated-overlay" v-if="studentProgram.Graduate"></div>
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="form-group">
                                            <label for="EducationalBackground:">{{
                                                $t(
                                                    "form.student.background"
                                                )
                                            }}</label>
                                            <div class>
                                                <textarea :disabled="!permissions.editStudentsAdmissions
                                                    " id="educationalbackground:" name="educationalbackground" v-model="studentAdmission.EducationalBackground
                                                        " rows="15" class="form-control" data-role="textarea"
                                                    data-parsley-errors-container="#errId40"></textarea>
                                                <span id="errId40" class="error"></span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-7">
                                        <label>{{
                                            $t("form.student.bachelorAdmission")
                                            }}</label>
                                        <div class="row">
                                            <div class="col-6">
                                                <label class="checkbox" for="checkbox141">
                                                    <input :disabled="!permissions.editStudentsAdmissions
                                                        " type="checkbox" name="ExamAdmBBA" v-model="studentAdmission.ExamAdmBBA
                                                            " id="checkbox141" data-parsley-errors-container="#errId41"
                                                        @change="
                                                            changeCheck($event)
                                                            " value="0" />
                                                    {{
                                                        $t(
                                                            "form.student.admissionOption1"
                                                        )
                                                    }}
                                                </label>
                                            </div>

                                            <div class="col-6">
                                                <div class="form-group">
                                                    <div class>
                                                        <input :disabled="!permissions.editStudentsAdmissions
                                                            " id="ExamAdmResultBBA" type="text" class="form-control"
                                                            data-role="text" data-parsley-errors-container="#errId42"
                                                            name="ExamAdmResultBBA" v-model="studentAdmission.ExamAdmResultBBA
                                                                " :placeholder="$t(
                                                                'form.student.result'
                                                            )
                                                                " />
                                                        <span id="errId42" class="error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6">
                                                <label class="checkbox" for="checkbox143">
                                                    <input :disabled="!permissions.editStudentsAdmissions
                                                        " type="checkbox" id="checkbox143" name="ExamOthBBA" v-model="studentAdmission.ExamOthBBA
                                                            " data-parsley-errors-container="#errId41" @change="
                                                            changeCheck($event)
                                                            " value="0" />
                                                    {{
                                                        $t(
                                                            "form.student.admissionOption3"
                                                        )
                                                    }}
                                                </label>
                                            </div>

                                            <div class="col-6">
                                                <div class="form-group">
                                                    <div class>
                                                        <input :disabled="!permissions.editStudentsAdmissions
                                                            " id="result_other_b" type="text" name="ExamOthResultBBA"
                                                            v-model="studentAdmission.ExamOthResultBBA
                                                                " class="form-control" data-role="text"
                                                            data-parsley-errors-container="#errId44" :placeholder="$t(
                                                                'form.student.result'
                                                            )
                                                                " />
                                                        <span id="errId44" class="error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <label>{{
                                            $t("form.student.masterAdmission")
                                            }}</label>
                                        <div class="row">
                                            <div class="col-6">
                                                <label class="checkbox" for="checkbox149">
                                                    <input :disabled="!permissions.editStudentsAdmissions
                                                        " @change="
                                                            changeCheck($event)
                                                            " value="0" type="checkbox" name="ExamAdmMAS" id="checkbox149"
                                                        v-model="studentAdmission.ExamAdmMAS
                                                            " data-parsley-errors-container="#errId45" />
                                                    {{
                                                        $t(
                                                            "form.student.admissionOption1"
                                                        )
                                                    }}
                                                </label>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <div class>
                                                        <input :disabled="!permissions.editStudentsAdmissions
                                                            " id="result_entrance_m" type="text" class="form-control"
                                                            data-role="text" data-parsley-errors-container="#errId46"
                                                            name="ExamAdmResultMAS" v-model="studentAdmission.ExamAdmResultMAS
                                                                " :placeholder="$t(
                                                                'form.student.result'
                                                            )
                                                                " />
                                                        <span id="errId46" class="error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6">
                                                <label class="checkbox" for="ExamEntMAS">
                                                    <input :disabled="!permissions.editStudentsAdmissions
                                                        " type="checkbox" @change="
                                                            changeCheck($event)
                                                            " value="0" name="ExamEntMAS" id="ExamEntMAS" v-model="studentAdmission.ExamEntMAS
                                                            " data-parsley-errors-container="#errId45" />
                                                    {{
                                                        $t(
                                                            "form.student.admissionOption2"
                                                        )
                                                    }}
                                                </label>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <div class>
                                                        <input :disabled="!permissions.editStudentsAdmissions
                                                            " id="result_admission_m" name="ExamEntResultMAS" v-model="studentAdmission.ExamEntResultMAS
                                                                " type="text" class="form-control" data-role="text"
                                                            data-parsley-errors-container="#errId47" :placeholder="$t(
                                                                'form.student.result'
                                                            )
                                                                " />
                                                        <span id="errId47" class="error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6">
                                                <label class="checkbox" for="ExamOthMAS">
                                                    <input :disabled="!permissions.editStudentsAdmissions
                                                        " @change="
                                                            changeCheck($event)
                                                            " value="0" type="checkbox" id="ExamOthMAS" name="ExamOthMAS"
                                                        v-model="studentAdmission.ExamOthMAS
                                                            " data-parsley-errors-container="#errId45" />
                                                    {{
                                                        $t(
                                                            "form.student.admissionOption3"
                                                        )
                                                    }}
                                                </label>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <div class>
                                                        <input :disabled="!permissions.editStudentsAdmissions
                                                            " id="ExamOthResultMAS" type="text" name="ExamOthResultMAS"
                                                            v-model="studentAdmission.ExamOthResultMAS
                                                                " class="form-control" data-role="text"
                                                            data-parsley-errors-container="#errId48" :placeholder="$t(
                                                                'form.student.result'
                                                            )
                                                                " />
                                                        <span id="errId48" class="error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <label>{{
                                            $t(
                                                "form.student.doctorateAdmission"
                                            )
                                        }}</label>
                                        <div class="row">
                                            <div class="col-6">
                                                <label class="checkbox" for="ExamEntDBA">
                                                    <input :disabled="!permissions.editStudentsAdmissions
                                                        " type="checkbox" @change="
                                                            changeCheck($event)
                                                            " value="0" v-model="studentAdmission.ExamEntDBA
                                                            " id="ExamEntDBA" name="ExamEntDBA"
                                                        data-parsley-errors-container="#errId49" />
                                                    {{
                                                        $t(
                                                            "form.student.admissionOption2"
                                                        )
                                                    }}
                                                </label>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <div class>
                                                        <input :disabled="!permissions.editStudentsAdmissions
                                                            " id="ExamEntResultDBA" name="ExamEntResultDBA" v-model="studentAdmission.ExamEntResultDBA
                                                                " type="text" class="form-control" data-role="text"
                                                            data-parsley-errors-container="#errId50" :placeholder="$t(
                                                                'form.student.result'
                                                            )
                                                                " />
                                                        <span id="errId50" class="error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-6">
                                                <label class="checkbox" for="ExamOthDBA">
                                                    <input :disabled="!permissions.editStudentsAdmissions
                                                        " type="checkbox" @change="
                                                            changeCheck($event)
                                                            " value="0" v-model="studentAdmission.ExamOthDBA
                                                            " id="ExamOthDBA" name="ExamOthDBA"
                                                        data-parsley-errors-container="#errId49" />
                                                    {{
                                                        $t(
                                                            "form.student.admissionOption3"
                                                        )
                                                    }}
                                                </label>
                                            </div>
                                            <div class="col-6">
                                                <div class="form-group">
                                                    <div class>
                                                        <input :disabled="!permissions.editStudentsAdmissions
                                                            " id="ExamOthResultDBA" name="ExamOthResultDBA" v-model="studentAdmission.ExamOthResultDBA
                                                                " type="text" class="form-control" data-role="text"
                                                            data-parsley-errors-container="#errId51" :placeholder="$t(
                                                                'form.student.result'
                                                            )
                                                                " />
                                                        <span id="errId51" class="error"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.student.tabProgram')" class="position-relative">
                                <div class="graduated-overlay" v-if="!permissions.editStudentsProgram"></div>

                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label class for="Program">{{
                                                $t("form.student.program")
                                                }}</label><span class="text-danger">*</span>
                                            <div class>
                                                <v-select @input="selectProgram" label="FullTitle" :options="programs"
                                                    :disabled="!permissions.editStudentsProgram
                                                        " v-model="studentProgram.ProgramID
                                                        " :reduce="programs => programs.ID
                                                        ">
                                                </v-select>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label for="SecondrayMajor">
                                                {{
                                                    $t("form.student.program2")
                                                }}
                                            </label>
                                            <div v-if="secondaryPrograms.length">
                                                <v-select label="FullTitle" :options="secondaryPrograms" :disabled="!permissions.editStudentsProgram
                                                    " @input="selectProgram2" v-model="studentProgram.Program2ID
                                                        " :key="studentProgram.Program2ID
                                                        " :reduce="secondaryPrograms =>
                                                            secondaryPrograms.ID
                                                        " :resetOnOptionsChange="true">
                                                </v-select>
                                            </div>
                                            <div v-else>
                                                <select class="form-control" disabled>
                                                    <option value=""></option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="checkbox">
                                                <input type="checkbox" @change="
                                                    changeCheck($event)
                                                    " value="0" :disabled="!permissions.editStudentsProgram
                                                        " v-model="bookIncludedcheckbox
                                                        " />
                                                {{ $t("form.student.books") }}
                                            </label>
                                            <br />
                                            <label class="checkbox">
                                                <input type="checkbox" @change="
                                                    markGraduated($event)
                                                    " :checked="studentProgram.Graduate
                                                        " :disabled="studentProgram.Graduate ||
                                                        readonly ||
                                                        readonlyprogram ||
                                                        !permissions.editStudentsProgram
                                                        " />
                                                {{
                                                    $t("form.student.graduate")
                                                }}
                                            </label>
                                            <br />
                                            <label class="checkbox">
                                                <input type="checkbox" @change="
                                                    changeCheck($event)
                                                    " value="0" :disabled="!permissions.editStudentsProgram
                                                        " v-model="withdrawcheckbox" name="withdrawcheckbox" />
                                                {{
                                                    $t("form.student.withdrawn")
                                                }}
                                            </label>
                                        </div>

                                        <div class="form-group">
                                            <label for="ThesisSubject">{{
                                                $t("form.student.thesisSubject")
                                                }}</label>
                                            <div>
                                                <textarea id="ThesisSubject" :disabled="!permissions.editStudentsProgram
                                                    " v-model.trim="$v.studentProgram
                                                            .ThesisSubject
                                                            .$model
                                                        " name="ThesisSubject" rows="3" class="form-control"
                                                    data-role="textarea" :class="{
                                                        'is-invalid':
                                                            $v.studentProgram
                                                                .ThesisSubject
                                                                .$error
                                                    }"></textarea>
                                                <div class="invalid-feedback" v-if="
                                                    !$v.studentProgram
                                                        .ThesisSubject
                                                        .maxLength
                                                ">
                                                    {{
                                                        $t(
                                                            "form.validation.maxLength",
                                                            {
                                                                num:
                                                                    $v
                                                                        .studentProgram
                                                                        .ThesisSubject
                                                                        .$params
                                                                        .maxLength
                                                                        .max
                                                            }
                                                        )
                                                    }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6">
                                        <label for="DefenceExaminer">{{
                                            $t("form.student.defenceExaminer")
                                            }}</label>
                                        <div class="form-group">
                                            <label class="sr-only"></label>
                                            <v-select label="FullName" :options="professor" :disabled="!permissions.editStudentsProgram
                                                " v-model="studentProgram.Examiner1
                                                    " :reduce="professor => professor.ID
                                                    " :key="studentProgram.Examiner1">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class="sr-only"></label>
                                            <v-select label="FullName" :options="professor" :disabled="!permissions.editStudentsProgram
                                                " v-model="studentProgram.Examiner2
                                                    " :reduce="professor => professor.ID
                                                    " :key="studentProgram.Examiner2">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class="sr-only"></label>
                                            <v-select label="FullName" :options="professor" :disabled="!permissions.editStudentsProgram
                                                " v-model="studentProgram.Examiner3
                                                    " :key="studentProgram.Examiner3" :reduce="professor => professor.ID
                                                    ">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class="sr-only"></label>
                                            <v-select label="FullName" :options="professor" :disabled="!permissions.editStudentsProgram
                                                " v-model="studentProgram.Examiner4
                                                    " :key="studentProgram.Examiner4" :reduce="professor => professor.ID
                                                    ">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label class="sr-only"></label>
                                            <v-select label="FullName" :options="professor" :disabled="!permissions.editStudentsProgram
                                                " v-model="studentProgram.Examiner5
                                                    " :key="studentProgram.Examiner5" :reduce="professor => professor.ID
                                                    ">
                                            </v-select>
                                        </div>
                                        <div class="form-group">
                                            <label>{{
                                                $t(
                                                    "form.student.thesisEvaluation"
                                                )
                                            }}</label>
                                            <div class="mb-3" v-if="
                                                studentProgram.ThesisEvaluation
                                            ">
                                                <a href="#" @click.prevent="
                                                    downloadThesisEvaluation(
                                                        studentProgram.ThesisEvaluation,
                                                        true
                                                    )
                                                    ">
                                                    {{
                                                        studentProgram.ThesisEvaluation.split(
                                                            "/"
                                                        ).pop()
                                                    }}</a>
                                                |
                                                <a href="#" @click.prevent="
                                                    downloadThesisEvaluation(
                                                        studentProgram.ThesisEvaluation
                                                    )
                                                    ">{{ $t("button.view") }}</a>
                                            </div>
                                            <vue-dropzone ref="thesisEvaluationDropzone" id="thesisEvaluationDropzoneID"
                                                :disabled="!permissions.editStudentsProgram
                                                    " :options="thesisEvaluationDropzone
                                                    " @vdropzone-success="
                                                    thesisEvaluationUploaded
                                                " @vdropzone-processing="
                                                    isLoading = true
                                                    " v-on:vdropzone-sending="
                                                    sendingEvent
                                                ">
                                            </vue-dropzone>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="GraduationDate">
                                                {{
                                                    $t(
                                                        "form.student.graduateDate"
                                                    )
                                                }}
                                            </label>
                                            <div class>
                                                <date-picker :lang="lang" class="date-picker" :disabled="!permissions.editStudentsProgram
                                                    " v-model="studentProgram.GraduationDate
                                                        " valueType="format" :format="dateFormat" :popup-style="{
                                                        top: '100%',
                                                        left: 0
                                                    }" :append-to-body="false" :placeholder="studentProgram.GraduationDate
                                                        ">
                                                </date-picker>
                                                <span id="errId60" class="error"></span>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class for="ThesisPercentage">{{
                                                $t(
                                                    "form.student.thesisPercentage"
                                                )
                                            }}</label>
                                            <div class>
                                                <input id="ThesisPercentage" :disabled="!permissions.editStudentsProgram
                                                    " name="ThesisPercentage" type="number" class="form-control"
                                                    v-model.number="gradeDetails.Percentage
                                                        " readonly readonlyprogram />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="ThesisGrade">{{
                                                $t("form.student.thesisGrade")
                                                }}</label>
                                            <div class v-if="gradeDetails.DescriptiveGrade != ''">
                                                <input id="ThesisGrade" :disabled="!permissions.editStudentsProgram
                                                    " v-model.number="gradeDetails.DescriptiveGrade
                                                        " name="ThesisGrade" type="text" class="form-control" readonly
                                                    readonlyprogram />
                                            </div>
                                            <div class v-else>
                                                <input id="ThesisGrade" :disabled="!permissions.editStudentsProgram
                                                    " v-model.number="gradeDetails.LocalGrade
                                                        " name="ThesisGrade" type="text" class="form-control" readonly
                                                    readonlyprogram />
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label for="ThesisMentor">{{
                                                $t("form.student.thesisMentor")
                                                }}</label>
                                            <v-select label="FullName" :options="professor" :disabled="!permissions.editStudentsProgram
                                                " v-model="studentProgram.ThesisMentor
                                                    " :key="studentProgram.ThesisMentor
                                                    " :reduce="professor => professor.ID
                                                    ">
                                            </v-select>
                                        </div>
                                        <div class="form-group" v-if="!readonly || !readonlyprogram">
                                            <b-button variant="default" v-b-modal.addProfessorModal :disabled="!permissions.editStudentsProgram
                                                ">
                                                {{ $t("button.newProfessor") }}
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.student.tabGrade')" class="position-relative" ref="gradesTab"
                                v-if="permissions.viewStudentsGrades">
                                <div class="graduated-overlay" v-if="
                                    studentProgram.Graduate ||
                                    (!permissions.addStudentsGrades &&
                                        !permissions.editStudentsGrades)
                                "></div>

                                <grades :readonly="readonly" :isLoading="isLoading"
                                    v-on:noGradingScale="handleNoGradingScale" :noGradingScale="noGradingScale"
                                    :foundationGrades="foundationGrades" :foundationProgram="foundationProgram"
                                    :fpCourses="fpCourses" :fpGrades="fpGrades" :partnerCode="partnerCode"
                                    :gradingScale="gradingScale" :localMaxGrade="localMaxGrade"
                                    :localMinGrade="localMinGrade" :secondaryGrades="secondaryGrades"
                                    :showGradesBtns="showGradesBtns" :showLocalGrades="showLocalGrades"
                                    :showSecondaryLocalGrades="showSecondaryLocalGrades"
                                    :localGradeLabel="localGradeLabel" :localScale="localScale"
                                    :permissions="permissions" :gpa="gpa" :fpGpa="fpGpa" :localGpa="localGpa"
                                    :fpLocalGpa="fpLocalGpa" :gradeType="gradeType" :courses="courses"
                                    :studentProgram="studentProgram" :editProgram="editProgram" :grades="grades"
                                    :student="student" :program1Type="program1Type" :program2Type="program2Type"
                                    :coursesArr="coursesArr" :courses2Arr="courses2Arr"
                                    :isPartnerSchoolUserWithAddGradePermission="isPartnerSchoolUserWithAddGradePermission
                                        " :descriptiveGrades="descriptiveGrades" :dateFormat="dateFormat"
                                    :courses2="courses2" :convertDate="convertDate"
                                    :selectedProgramCode="selectedProgramCode"
                                    :selectedProgram2Code="selectedProgram2Code" :changeCheck="changeCheck"
                                    :changeCreditCheck="changeCreditCheck" :userPartnerCode="userPartnerCode" />
                            </b-tab>

                            <b-tab :title="$t('form.student.tabGraduation')" class="position-relative">
                                <div class="graduated-overlay" v-if="studentProgram.Graduate"></div>
                                <div class="row">
                                    <div class="col-md-4">
                                        <h5>
                                            <u>
                                                <b>{{
                                                    $t(
                                                        "form.student.bachelorProgram"
                                                    )
                                                }}</b>
                                            </u>
                                        </h5>

                                        <br />

                                        <div class="pl-3">
                                            <div class="form-group mb-0">
                                                <div>
                                                    <label>
                                                        <input type="checkbox" name="BBAExitSurvey" :disabled="!permissions.editStudentsGraduationrequirements
                                                            " v-model="studentGraduateReq.BBAExitSurvey
                                                                " value="1" @change="
                                                                changeCheck(
                                                                    $event
                                                                );
                                                            " />
                                                        {{
                                                            $t(
                                                                "form.student.bachelorProgramOption1"
                                                            )
                                                        }}
                                                    </label>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <div class="checkbox">
                                                    <label>
                                                        <input value="1" @change="
                                                            changeCheck(
                                                                $event
                                                            )
                                                            " type="checkbox" name="BBAExitSurveyCBE" :disabled="!permissions.editStudentsGraduationrequirements
                                                                " v-model="studentGraduateReq.BBAExitSurveyCBE
                                                                " />
                                                        {{
                                                            $t(
                                                                "form.student.bachelorProgramOption2"
                                                            )
                                                        }}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <h5>
                                                <u>
                                                    <b>{{
                                                        $t(
                                                            "form.student.masterProgram"
                                                        )
                                                    }}</b>
                                                </u>
                                            </h5>
                                            <br />
                                            <div class="pl-3">
                                                <div class="checkbox">
                                                    <label>
                                                        <input value="1" @change="
                                                            changeCheck(
                                                                $event
                                                            )
                                                            " type="checkbox" name="MASExitSurvey" :disabled="!permissions.editStudentsGraduationrequirements
                                                                " v-model="studentGraduateReq.MASExitSurvey
                                                                " />
                                                        {{
                                                            $t(
                                                                "form.student.masterProgramOption1"
                                                            )
                                                        }}
                                                    </label>
                                                </div>

                                                <div class="form-group mb-0">
                                                    <div class="checkbox">
                                                        <label>
                                                            <input value="1" @change="
                                                                changeCheck(
                                                                    $event
                                                                )
                                                                " type="checkbox" name="MSCInternReport" :disabled="!permissions.editStudentsGraduationrequirements
                                                                    " v-model="studentGraduateReq.MSCInternReport
                                                                    " />
                                                            {{
                                                                $t(
                                                                    "form.student.masterProgramOption4"
                                                                )
                                                            }}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <h5>
                                                <u>
                                                    <b>{{
                                                        $t(
                                                            "form.student.continuingEducation"
                                                        )
                                                    }}</b>
                                                </u>
                                            </h5>
                                            <br />
                                            <div class="pl-3">
                                                <div class="checkbox">
                                                    <label>
                                                        <input value="1" @change="
                                                            changeCheck(
                                                                $event
                                                            )
                                                            " type="checkbox" name="DBAExitSurvey" :disabled="!permissions.editStudentsGraduationrequirements
                                                                " v-model="studentGraduateReq.CEExitSurvey
                                                                " />
                                                        {{
                                                            $t(
                                                                "form.student.doctorateProgramOption1"
                                                            )
                                                        }}
                                                    </label>
                                                </div>
                                                <div class="form-group mb-0">
                                                    <div class="checkbox">
                                                        <label>
                                                            <input value="1" @change="
                                                                changeCheck(
                                                                    $event
                                                                );
                                                            clearExamScore();
                                                            " type="checkbox" name="MASExitExamSBS" :disabled="!permissions.editStudentsGraduationrequirements
                                                                    " v-model="studentGraduateReq.MASExitExamSBS
                                                                    " />
                                                            {{
                                                                $t(
                                                                    "form.student.masterProgramOption2"
                                                                )
                                                            }}
                                                        </label>
                                                    </div>

                                                    <div class="form-group" v-if="
                                                        studentGraduateReq.MASExitExamSBS
                                                    ">
                                                        <div class>
                                                            <input type="text" class="form-control" :disabled="!permissions.editStudentsGraduationrequirements
                                                                " v-model="studentGraduateReq.MASExitExamSBSResult
                                                                    " :placeholder="$t(
                                                                    'form.student.programScore'
                                                                )
                                                                    " />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <h5>
                                                <u>
                                                    <b>{{
                                                        $t(
                                                            "form.student.doctorateProgram"
                                                        )
                                                    }}</b>
                                                </u>
                                            </h5>
                                            <br />
                                            <div class="pl-3">
                                                <div class="checkbox">
                                                    <label>
                                                        <input value="1" @change="
                                                            changeCheck(
                                                                $event
                                                            )
                                                            " type="checkbox" name="DBAExitSurvey" :disabled="!permissions.editStudentsGraduationrequirements
                                                                " v-model="studentGraduateReq.DBAExitSurvey
                                                                " />
                                                        {{
                                                            $t(
                                                                "form.student.doctorateProgramOption1"
                                                            )
                                                        }}
                                                    </label>
                                                </div>

                                                <div class="form-group mb-0">
                                                    <div class="checkbox">
                                                        <label>
                                                            <input value="1" @change="
                                                                changeCheck(
                                                                    $event
                                                                );
                                                            clearExamScore();
                                                            " type="checkbox" name="DBAExitExamSBS" :disabled="!permissions.editStudentsGraduationrequirements
                                                                    " v-model="studentGraduateReq.DBAExitExamSBS
                                                                    " />
                                                            {{
                                                                $t(
                                                                    "form.student.doctorateProgramOption2"
                                                                )
                                                            }}
                                                        </label>
                                                    </div>
                                                    <div class="form-group" v-if="
                                                        studentGraduateReq.DBAExitExamSBS
                                                    ">
                                                        <div class>
                                                            <input type="text" class="form-control" :disabled="!permissions.editStudentsGraduationrequirements
                                                                " v-model="studentGraduateReq.DBAExitExamSBSResult
                                                                    " :placeholder="$t(
                                                                    'form.student.programScore'
                                                                )
                                                                    " />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <h5>
                                                    <u>
                                                        <b>{{
                                                            $t(
                                                                "form.student.allPrograms"
                                                            )
                                                        }}</b>
                                                    </u>
                                                </h5>
                                                <br />

                                                <div class="pl-3">
                                                    <div class="checkbox">
                                                        <label>
                                                            <input value="1" @change="
                                                                changeCheck(
                                                                    $event
                                                                )
                                                                " :disabled="!permissions.editStudentsGraduationrequirements
                                                                    " type="checkbox" name="PassingGPA" v-model="studentGraduateReq.PassingGPA
                                                                    " />
                                                            {{
                                                                $t(
                                                                    "form.student.allProgramsOption1"
                                                                )
                                                            }}
                                                        </label>
                                                    </div>

                                                    <div class="form-group">
                                                        <div class="checkbox">
                                                            <label>
                                                                <input value="1" @change="
                                                                    changeCheck(
                                                                        $event
                                                                    )
                                                                    " :disabled="!permissions.editStudentsGraduationrequirements
                                                                        " type="checkbox" name="FinancialObligations"
                                                                    v-model="studentGraduateReq.FinancialObligations
                                                                        " />
                                                                {{
                                                                    $t(
                                                                        "form.student.allProgramsOption2"
                                                                    )
                                                                }}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-md-8" v-if="selectedProgramCode == 'DBA'">
                                        <h5>
                                            <u>
                                                <b>{{
                                                    $t("form.student.dba")
                                                    }}</b>
                                            </u>
                                        </h5>

                                        <br />

                                        <div class="pl-3">
                                            <div class="form-group row">
                                                <label class="col-md-4">{{
                                                    $t(
                                                        "form.student.ethicsApprovalDoc"
                                                    )
                                                }}</label>
                                                <input type="text" class="col-md-7 form-control" :disabled="!permissions.editStudentsGraduationrequirements
                                                    " v-model="studentGraduateReq.DBAEthicsApprovalDoc
                                                        " />
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-4">{{
                                                    $t(
                                                        "form.student.approvedDate"
                                                    )
                                                }}</label>
                                                <div class="col-md-7 p-0">
                                                    <date-picker :lang="lang" class="date-picker" :disabled="!permissions.editStudentsGraduationrequirements
                                                        " v-model="studentGraduateReq.DBAEApprovalDate
                                                            " valueType="format" :format="dateFormat" :popup-style="{
                                                            top: '100%',
                                                            left: 0
                                                        }" :append-to-body="false">
                                                    </date-picker>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-4">{{
                                                    $t(
                                                        "form.student.statisticsExamDate"
                                                    )
                                                }}</label>
                                                <div class="col-md-7 p-0">
                                                    <date-picker :lang="lang" class="date-picker" :disabled="!permissions.editStudentsGraduationrequirements
                                                        " v-model="studentGraduateReq.DBAStatsExamDate
                                                            " valueType="format" :format="dateFormat" :popup-style="{
                                                            top: '100%',
                                                            left: 0
                                                        }" :append-to-body="false">
                                                    </date-picker>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-4">{{
                                                    $t(
                                                        "form.student.statisticsExamResult"
                                                    )
                                                }}</label>
                                                <input type="text" class="col-md-7 form-control" :disabled="!permissions.editStudentsGraduationrequirements
                                                    " v-model="studentGraduateReq.DBAStatsExamResult
                                                        " />
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-4">{{
                                                    $t("form.student.compsDate")
                                                    }}</label>

                                                <div class="col-md-7 p-0">
                                                    <date-picker :lang="lang" class="date-picker" :disabled="!permissions.editStudentsGraduationrequirements
                                                        " v-model="studentGraduateReq.DBACompsDate
                                                            " valueType="format" :format="dateFormat" :popup-style="{
                                                            top: '100%',
                                                            left: 0
                                                        }" :append-to-body="false">
                                                    </date-picker>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-4">{{
                                                    $t(
                                                        "form.student.compsResult"
                                                    )
                                                }}</label>
                                                <input type="text" class="col-md-7 form-control" :disabled="!permissions.editStudentsGraduationrequirements
                                                    " v-model="studentGraduateReq.DBACompsResult
                                                        " />
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    <input type="checkbox" name="DBAMAIssued" :disabled="!permissions.editStudentsGraduationrequirements
                                                        " v-model="studentGraduateReq.DBAMAIssued
                                                            " @change="
                                                            changeCheck($event)
                                                            " />
                                                    {{
                                                        $t(
                                                            "form.student.mabrIssued"
                                                        )
                                                    }}
                                                </label>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-4">{{
                                                    $t("form.student.mabrDate")
                                                    }}</label>
                                                <div class="col-md-7 p-0">
                                                    <date-picker :lang="lang" class="date-picker" :disabled="!permissions.editStudentsGraduationrequirements
                                                        " v-model="studentGraduateReq.DBAMADate
                                                            " valueType="format" :format="dateFormat" :popup-style="{
                                                            top: '100%',
                                                            left: 0
                                                        }" :append-to-body="false">
                                                    </date-picker>
                                                </div>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-4">{{
                                                    $t(
                                                        "form.student.dissertation"
                                                    )
                                                }}</label>
                                                <input type="text" class="col-md-7 form-control" :disabled="!permissions.editStudentsGraduationrequirements
                                                    " v-model="studentGraduateReq.DBADissertation
                                                        " />
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-4">{{
                                                    $t(
                                                        "form.student.dissertationDate"
                                                    )
                                                }}</label>
                                                <div class="col-md-7 p-0">
                                                    <date-picker :lang="lang" class="date-picker" :disabled="!permissions.editStudentsGraduationrequirements
                                                        " v-model="studentGraduateReq.DBADODDate
                                                            " valueType="format" :format="dateFormat" :popup-style="{
                                                            top: '100%',
                                                            left: 0
                                                        }" :append-to-body="false">
                                                    </date-picker>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    <input value="1" @change="
                                                        changeCheck($event)
                                                        " type="checkbox" :disabled="!permissions.editStudentsGraduationrequirements
                                                            " name="DBADegreeIssued" v-model="studentGraduateReq.DBADegreeIssued
                                                            " />
                                                    {{
                                                        $t(
                                                            "form.student.degreeIssued"
                                                        )
                                                    }}
                                                </label>
                                            </div>

                                            <div class="form-group row">
                                                <label class="col-md-4">{{
                                                    $t(
                                                        "form.student.degreeIssueDate"
                                                    )
                                                }}</label>
                                                <div class="col-md-7 p-0">
                                                    <date-picker :lang="lang" class="date-picker" :disabled="!permissions.editStudentsGraduationrequirements
                                                        " v-model="studentGraduateReq.DBADegreeIssueDate
                                                            " valueType="format" :format="dateFormat" :popup-style="{
                                                            top: '100%',
                                                            left: 0
                                                        }" :append-to-body="false">
                                                    </date-picker>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab :title="$t('form.student.tabAttachment')">
                                <attachments :disabled="!permissions.editStudentsAttachments
                                    " :permissions="permissions" :readonly="readonlyattachments" :isLoading="isLoading" :isPartnerSchoolUser="isPartnerSchoolUser"
                                    :attachments="attachments" :downloadAttachment="downloadAttachment"
                                    :removeAttachment="removeAttachment" :attachmentUploaded="attachmentUploaded"
                                    :attachmentDropzone="attachmentDropzone" :uploadFileError="uploadFileError"
                                    :sendingEvent="sendingEvent" :getAttachmentFileName="getAttachmentFileName" />
                            </b-tab>

                            <b-tab :title="$t('form.student.tabAbsence')" v-if="showAbsencesTab">
                                <div class="row" v-if="!readonlyabsences">
                                    <div class="col-md-12">
                                        <button class="btn btn-primary float-right" :disabled="!permissions.editStudentsAbsences
                                            " @click.prevent="addAbsence">
                                            {{ $t("button.add") }}
                                        </button>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>
                                                {{
                                                    $t(
                                                        "form.student.absenceDate"
                                                    )
                                                }}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <date-picker :lang="lang" :disabled="!permissions.editStudentsAbsences
                                                " class="date-picker" v-model="studentAbsence.Date" valueType="format"
                                                :format="dateFormat" :popup-style="{
                                                    top: '100%',
                                                    left: 0
                                                }" :append-to-body="false">
                                            </date-picker>
                                            <div class="invalid-feedback custom-validate" v-if="invalidAbsenceDate">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>
                                                {{
                                                    $t(
                                                        "form.student.absenceReason"
                                                    )
                                                }}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <input :disabled="!permissions.editStudentsAbsences
                                                " type="text" v-model.trim="studentAbsence.Reason
                                                    " class="form-control" />
                                            <div class="invalid-feedback custom-validate" v-if="invalidAbsenceReason">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <label>
                                                {{
                                                    $t(
                                                        "form.student.absenceCourse"
                                                    )
                                                }}
                                                <span class="text-danger">*</span>
                                            </label>
                                            <v-select :disabled="!permissions.editStudentsAbsences
                                                " v-if="gradeType == 'pr'" v-model="absenceCourse" label="FullTitle"
                                                :options="grades" @input="addAbsenseCourse" :reduce="grades => grades">
                                            </v-select>
                                            <v-select :disabled="!permissions.editStudentsAbsences
                                                " v-if="gradeType == 'se'" v-model="absenceCourse" label="FullTitle"
                                                :options="secondaryGrades" @input="addAbsenseCourse" :reduce="secondaryGrades =>
                                                        secondaryGrades
                                                    ">
                                            </v-select>
                                            <div class="invalid-feedback custom-validate" v-if="invalidAbsenceCourse">
                                                {{
                                                    $t(
                                                        "form.validation.required"
                                                    )
                                                }}
                                            </div>
                                        </div>
                                        <div class="form-group" v-if="studentProgram.Program2ID">
                                            <label class="radio-inline">
                                                <input :disabled="!permissions.editStudentsAbsences
                                                    " type="radio" v-model="gradeType" value="pr" />
                                                {{
                                                    $t(
                                                        "form.student.primaryGrades"
                                                    )
                                                }} </label><br />
                                            <label class="radio-inline">
                                                <input :disabled="!permissions.editStudentsAbsences
                                                    " type="radio" v-model="gradeType" value="se" />
                                                {{
                                                    $t(
                                                        "form.student.secondaryGrades"
                                                    )
                                                }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="Notes:">{{
                                                $t(
                                                    "form.student.absenceRemarks"
                                                )
                                            }}</label>
                                            <div class="controls">
                                                <textarea :disabled="!permissions.editStudentsAbsences
                                                    " id="Notes:" name="Notes" v-model="studentAbsence.Remarks
                                                        " rows="8" class="form-control" data-role="textarea"
                                                    data-parsley-errors-container="#errId39"></textarea>
                                                <span id="errId39" class="error"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row" v-if="studentAbsences.length > 0">
                                    <div class="col-md-12">
                                        <div class="table-responsive p-0">
                                            <table class="table table-bordered">
                                                <tr>
                                                    <th>
                                                        {{
                                                            $t(
                                                                "form.student.absenceDate"
                                                            )
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            $t(
                                                                "form.student.absenceReason"
                                                            )
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            $t(
                                                                "form.student.absenceCourse"
                                                            )
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            $t(
                                                                "form.student.absenceRemarks"
                                                            )
                                                        }}
                                                    </th>
                                                    <th class="text-right" v-if="
                                                        !readonly ||
                                                        !readonlyabsences
                                                    ">
                                                        {{
                                                            $t(
                                                                "form.student.action"
                                                            )
                                                        }}
                                                    </th>
                                                </tr>
                                                <tbody>
                                                    <tr v-for="(StudentAbsence,
                                                        index) in studentAbsences" v-bind:key="index">
                                                        <td>
                                                            {{
                                                                StudentAbsence.Date
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                StudentAbsence.Reason
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                StudentAbsence
                                                                    .course
                                                                    .CourseTitle
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                StudentAbsence.Remarks
                                                            }}
                                                        </td>
                                                        <td class="text-right" v-if="
                                                            !readonly ||
                                                            !readonlyabsences
                                                        ">
                                                            <button :disabled="!permissions.editStudentsAbsences
                                                                " class="btn btn-danger btn-sm" @click.prevent="
                                                                    removeAbsence(
                                                                        index
                                                                    )
                                                                    ">
                                                                <i class="fas fa-trash"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>

                            <b-tab v-if="showApplicationTab" :title="$t('form.student.tabApplication')">
                                <StudentApplication :studentApplication="studentApplication" :studentApplicationNewData="studentApplicationNewData
                                    " :studentProgram="studentProgram" :selectedProgramCode="selectedProgramCode"
                                    :applicationDropzone="applicationDropzone" :readonly="readonly"
                                    :cvUploaded="cvUploaded" :degreeUploaded="degreeUploaded"
                                    :transcriptUploaded="transcriptUploaded" :passportUploaded="passportUploaded"
                                    :permitUploaded="permitUploaded" :englishProficiencyUploaded="englishProficiencyUploaded
                                        " :letterUploaded="letterUploaded" :pictureUploaded="pictureUploaded"
                                    :outlineUploaded="outlineUploaded" :associateDegreeUploaded="associateDegreeUploaded
                                        " :additionalDocumentsUploaded="additionalDocumentsUploaded
                                        " :applicationDropzoneAdditionalDocument="applicationDropzoneAdditionalDocument
                                        " :downloadApplication="downloadApplication" :removeNewApplicationFile="removeNewApplicationFile
                                        " :removeApplicationFile="removeApplicationFile
                                        " :downloadZipApplication="downloadZipApplication
                                        " :uploadFileError="uploadFileError" :sendingEvent="sendingEvent"
                                    :getFileName="getFileName" />
                            </b-tab>

                            <b-tab :title="$t('form.student.tabFinance')" v-if="showFinanceTab" ref="financeTab">
                                <div class="mb-3 row">
                                    <div class="form-group col-md-3">
                                        <label>{{
                                            $t("form.student.globalDiscount")
                                            }}</label>
                                        <input type="text" class="form-control"
                                            v-model.trim="$v.studentFinance.GlobalDiscount.$model"
                                            :class="{ 'is-invalid': $v.studentFinance.GlobalDiscount.$error }"
                                            v-on:blur="autoSave('GlobalDiscount', studentFinance.GlobalDiscount)" />
                                        <div class="invalid-feedback" v-if="
                                            !$v.studentFinance
                                                .GlobalDiscount.maxLength
                                        ">
                                            {{
                                                $t(
                                                    "form.validation.maxLength",
                                                    {
                                                        num:
                                                            $v.studentFinance
                                                                .GlobalDiscount
                                                                .$params
                                                                .maxLength.max
                                                    }
                                                )
                                            }}
                                        </div>
                                        <div class="invalid-feedback" v-if="
                                            !$v.studentFinance
                                                .GlobalDiscount.decimal
                                        ">
                                            {{
                                                $t(
                                                    "form.validation.numbersAllowed"
                                                )
                                            }}
                                        </div>
                                        <div class="invalid-feedback" v-if="
                                            !$v.studentFinance
                                                .GlobalDiscount.between
                                        ">
                                            {{
                                                $t("form.validation.between", {
                                                    num1:
                                                        $v.studentFinance
                                                            .GlobalDiscount
                                                            .$params.between
                                                            .min,
                                                    num2:
                                                        $v.studentFinance
                                                            .GlobalDiscount
                                                            .$params.between.max
                                                })
                                            }}
                                        </div>
                                    </div>
                                    <div class="form-group col-md-3" v-if="permissions.viewSettingsReductiontypes">
                                        <label>{{
                                            $t("form.student.reduction_type")
                                            }}</label>
                                        <select class="form-control" v-model="student_reduction"
                                            v-on:change="autoSave('student_reduction', student_reduction)">
                                            <option value="">{{
                                                $t("form.student.select")
                                                }}</option>
                                            <option v-for="(type,
                                                index) in reduction_types" :value="type.name" :key="index">
                                                {{
                                                    type.name | capitalize
                                                }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label>{{
                                            $t("form.student.FullPaymentDiscount")
                                            }}</label>
                                        <input type="text" class="form-control"
                                            v-model.trim="$v.studentFinance.FullPaymentDiscount.$model"
                                            :class="{ 'is-invalid': $v.studentFinance.FullPaymentDiscount.$error }"
                                            v-on:blur="autoSave('FullPaymentDiscount', studentFinance.FullPaymentDiscount)" />
                                        <div class="invalid-feedback" v-if="
                                            !$v.studentFinance
                                                .FullPaymentDiscount
                                                .maxLength
                                        ">
                                            {{
                                                $t(
                                                    "form.validation.maxLength",
                                                    {
                                                        num:
                                                            $v.studentFinance
                                                                .FullPaymentDiscount
                                                                .$params
                                                                .maxLength.max
                                                    }
                                                )
                                            }}
                                        </div>
                                        <div class="invalid-feedback" v-if="
                                            !$v.studentFinance
                                                .FullPaymentDiscount.decimal
                                        ">
                                            {{
                                                $t(
                                                    "form.validation.numbersAllowed"
                                                )
                                            }}
                                        </div>
                                        <div class="invalid-feedback" v-if="
                                            !$v.studentFinance
                                                .FullPaymentDiscount.between
                                        ">
                                            {{
                                                $t("form.validation.between", {
                                                    num1:
                                                        $v.studentFinance
                                                            .FullPaymentDiscount
                                                            .$params.between
                                                            .min,
                                                    num2:
                                                        $v.studentFinance
                                                            .FullPaymentDiscount
                                                            .$params.between.max
                                                })
                                            }}
                                        </div>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <label>{{
                                            $t("form.student.paymentPlan")
                                            }}</label>
                                        <select class="form-control" v-model="student.PaymentPlan"
                                            v-on:change="autoSave('PaymentPlan', student.PaymentPlan)">
                                            <option value="">{{
                                                $t("form.student.select")
                                                }}</option>
                                            <option v-for="(plan,
                                                index) in paymentPlans" :value="plan" :key="index">
                                                {{ plan | capitalize }}</option>
                                        </select>
                                    </div>
                                </div>

                                <hr />

                                <div class="d-flex justify-content-between">
                                    <h4>{{ $t("form.invoice.invoices") }}</h4>
                                    <div class="d-flex mb-3">
                                        <div class="mr-2">
                                            <select class="form-control" v-model="invoiceType"
                                                @change="getStudentInvoices()">
                                                <option value="">{{
                                                    $t("form.student.all")
                                                    }}</option>
                                                <option value="1">{{
                                                    $t(
                                                        "form.invoice.status_pending"
                                                    )
                                                }}</option>
                                                <option value="2">{{
                                                    $t(
                                                        "form.invoice.status_approved"
                                                    )
                                                }}</option>
                                                <option value="3">{{
                                                    $t(
                                                        "form.invoice.status_sent"
                                                    )
                                                }}</option>
                                                <option value="4">{{
                                                    $t(
                                                        "form.invoice.status_paid"
                                                    )
                                                }}</option>
                                                <option value="5">{{
                                                    $t(
                                                        "form.invoice.status_delivery_failed"
                                                    )
                                                }}</option>
                                                <option value="6">{{
                                                    $t(
                                                        "form.invoice.status_course_date_pending"
                                                    )
                                                }}</option>

                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div class="table-responsive">
                                    <table class="table table-hover table-bordered" v-if="studentInvoices.length">
                                        <thead>
                                            <tr>
                                                <th>
                                                    {{
                                                        $t(
                                                            "form.invoice.number"
                                                        )
                                                    }}
                                                </th>
                                                <th>
                                                    {{
                                                        $t("form.invoice.date")
                                                    }}
                                                </th>
                                                <th>
                                                    {{
                                                        $t(
                                                            "form.invoice.amount"
                                                        )
                                                    }}
                                                </th>
                                                <th>
                                                    {{
                                                        $t(
                                                            "form.invoice.invoicePurpose"
                                                        )
                                                    }}
                                                </th>
                                                <template v-if="student.PaymentPlan">
                                                    <th>
                                                        {{
                                                            $t(
                                                                "form.invoice.payment"
                                                            )
                                                        }}
                                                    </th>
                                                    <th>
                                                        {{
                                                            $t(
                                                                "form.invoice.installment"
                                                            )
                                                        }}
                                                    </th>
                                                </template>
                                                <th>
                                                    {{
                                                        $t(
                                                            "form.invoice.status"
                                                        )
                                                    }}
                                                </th>
                                                <th class="text-right">
                                                    {{
                                                        $t(
                                                            "form.invoice.action"
                                                        )
                                                    }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="(invoice,
                                            index) in studentInvoices" v-bind:key="index">
                                            <tr @dblclick="goToEdit(invoice.ID)">
                                                <td>
                                                    {{ invoice.InvoiceNumber }}
                                                </td>
                                                <td>
                                                    {{
                                                        invoice.InvoiceDate
                                                        | formatDate(
                                                            dateFormat
                                                        )
                                                    }}
                                                </td>
                                                <td>
                                                    <template
                                                        v-if="invoice.AmountAfterDeductibles == 0 && invoice.PaymentPlan == 'by Course/Semester/Term'">
                                                        {{ invoice.Currency }}
                                                        0
                                                    </template>
                                                    <template
                                                        v-else-if="invoice.Discount > 0 && invoice.InvoicedSeparately > 0 && invoice.PaymentPlan != 'Full Payment'">
                                                        {{ invoice.Currency }}
                                                        {{ invoice.Amount | curreny(decimalDigits, decimalPoint,
                                                        thousandSeparator) }}
                                                    </template>
                                                    <template
                                                        v-else-if="invoice.IsSeparately == 1 && invoice.PaymentPlan == 'Full Payment'">
                                                        {{ invoice.Currency }}
                                                        {{ invoice.Amount | curreny(decimalDigits, decimalPoint,
                                                        thousandSeparator) }}
                                                    </template>
                                                    <template
                                                        v-else-if="invoice.Version === 'V2' && !invoice.acceptanceFee">
                                                        {{ invoice.Currency }}
                                                        {{ invoice.Total | curreny(decimalDigits, decimalPoint,
                                                        thousandSeparator) }}
                                                        {{ invoice.Discount > 0 ? `(${invoice.Discount}%
                                                        ${$t("form.invoice.discount")})`: null}}
                                                    </template>
                                                    <template
                                                        v-else-if="invoice.PaymentPlan == 'Full Payment' && invoice.acceptanceFee && invoice.FullPaymentDiscountedAmount || invoice.AmountAfterDeductibles">
                                                        {{ invoice.Currency }}
                                                        {{ (invoice.FullPaymentDiscountedAmount ||
                                                            invoice.AmountAfterDeductibles) | curreny(decimalDigits,
                                                        decimalPoint,thousandSeparator)}}
                                                        {{ student.GlobalDiscount > 0 ? `(${student.GlobalDiscount}%
                                                        ${$t("form.invoice.discount")})`: null }}
                                                    </template>
                                                    <template
                                                        v-else-if="Number(invoice.Discount) > 0 && invoice.PaymentPlan != 'Full Payment' && !invoice.acceptanceFee">
                                                        {{ invoice.Currency }}
                                                        {{ invoice.DiscountedAmount | curreny(decimalDigits,
                                                        decimalPoint, thousandSeparator)}}
                                                        ({{ invoice.Discount }}%
                                                        {{ $t("form.invoice.discount") }})
                                                    </template>
                                                    <template v-else>
                                                        {{ invoice.Currency }}
                                                        {{ invoice.Amount | curreny(decimalDigits, decimalPoint,
                                                        thousandSeparator) }}
                                                    </template>
                                                </td>
                                                <td>
                                                    {{ invoice.InvoicePurpose }}
                                                </td>
                                                <template v-if="student.PaymentPlan">
                                                    <td>
                                                        {{ invoice.PaymentPlan | capitalize }}
                                                    </td>
                                                    <td>
                                                        {{ invoice.Installment }}
                                                    </td>
                                                </template>
                                                <td v-if="invoice.Status == 1">
                                                    {{ $t("form.invoice.status_pending") }}
                                                </td>
                                                <td v-else-if="
                                                    invoice.Status == 2
                                                ">
                                                    {{
                                                        $t(
                                                            "form.invoice.status_approved"
                                                        )
                                                    }}
                                                </td>
                                                <td v-else-if="
                                                    invoice.Status == 3
                                                ">
                                                    {{
                                                        $t(
                                                            "form.invoice.status_sent"
                                                        )
                                                    }}
                                                </td>
                                                <td v-else-if="
                                                    invoice.Status == 4
                                                ">
                                                    {{
                                                        $t(
                                                            "form.invoice.status_paid"
                                                        )
                                                    }}
                                                </td>
                                                <td v-else-if="
                                                    invoice.Status == 5
                                                ">
                                                    {{
                                                        $t(
                                                            "form.invoice.status_delivery_failed"
                                                        )
                                                    }}
                                                </td>
                                                <td v-else-if="
                                                    invoice.Status == 6
                                                ">
                                                    {{
                                                        $t(
                                                            "form.invoice.course_date_pending"
                                                        )
                                                    }}
                                                </td>
                                                <td v-else-if="
                                                    invoice.Status ==
                                                    null ||
                                                    invoice.Status ==
                                                    undefined ||
                                                    invoice.Status == 0
                                                "></td>

                                                <td class="text-right">
                                                    <button v-if="
                                                        permissions.viewInvoices
                                                    " @click="
                                                            goToShow(invoice.ID, invoice.Version)
                                                            " class="btn btn-dark btn-sm">
                                                        <i class="fa fa-print"></i>
                                                    </button>
                                                    <button v-if="
                                                        permissions.editInvoicesStudents
                                                    " @click="
                                                            goToEdit(invoice.ID)
                                                            " class="btn btn-info btn-sm">
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                    <button class="btn btn-danger btn btn-sm"
                                                        v-on:click="deleteInvoice(invoice)"
                                                        v-show="permissions.deleteInvoicesStudents">
                                                        <span class="fa fa-trash"></span>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-else>{{ $t("noRecord") }}</p>
                                </div>

                                <b-button @click="newInvoice" v-if="permissions.createInvoicesStudents">
                                    {{ $t("button.newInvoice") }}</b-button>
                                <b-button @click="createPaymentPlanFPInvoices" v-if="permissions.createInvoicesStudents && studentProgram.FoundationID && this.student.PaymentPlan != null">
                                    {{ $t("button.createPaymentPlanFPInvoices") }}</b-button>
                                <b-button @click="createpaymentplanInvoices" v-if="
                                    permissions.createInvoicesStudents &&
                                    this.student.PaymentPlan != null
                                ">
                                    {{
                                        $t("button.createpaymentplanInvoices")
                                    }}</b-button>
                                <b-button @click="createPaymentPlanInvoicesForSecondary" v-if="
                                    permissions.createInvoicesStudents &&
                                    this.student.PaymentPlan != null && studentProgram.Program2ID
                                ">
                                    {{
                                        $t("button.createPaymentPlanInvoicesForSecondary")
                                    }}</b-button>
                                <b-button @click="exportInvoices" v-if="studentInvoices.length">
                                    {{ $t("button.exportPDF") }}</b-button>

                                <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="5"
                                    @paginate="paginate('invoice')">
                                </pagination>
                            </b-tab>

                            <b-tab :title="$t('form.student.tabPaymentSummaries')" v-if="showPaymentSummaryTab" ref="summaryTab">
                                <h3 class="mb-3">{{ $t("form.student.paymentSummaries") }}</h3>
                                <div class="table-responsive">
                                    <table class="table table-hover table-bordered" v-if="paymentSummaries.length">
                                        <thead>
                                            <tr>
                                                <th>
                                                    {{ $t("form.student.summaryNumber") }}
                                                </th>
                                                <th>
                                                    {{ $t("form.student.status") }}
                                                </th>
                                                <th>
                                                    {{ $t("form.student.date") }}
                                                </th>
                                                <th class="text-right">
                                                    {{ $t("form.student.totalAmount") }}
                                                </th>
                                                <th class="text-right">
                                                    {{ $t("form.student.action") }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr @dblclick="goToEditSummary(sps.id)" v-for="sps in paymentSummaries" :key="sps.id">
                                                <td>
                                                    {{ sps.reference_number }}
                                                </td>
                                                <td>
                                                    {{ sps.status }}
                                                </td>
                                                <td>
                                                    {{ sps.summary_date | formatDate(dateFormat) }}
                                                </td>
                                                <td class="text-right">
                                                    {{ sps.currency }} {{ sps.total_amount | curreny(decimalDigits, decimalPoint, thousandSeparator) }}
                                                </td>
                                                
                                                <td class="text-right">
                                                    <button @click="goToShowSummary(sps.id)" class="btn btn-dark btn-sm">
                                                        <i class="fa fa-print"></i>
                                                    </button>
                                                    <button @click="goToEditSummary(sps.id)" class="btn btn-info btn-sm">
                                                        <i class="fa fa-edit"></i>
                                                    </button>
                                                    <button @click="deleteSummary(sps)" class="btn btn-danger btn-sm">
                                                    <i class="fa fa-trash"></i>
                                                    </button>
                                                   
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p v-else>{{ $t("noRecord") }}</p>
                                </div>

                                <b-button class="mb-3" @click="$refs.paymentSummaryModal.show()">{{ $t("form.student.createPaymentSummary") }}</b-button>

                                <b-modal
                                    ref="paymentSummaryModal"
                                    size="xl"
                                    hide-footer
                                    scrollable
                                    :title="$t('form.student.createPaymentSummary')"
                                >
                                    <div class="mb-3 row">
                                        <div class="form-group col-md-4">
                                            <label>{{ $t("form.student.dateFrom") }}</label>
                                            <date-picker
                                                class="date-picker"
                                                :lang="lang"
                                                v-model="studentPaymentSummary.DateFrom"
                                                valueType="format"
                                                :format="dateFormat"
                                                :popup-style="{ top: '100%', left: 0 }"
                                                :append-to-body="false"
                                            >
                                            </date-picker>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label>{{ $t("form.student.dateTo") }}</label>
                                            <date-picker
                                                class="date-picker"
                                                :lang="lang"
                                                v-model="studentPaymentSummary.DateTo"
                                                valueType="format"
                                                :format="dateFormat"
                                                :popup-style="{ top: '100%', left: 0 }"
                                                :append-to-body="false"
                                            >
                                            </date-picker>
                                        </div>

                                        <div class="form-group col-md-4 align-self-end">
                                            <b-button @click="getPaymentData">
                                        {{ $t("button.getPaymentData") }}</b-button>
                                        </div>
                                    </div>

                                    <div class="row mb-3">
                                        <div class="form-group col-md-12">
                                            <label>{{ $t("form.student.summaryDate") }}</label>
                                            <date-picker
                                                class="date-picker"
                                                :lang="lang"
                                                v-model="studentPaymentSummary.SummaryDate"
                                                valueType="format"
                                                :format="dateFormat"
                                                :popup-style="{ top: '100%', left: 0 }"
                                                :append-to-body="false"
                                            >
                                            </date-picker>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label>{{$t('form.student.currency')}}</label>
                                            <v-select :options="currencies" v-model="studentPaymentSummary.Currency"
                                                :reduce="currencies => currencies" :key="studentPaymentSummary.Currency">
                                            </v-select>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label>{{ $t("form.student.titleText") }}</label>
                                            <input type="text" v-model="studentPaymentSummary.TitleText" class="form-control" />
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label>{{ $t("form.student.introText") }}</label>
                                            <input type="text" v-model="studentPaymentSummary.IntroText" class="form-control" />
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label>{{ $t("form.student.closingText") }}</label>
                                            <input type="text" v-model="studentPaymentSummary.ClosingText" class="form-control" />
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label class="checkbox" :disabled="studentPaymentSummary.CustomGrouping">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="studentPaymentSummary.GroupByYear" 
                                                    @change="handleGroupByYearChange"
                                                />
                                                {{ $t("form.student.groupByYear") }}
                                            </label>
                                            <label class="checkbox" :disabled="studentPaymentSummary.GroupByYear">
                                                <input 
                                                    type="checkbox" 
                                                    v-model="studentPaymentSummary.CustomGrouping" 
                                                    @change="handleCustomGroupingChange"
                                                />
                                                {{ $t("form.student.customGrouping") }}
                                            </label>
                                        </div>
                                        <div class="form-group col-md-12">
                                            <label>{{ $t("form.student.grandTotalLabel") }}</label>
                                            <input type="text" v-model="studentPaymentSummary.GrandTotalLabel" class="form-control" 
                                                :placeholder="$t('form.student.totalFeesPaidToDate')" />
                                        </div>
                                    </div>

                                    <div class="row mb-3" v-if="paymentSummaryItems.length">
                                        <div class="form-group col-md-12">
                                            <div class="table-responsive">
                                                <table class="table table-hover table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 40px;">
                                                                {{ $t("form.student.drag") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("form.student.amountReceived") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("form.student.invoiceNumber") }}
                                                            </th>
                                                            <th>
                                                                {{ $t("form.student.dateFeesReceived") }}
                                                            </th>
                                                            <th v-if="studentPaymentSummary.GroupByYear">{{ $t("form.student.year") }}</th>
                                                            <th v-if="studentPaymentSummary.CustomGrouping">{{ $t("form.student.groupNumber") }}</th>
                                                            <th class="text-center" style="width: 100px;">
                                                                {{ $t("form.student.sort_order") }}
                                                            </th>
                                                            <th class="text-right">
                                                                {{ $t("form.student.action") }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="(row, idx) in paymentSummaryItems">
                                                            <!-- Group Separator -->
                                                            <tr v-if="idx === 0 || getGroupKey(row) !== getGroupKey(paymentSummaryItems[idx-1])" class="table-secondary">
                                                                <td v-if="studentPaymentSummary.GroupByYear || studentPaymentSummary.CustomGrouping" colspan="100" class="py-1 text-center text-muted">
                                                                    <strong>Group: {{ getGroupKey(row) === 'no_year' ? 'No Year' : getGroupKey(row) }}</strong>
                                                                </td>
                                                            </tr>
                                                            <tr :key="row.id || row.invoice_number || idx" class="draggable-row" :draggable="true" @dragstart="onDragStart($event, row)" @dragover="onDragOver" @drop="onDrop($event, row)">
                                                                <td class="text-center align-middle" style="cursor: grab;">⋮⋮</td>
                                                                <td>
                                                                    <input type="number" step="0.01" v-model.number="row.amount_received" class="form-control" />
                                                                </td>
                                                                <td>
                                                                    <input type="text" v-model="row.invoice_number" class="form-control" />
                                                                </td>
                                                                <td>
                                                                    <date-picker
                                                                        class="date-picker"
                                                                        :lang="lang"
                                                                        v-model="row.payment_date"
                                                                        valueType="format"
                                                                        :format="dateFormat"
                                                                        :popup-style="{ top: '100%', left: 0 }"
                                                                        :append-to-body="false"
                                                                        @input="autoPopulateYear(row, idx)"
                                                                    >
                                                                    </date-picker>
                                                                </td>
                                                                <td v-if="studentPaymentSummary.GroupByYear">
                                                                    <input 
                                                                        type="text" 
                                                                        v-model="row.year" 
                                                                        maxlength="4" 
                                                                        class="form-control" 
                                                                        :placeholder="$t('form.student.year')"
                                                                        @blur="sortPaymentSummaryItemsByYear"
                                                                    />
                                                                </td>
                                                                <td v-if="studentPaymentSummary.CustomGrouping">
                                                                    <input 
                                                                        type="number" 
                                                                        v-model.number="row.group_number" 
                                                                        min="1"
                                                                        class="form-control" 
                                                                        :placeholder="$t('form.student.groupNumber')"
                                                                        @blur="sortPaymentSummaryItemsByGroup"
                                                                    />
                                                                </td>
                                                                <td class="text-center align-middle">
                                                                    <div class="d-flex align-items-center justify-content-center">
                                                                        <button class="btn btn-sm btn-outline-secondary" :disabled="getGroupItems(row).indexOf(row) === 0" @click="moveRowUp(row)">↑</button>
                                                                        <span class="mx-1">{{ row.sort_order || 1 }}</span>
                                                                        <button class="btn btn-sm btn-outline-secondary" :disabled="getGroupItems(row).indexOf(row) === getGroupItems(row).length - 1" @click="moveRowDown(row)">↓</button>
                                                                    </div>
                                                                </td>
                                                                
                                                                <td class="text-right">
                                                                    <button class="btn btn-danger btn btn-sm" @click="removeRow(idx)">
                                                                    <span class="fa fa-trash"></span>
                                                                    </button>
                                                                
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                    <tfoot>
                                                        <tr>
                                                            <td colspan="5">
                                                                <strong>{{ $t("form.student.totalPaymentReceived") }} {{ paymentSummaryCurrency }} {{ paymentSummaryTotalAmountFormatted | curreny(decimalDigits, decimalPoint, thousandSeparator) }}</strong>
                                                            </td>
                                                            <td v-if="studentPaymentSummary.GroupByYear"></td>
                                                            <td v-if="studentPaymentSummary.CustomGrouping"></td>
                                                            <td class="text-right">
                                                                <button class="btn btn-primary" @click="savePaymentSummary">{{ $t("form.student.savePaymentSummary") }}</button>
                                                                <button class="btn btn-success" @click="addRow">
                                                                    <span class="fa fa-plus"></span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                            <div class="row mb-3 mt-3" v-if="studentPaymentSummary.GroupByYear && paymentSummaryItems.length">
                                                <div class="form-group col-md-12">
                                                    <h5>{{ $t("form.student.subtotalLabels") }}</h5>
                                                    <div v-for="year in getUniqueYears()" :key="year" class="mb-3">
                                                        <label>
                                                            {{ $t("form.student.subtotalText") }} 
                                                            <span v-if="year === 'noYear'">{{ $t('form.student.noYear') }}</span>
                                                            <span v-else>{{ year }}</span>
                                                        </label>
                                                        <input 
                                                            type="text" 
                                                            v-model="subtotalLabelsInput[year]" 
                                                            class="form-control" 
                                                            :placeholder="getSubtotalPlaceholder(year, 'year')" 
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row mb-3 mt-3" v-if="studentPaymentSummary.CustomGrouping && paymentSummaryItems.length">
                                                <div class="form-group col-md-12">
                                                    <h5>{{ $t("form.student.subtotalLabels") }}</h5>
                                                    <div v-for="group in getUniqueGroups()" :key="group" class="mb-3">
                                                        <label>
                                                            {{ $t("form.student.subtotalText") }} 
                                                            <span v-if="group === 'unspecified'">{{ $t('form.student.unspecifiedGroup') }}</span>
                                                            <span v-else>{{ $t('form.student.group') }} {{ group }}</span>
                                                        </label>
                                                        <input 
                                                            type="text" 
                                                            v-model="subtotalLabelsInput[group]" 
                                                            class="form-control" 
                                                            :placeholder="getSubtotalPlaceholder(group, 'group')" 
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-modal>
                            </b-tab>

                            <b-tab :title="$t('form.student.tabTranscript')" v-if="showTranscriptTab">
                                <transcript :dateFormat="dateFormat" v-if="grades.length" :id="student.ID"
                                    :program_code="selectedProgramCode" :localGradeLabel="localGradeLabel"
                                    :gradingScales="gradingScales" :showLocalGrades="showLocalGrades"
                                    :studentProgram="studentProgram"
                                    :showSecondaryLocalGrades="showSecondaryLocalGrades"></transcript>
                                <p v-else>
                                    {{ $t("form.student.noTranscript") }}
                                </p>
                            </b-tab>

                            <b-tab :title="$t('form.student.tabAudits')" v-if="showAuditTab">
                                <div class="card-body table-responsive p-0">
                                    <p class="p-3 m-0 text-center" v-if="loadingAudits">
                                        <svg viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" width="64"
                                            height="64" stroke="#000">
                                            <g fill="none" fill-rule="evenodd">
                                                <g transform="translate(1 1)" stroke-width="2">
                                                    <circle stroke-opacity=".25" cx="18" cy="18" r="18"></circle>
                                                    <path d="M36 18c0-9.94-8.06-18-18-18">
                                                        <animateTransform attributeName="transform" type="rotate"
                                                            from="0 18 18" to="360 18 18" dur="0.8s"
                                                            repeatCount="indefinite"></animateTransform>
                                                    </path>
                                                </g>
                                            </g>
                                        </svg>
                                        Loading audit log records...
                                    </p>
                                    <table class="table table-hover" v-else-if="audits.length">
                                        <thead>
                                            <tr>
                                                <th>Field</th>
                                                <th>Old Value</th>
                                                <th>New Value</th>
                                                <th>User Name</th>
                                                <th>Timestamp</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(audit, index) in audits" :key="index">
                                                <td>{{ audit.field }}</td>
                                                <td>
                                                    <div v-if="Array.isArray(audit.old_value)">
                                                        <div v-for="(oldValue, index) in audit.old_value" :key="index">
                                                            <p v-if="oldValue.path">{{ oldValue.path }} - {{
                                                                oldValue.timestamp }}</p>
                                                            <p v-else>{{ oldValue | replaceString(['false', '"null"',
                                                                undefined], '') }}</p>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <p>{{ audit.old_value | replaceString(['false', '"null"',
                                                            undefined], '') }}</p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div v-if="Array.isArray(audit.new_value)">
                                                        <div v-for="(newValue, index) in audit.new_value" :key="index">
                                                            <p v-if="newValue.path">{{ newValue.path }} - {{
                                                                newValue.timestamp }}</p>
                                                            <p v-else>{{ newValue | replaceString(['false', '"null"',
                                                                undefined], '') }}</p>
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <p>{{ audit.new_value | replaceString(['false', '"null"',
                                                            undefined], '') }}</p>
                                                    </div>
                                                </td>
                                                <td>{{ audit.user.name }}</td>
                                                <td>{{ audit.created_at | formatDate(datetimeFormat) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <p class="p-3 m-0" v-else-if="audits.length === 0 && !loadingAudits">No audit log
                                        records found.</p>
                                </div>
                                <pagination v-if="pagination_audit.last_page > 1" :pagination="pagination_audit"
                                    :offset="5" @paginate="paginateAudit"></pagination>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>

                <!-- Available Models -->
                <b-modal id="addProfessorModal" :title="$t('form.student.addProfessor')" @show="resetModal"
                    @hidden="resetModal" @ok="handleOk">
                    <form ref="form" @submit.stop.prevent="handleSubmit">
                        <b-form-group :label="$t('form.employee.title')" :state="titleState"
                            :invalid-feedback="$t('form.validation.required')">
                            <b-form-select v-model="title" :state="titleState" :options="titles" required>
                            </b-form-select>
                        </b-form-group>

                        <b-form-group :label="$t('form.employee.firstName')" :state="firstNameState"
                            :invalid-feedback="$t('form.validation.required')">
                            <b-form-input v-model="firstName" :state="firstNameState" required>
                            </b-form-input>
                        </b-form-group>

                        <b-form-group :label="$t('form.employee.lastName')" :state="lastNameState"
                            :invalid-feedback="$t('form.validation.required')">
                            <b-form-input v-model="lastName" :state="lastNameState" required>
                            </b-form-input>
                        </b-form-group>
                    </form>

                    <template v-slot:modal-footer="{ ok, cancel }">
                        <!-- Emulate built in modal footer ok and cancel button actions -->
                        <b-button variant="primary" @click="ok()">
                            {{ $t("button.professor") }}
                        </b-button>
                        <b-button variant="default" @click="cancel()">
                            {{ $t("button.cancel") }}
                        </b-button>
                    </template>
                </b-modal>
                <b-modal id="uncheck-withdraw-modal" title="Update Status" hide-footer>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="StatusID:">{{
                                $t("form.student.status")
                                }}</label>
                            <v-select label="StatusName" @input="onChangeStatusModal" :options="statusList"
                                v-model="status" :reduce="statusList => statusList">
                            </v-select>
                        </div>
                        <div class="form-group col-12" v-if="statusCreateModeModal">
                            <label for="StudentStatusComment:">{{
                                $t("form.student.studentStatusComment")
                                }}</label>
                            <input type="text" name="StudentStatusComment" v-model="status.StatusComment"
                                class="form-control" />
                        </div>
                        <div class="form-group col-12" v-if="statusCreateModeModal">
                            <label for="StudentStatusDate:">{{
                                $t("form.student.studentStatusDate")
                                }}</label>

                            <date-picker :lang="lang" class="date-picker" name="StudentStatusDate" v-model="statusDate"
                                valueType="format" :format="dateFormat" :popup-style="{ top: '100%', left: 0 }"
                                :append-to-body="false">
                            </date-picker>
                        </div>
                        <div class="col-12" v-if="statusCreateModeModal">
                            <button type="button" @click="addModalStatus(shouldClose)" class="btn btn-primary btn-block"
                                name="modalupdate" :disabled="!status.StatusID || readonly">
                                {{ $t("button.updateStatus") }}
                            </button>
                        </div>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import Transcript from "../../components/Transcript";
import Summernote from "../../components/Summernote";
import StudentApplication from "./components/StudentApplication";
import Attachments from "./components/Attachments";
import Personal from "./components/Personal";
import Grades from "./components/Grades";
import GradingScaleResolver from "../../services/GradingScaleResolver";

/**
 * Vuelidate items
 */
import {
    required,
    minLength,
    maxLength,
    between,
    alpha,
    numeric,
    decimal,
    email
} from "vuelidate/lib/validators";
import { inArray } from "jquery";

export default {
    props: [
        "permissions",
        "editFormInterval",
        "dateFormat",
        "datetimeFormat",
        "decimalDigits",
        "decimalPoint",
        "thousandSeparator",
        "user",
        "fullPaymentDiscount"
    ],

    components: {
        vueDropzone: vue2Dropzone,
        Transcript,
        Summernote,
        StudentApplication,
        Attachments,
        Personal,
        Grades
    },

    data() {
        return {
            subtotalLabelsInput: {},
            userPartnerCode: "",
            foundationAllowedCodes: [],
            foundationGrades: false,
            foundationProgram: {},
            program1Type: "",
            program2Type: "",
            coursesArr: [],
            courses2Arr: [],
            gradingScales: [],
            defaultGradingScaleTypeId: null,
            localGradeLabel: "",
            showLocalGrades: false,
            showSecondaryLocalGrades: false,
            localMinGrade: {},
            localMaxGrade: {},
            localScale: {},

            updateCalled: 0,

            finance_tab: 10,
            summary_tab: 11,

            reduction_types: [],
            student_reduction: "",

            deductible_courses_exist: false,

            sessionTimer: { minutes: 4, seconds: 59 },
            isLoading: true,
            loadingAudits: false,
            shouldClose: false,
            firstLoad: true,
            sessionCreated: true,
            continueInterVal: true,
            fullPage: true,
            withdrawcheckbox_changed: 0,
            checkInvoiceCall: true,
            checkSummaryCall: true,

            programchanged: 0,

            paymentPlanToShow: 1,

            tabIndex: 0,

            alert: false,
            alertClass: "",
            alertMessage: "",

            disableEditFormMessage: "",
            disableEditForm: false,

            showDisableAlert: false,
            noGradingScaleRes: "", noGradingScale: false,
            statusCreateMode: false,
            statusCreateModeModal: false,

            lang: {
                formatLocale: {
                    firstDayOfWeek: 1,
                },
            },

            requestSource: "",
            interval: "",
            invalidStudentCountry: false,
            invalidAbsenceDate: false,
            invalidAbsenceReason: false,
            invalidAbsenceCourse: false,
            image: "/images/student.jpg",
            partnersDisabled: false,
            isAccountingUser: false,
            invoiceType: "",
            programCodesSecondaryMajor: [],
            absenceCourse: null,
            gpa: null,
            fpGpa: null,
            localGpa: null,
            fpLocalGpa: null,
            closing: true,
            watchIndex: 0,

            pagination: {
                current_page: 1
            },

            pagination_audit: {
                current_page: 1,
            },

            gradeDetails: {
                CourseID: null,
                CourseTitle: null,
                DescriptiveGrade: null,
                ECTSGrade: null,
                Enrolled: null,
                FinalExameDate: null,
                FullTitle: null,
                Grade: null,
                ImportFlag: null,
                ImportUser: null,
                Percentage: null,
                StudentID: null
            },
            // audits custom pagination
            currentPage: 1,
            perPageAudits: 5,
            fields: ["field", "oldValue", "newValue", "userName", "updatedAt"],

            thesisEvaluationDropzone: {
                url: "/api/students/thesis-evaluation",
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector(
                        "[name=csrf-token]"
                    ).content,
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                thumbnailWidth: 150, // px
                thumbnailHeight: 150,
                addRemoveLinks: true,
                maxFiles: 1
            },

            attachmentDropzone: {
                language: {
                    dictDefaultMessage:
                        "Drop a PDF file here, or click to select a file to upload."
                },
                url: "/api/students/attachments",
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector(
                        "[name=csrf-token]"
                    ).content,
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                thumbnailWidth: 150, // px
                thumbnailHeight: 150,
                params: {
                    student: localStorage.getItem("get-student")// Replace 123 with the actual student number value
                }
            },

            profileDropzone: {
                url: "/api/students/profile-image",
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector(
                        "[name=csrf-token]"
                    ).content,
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                thumbnailWidth: 150,
                thumbnailHeight: 150,
                addRemoveLinks: true,
                maxFiles: 1
            },

            applicationDropzone: {
                url: "/api/students/application",
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector(
                        "[name=csrf-token]"
                    ).content,
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                thumbnailWidth: 150, // px
                thumbnailHeight: 150
            },
            applicationDropzoneAdditionalDocument: {
                url: "/api/students/application",
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector(
                        "[name=csrf-token]"
                    ).content,
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                thumbnailWidth: 150, // px
                thumbnailHeight: 150,
                acceptedFiles:
                    ".docx,.doc,.xls,.xlsx,.ppt,.pptx,.pdf,.zip,.jpg,.jpeg,.tiff,.bmp,.gif,.png"
            },
            applicationDropzonePassport: {
                url: "/api/students/application",
                headers: {
                    "X-CSRF-TOKEN": document.head.querySelector(
                        "[name=csrf-token]"
                    ).content,
                    Authorization: "Bearer " + localStorage.getItem("token")
                },
                thumbnailWidth: 150, // px
                thumbnailHeight: 150,
                acceptedFiles:
                    ".docx,.doc,.xls,.xlsx,.ppt,.pptx,.pdf,.zip,.jpg,.jpeg,.tiff,.bmp,.gif,.png"
            },
            withdrawcheckbox: null,
            bookIncludedcheckbox: null,

            status: {
                StatusID: "",
                StatusName: "",
                StatusComment: "",
                StatusDate: this.toDayDate()
            },

            statusDate: this.toDayDate(),
            selectedProgramCode: "",
            selectedProgram2Code: "",

            courses: [],
            fpCourses: [],
            courses2: [],
            countries: [],
            programs: [],
            secondaryPrograms: [],
            professor: [],

            grades: [],
            fpGrades: [],
            secondaryGrades: [],
            attachments: [],
            studentStatus: [],
            studentAbsences: [],

            statusList: [],
            partners: [],
            partnercampus: [],
            audits: [],
            studentInvoices: [],
            paymentPlans: [],

            titles: [],
            descriptiveGrades: [],
            ECTSGrades: [],
            gradeType: "pr",
            gradingScale: {},
            partnerCode: -1,

            // add professor
            title: null,
            titleState: null,
            firstName: null,
            firstNameState: null,
            lastName: null,
            lastNameState: null,
            CurrentUserPartnerCode: "",
            tuitionFee: {
                id: null,
                ProgramType: null,
                BillingCycle: null,
                ApplicationFee: 0,
                AcceptanceFee: 0,
                courseFee: 0,
                noOfSem: 0,
                noOfCourses: 0,
                beforeOrAfter: "before",
                days: null,
                status: false,
                semesterfees: {},
                total: 0,
                sem_total: 0
            },
            payment_plan_invoices_exist: 0,
            student: {
                ID: 0,
                StudentNumber: null,
                FirstName: "",
                LastName: "",
                TranscriptName: null,
                Title: null,
                BirthDate: this.formatDate(),
                BirthPlace: null,
                BirthCountry: null,
                Nationality: null,
                StreetAddress: null,
                City: null,
                Zip: null,
                Country: null,
                Phone: null,
                Mobile: null,
                Fax: null,
                Email: null,
                Email2: null,
                Email3: null,
                WebAddress: null,
                Photo: null,
                Remarks: null,
                Notes: null,
                MailAddress: 1,
                Student: 1,
                Professor: 1,
                Staff: 1,
                SISEnabled: 0,
                GradeNotification: 0,
                BirthdayNotification: 1,
                PartnerID: null,
                PartnerCampusID: null,
                ImportFlag: 1,
                ImportUser: 1,
                CurrentStatus: 0,
                LegalizationRequired: 0,
                GlobalDiscount: 0,
                FullPaymentDiscount: this.defaultFullPaymentDiscount,
                ProgramStart: null
            },

            studentProgram: {
                ProgramID: null,
                Program2ID: null,
                FoundationID: null,
                BooksIncluded: null,
                Graduate: null,
                Withdraw: null,
                GraduationDate: this.formatDate(),
                ThesisPercentage: null,
                ThesisDescriptiveGrade: null,
                ThesisGrade: null,
                ThesisECTSGrade: null,
                ThesisSubject: null,
                ThesisMentor: null,
                ThesisEvaluation: null,
                Examiner1: null,
                Examiner2: null,
                Examiner3: null,
                Examiner4: null,
                Examiner5: null,
                ProgramCode: null
            },

            studentGraduateReq: {
                BBAExitSurvey: null,
                BBAExitSurveyCBE: null,

                MASExitSurvey: null,

                CEExitSurvey: null,
                MASExitExamSBS: null,
                MASExitExamSBSResult: null,

                MSCInternReport: null,

                DBAExitSurvey: null,
                DBAExitExamSBS: null,
                DBAExitExamSBSResult: null,

                DBAEthicsApprovalDoc: null,
                DBAEApprovalDate: null,
                DBAStatsExamDate: null,
                DBAStatsExamResult: null,
                DBACompsDate: null,
                DBACompsResult: null,
                DBAMAIssued: null,
                DBAMADate: null,
                DBADissertation: null,
                DBADODDate: null,
                DBADegreeIssued: null,
                DBADegreeIssueDate: null,

                FinancialObligations: null,
                PassingGPA: null
            },

            studentBussiness: {
                CompanyName: null,
                Department: null,
                Position: null,
                StreetAddress: null,
                City: null,
                Zip: null,
                Country: null,
                Phone: null,
                Mobile: null,
                Fax: null,
                Email: null,
                WebAddress: null,
                ContactPersonTitle: null,
                ContactPersonFirstName: null,
                ContactPersonLastName: null,
                ContactPersonDepartment: null,
                Notes: null,
                StudentID: null,
                ProfessorID: null
            },

            studentAdmission: {
                EducationalBackground: null,
                SBSTest: null,
                GMATTest: null,
                GMATResult: null,
                SATTest: null,
                SATResult: null,
                TOEFLTest: null,
                TOEFLResult: null,
                IELTSTest: null,
                IELTSResult: null,
                ExamAdmBBA: null,
                ExamAdmResultBBA: null,
                ExamEntBBA: null,
                ExamEntResultBBA: null,
                ExamOthBBA: null,
                ExamOthResultBBA: null,
                ExamAdmMAS: null,
                ExamAdmResultMAS: null,
                ExamEntMAS: null,
                ExamEntResultMAS: null,
                ExamOthMAS: null,
                ExamOthResultMAS: null,
                ExamEntDBA: null,
                ExamEntResultDBA: null,
                ExamOthDBA: null,
                ExamOthResultDBA: null
            },

            studentAbsence: {
                Date: this.dateFormat ? moment().format(this.dateFormat) : null,
                Reason: null,
                CourseID: null,
                CourseTitle: null,
                Remarks: null
            },
            studentApplicationNewData: {
                CurriculumVitae: [],
                Degree: [],
                Transcript: [],
                Letter: [],
                Picture: [],
                AdditionalDocuments: [],
                EnglishProficiency: [],
                ResearchInterestOutline: [],
                AssociateDegree: [],
                PassportCopy: [],
                PermitCopy: []
            },
            studentFinance: {
                GlobalDiscount: null,
                FullPaymentDiscount: null
            },
            studentPaymentSummary: {
                DateFrom: '',
                DateTo: '',
                SummaryDate: this.toDayDate(),
                TitleText: `Payment Confirmation ${new Date().getFullYear()}`,
                IntroText: '',
                Currency: 'CHF',
                ClosingText: 'Feel free to contact us should you have any questions.',
                DefaultStatus: 'Pending',
                GroupByYear: false,
                CustomGrouping: false,
                GrandTotalLabel: 'Total fees paid to date:'
            },
            currencies: [],
            paymentSummaries: [],
            paymentSummaryItems: [],
            studentApplication: {
                CurriculumVitae: [],
                Degree: [],
                Transcript: [],
                Letter: [],
                Picture: [],
                PassportCopy: [],
                PermitCopy: [],
                AdditionalDocuments: [],
                Score: "",
                EnglishProficiency: [],
                ResearchInterestOutline: [],
                AssociateDegree: [],
                ValidAssociateDegree: false,
                ValidResearchInterestOutline: false,
                ValidCurriculumVitae: false,
                ValidDegree: false,
                ValidTranscript: false,
                ValidLetter: false,
                ValidPicture: false,
                ValidEnglishProficiency: false,
                ValidPermitCopy: false,
                ValidPassportCopy: false,
                TS: null
            }
        };
    },

    validations: {
        student: {
            FirstName: {
                required,
                maxLength: maxLength(100)
            },
            LastName: {
                required,
                maxLength: maxLength(100)
            },
            BirthPlace: {

                maxLength: maxLength(100)
            },
            Email: {
                required,
                email
            }
        },
        studentFinance: {
            GlobalDiscount: {
                decimal,
                maxLength: maxLength(10),
                between: between(0, 100)
            },
            FullPaymentDiscount: {
                decimal,
                maxLength: maxLength(10),
                between: between(0, 100)
            }
        },
        studentBussiness: {
            CompanyName: {
                required,
                maxLength: maxLength(100)
            },
            Department: {
                required,
                maxLength: maxLength(100)
            },
            Position: {
                required,
                maxLength: maxLength(100)
            },
            StreetAddress: {
                required,
                maxLength: maxLength(255)
            },
            City: {
                required,
                maxLength: maxLength(100)
            },
            Country: {
                required
            },
            Zip: {
                required,
                maxLength: maxLength(50)
            },
            Phone: {
                required,
                maxLength: maxLength(100)
            },
            Mobile: {
                required,
                maxLength: maxLength(100)
            },
            Email: {
                required,
                email
            },
            ContactPersonFirstName: {
                maxLength: maxLength(100)
            },
            ContactPersonLastName: {
                maxLength: maxLength(100)
            },
            ContactPersonDepartment: {
                maxLength: maxLength(100)
            }
        },
        studentProgram: {

            ProgramID: {
                required,
                numeric,
                maxLength: maxLength(255)
            },

            ThesisSubject: {
                maxLength: maxLength(255)
            },

            ThesisPercentage: {
                numeric,
                maxLength: maxLength(10),
                between: between(0, 100)
            }
        },

        grades: {
            $each: {
                Percentage: {
                    between: between(0, 100)
                },
                Grade: {
                    between: between(0, 4)
                },
                LocalGrade: {
                    between: between(0, 6),
                },
            }
        },

        secondaryGrades: {
            $each: {
                Percentage: {
                    between: between(0, 100)
                },
                Grade: {
                    between: between(0, 4)
                },
                LocalGrade: {
                    between: between(0, 6),
                },
            }
        }
    },

    computed: {
        paymentSummaryTotalAmount() {
            return this.paymentSummaryItems.reduce((s, it) => s + (parseFloat(it.amount_received) || 0), 0);
        },
        paymentSummaryTotalAmountFormatted() {
            return this.paymentSummaryTotalAmount.toFixed(2);
        },
        paymentSummaryCurrency() {
            if (this.paymentSummaryItems.length > 0) {
                return this.paymentSummaryItems[0].currency ?? '';
            }
            return '';
        },
        defaultFullPaymentDiscount() {
            return this.fullPaymentDiscount;
        },
        totalAudits() {
            return this.audits.length;
        },

        readonly() {
            return !this.permissions.editStudents;
        },
        readonlyabsences() {
            return !this.permissions.editStudentsAbsences;
        },
        readonlyattachments() {
            return !this.permissions.editStudentsAttachments;
        },
        readonlygraduationrequirements() {
            return !this.permissions.editStudentsGraduationrequirements;
        },
        readonlyprogram() {
            return !this.permissions.editStudentsProgram;
        },
        readonlyadmissions() {
            return !this.permissions.editStudentsAdmissions;
        },
        readonlyremarks() {
            return !this.permissions.editStudentsRemarks;
        },
        readonlybusinessinformation() {
            return !this.permissions.editStudentsBusinessinformation;
        },
        readonlypersonalinformation() {
            return !this.permissions.editStudents;
        },

        showGradesBtns() {
            return (
                this.studentProgram.ProgramID &&
                (this.permissions.editPrograms ||
                    this.permissions.editStudentsGrades)
            );
        },

        cardTitle() {
            return `${this.student.FirstName} ${this.student.LastName} - ${this.student.StudentNumber}`;
        },

        isPartnerSchoolUser() {
            if (this.user.roles) {
                let found = this.user.roles.find(
                    role => role.slug == "partner.school"
                );

                if (found) return true;
            }

            return false;
        },

        isPartnerSchoolUserWithAddGradePermission() {
            if (
                this.isPartnerSchoolUser &&
                this.permissions.addStudentsGrades &&
                !this.permissions.editStudentsGrades
            ) {
                return true;
            }

            return false;
        },

        isFrontOfficeUser() {
            if (this.user.roles) {
                let found = this.user.roles.find(
                    role => role.slug == "front.office"
                );

                if (found) return true;
            }

            return false;
        },

        isRecruitmentManagerUser() {
            if (this.user.roles) {
                let found = this.user.roles.find(
                    role => role.slug == "recruitment.manager"
                );

                if (found) return true;
            }

            return false;
        },

        showAbsencesTab() {
            return !(this.isFrontOfficeUser || this.isRecruitmentManagerUser);
        },

        showBusinessTab() {
            if (!this.permissions.editStudentsBusinessinformation) return true;
            else return false;
        },

        showApplicationTab() {
            return !(this.isFrontOfficeUser || this.isRecruitmentManagerUser);
        },
        /* Other groups eligible to view finance tab*/
        groupsCanViewFinanceTab() {
            let res = false,
                role = null;
            const eligbleRoles = [
                "registrar",
                "management",
                "program.all",
                "program.bba",
                "program.mba",
                "program.msc",
                "program.dba"
            ];

            for (const roleSlug of eligbleRoles) {
                if (!role) {
                    role = this.user.roles.find(role => role.slug == roleSlug);
                } else {
                    if (role) {
                        res = true;
                    }
                }
            }

            return res;
        },
        showFinanceTab() {
            if (this.isFrontOfficeUser || this.isRecruitmentManagerUser) {
                return false;
            }

            return (
                (!this.isPartnerSchoolUser && this.isAccountingUser) ||
                this.groupsCanViewFinanceTab
            );
        },

        showPaymentSummaryTab() {
            if (this.isAccountingUser) {
                return true;
            } else {
                return false;
            }
        },

        showTranscriptTab() {
            return !(
                this.isFrontOfficeUser ||
                this.isRecruitmentManagerUser ||
                this.isPartnerSchoolUser
            );
        },

        showAuditTab() {
            if (this.isFrontOfficeUser || this.isRecruitmentManagerUser) {
                return false;
            }

            return !this.isPartnerSchoolUser;
        }
    },

    watch: {
        tabIndex(value) {

            if (value == 12) {
                this.getAudits();
            }
        },
        student: {
            handler(val) {
                if (val.ID != undefined && val.ID && this.checkInvoiceCall)
                    this.getStudentInvoices();
                this.closing = false;
            },
            deep: true
        },

        studentBussiness: {
            handler(val) {
                this.closing = false;
            },
            deep: true
        },

        studentFinance: {
            handler(val) {
                this.closing = false;
            },
            deep: true
        },

        studentAdmission: {
            handler(val) {
                this.closing = false;
            },
            deep: true
        },

        studentProgram: {
            handler(val) {
                this.closing = false;
            },
            deep: true
        },

        grades: {
            handler(val) {
                this.closing = false;
            },
            deep: true
        },

        secondaryGrades: {
            handler(val) {
                this.closing = false;
            },
            deep: true
        },

        studentGraduateReq: {
            handler(val) {
                this.closing = false;
            },
            deep: true
        },

        attachments: {
            handler(val) {
                this.closing = false;
            },
            deep: true
        },

        studentAbsences: {
            handler(val) {
                this.closing = false;
            },
            deep: true
        },

        studentApplication: {


            handler(val) {
                this.watchIndex++;


                this.closing = false;
                if (this.watchIndex == 1) {
                    this.closing = true;
                }
            },
            deep: true
        },

        "student.PartnerID": function (val) {
            this.checkLocalGrade();
            this.checkLocalGrade2();
        },

        "studentProgram.ProgramID": function (val) {
            this.checkLocalGrade();
        },

        "studentProgram.Program2ID": function (val) {
            this.checkLocalGrade2();
        },

        '$route.params.id': {
            immediate: false,
            handler(newId, oldId) {
            if (newId !== oldId) {
                this.resetStudentData();
                this.getStudent();
            }
            }
        },

        selectedProgramCode: {
            handler(newCode) {
                if (!newCode || !this.gradingScales.length) return;

                // Wait for Vue to finish updating this.studentProgram
                this.$nextTick(() => {
                    const programId = this.studentProgram?.ProgramID;
                    if (!programId) return; // Safety check

                    const studentPartnerCode = this.partners.find(
                        p => p.PartnerID === this.student.PartnerID
                    )?.PartnerCode;

                    this.populateGradingScaleForCurrentStudent(newCode, studentPartnerCode, programId);
                });
            },
            immediate: false
        },

        selectedProgram2Code: { 
            handler(newCode) {
                if (!newCode || !this.gradingScales.length) return;

                this.$nextTick(() => {
                    const programId = this.studentProgram?.Program2ID;
                    if (!programId) return;

                    const studentPartnerCode = this.partners.find(
                        p => p.PartnerID === this.student.PartnerID
                    )?.PartnerCode;

                    this.populateGradingScaleForCurrentStudent(newCode, studentPartnerCode, programId);
                });
            },
            immediate: false
        },

        'foundationProgram.ProgramCode': {
            handler(newCode) {
                if (!newCode || !this.gradingScales.length) return;

                this.$nextTick(() => {
                    const programId = this.foundationProgram?.ID;
                    if (!programId) return;

                    const studentPartnerCode = this.partners.find(
                        p => p.PartnerID === this.student.PartnerID
                    )?.PartnerCode;

                    this.populateGradingScaleForFoundationProgram(newCode, studentPartnerCode, programId);
                });
            },
            immediate: false
        },

        'studentPaymentSummary.GroupByYear'(newValue) {
            if (newValue) {
                // 1. Clear custom grouping
                this.studentPaymentSummary.CustomGrouping = false;
                this.paymentSummaryItems.forEach(item => { item.group_number = null; });

                // 2. Populate years for existing items
                this.paymentSummaryItems.forEach((item, idx) => {
                    if (item.payment_date && !item.year) {
                        this.autoPopulateYear(item, idx);
                    }
                });

                // 3. Sort and RESET sort_order to 1, 2, 3...
                this.sortPaymentSummaryItemsByYear();
                this.resortItems();
            }
        },

        'studentPaymentSummary.CustomGrouping'(newValue) {
            if (newValue) {
                // 1. Clear year grouping
                this.studentPaymentSummary.GroupByYear = false;
                this.paymentSummaryItems.forEach(item => { item.year = null; });

                // 2. Sort and RESET sort_order to 1, 2, 3...
                this.sortPaymentSummaryItemsByGroup();
                this.resortItems();
            }
        }
    },

    async mounted() {

        if (!this.permissions.viewStudents) {
            return this.$router.push("/");
        }
        if (!this.permissions.editStudentsRemarks) {
            $("#summernoteRemarks").summernote("disable");
        }

        if (this.permissions.editStudents) {
            this.checkForEdit();
            let self = this;

            this.interval = setInterval(() => {
                if (self.continueInterVal) self.checkForEdit();
            }, this.editFormInterval);
        }

        this.isLoading = true;
        await this.getInitialData();
        await this.getStudent();
        if (Number(localStorage.getItem("summary-tab")) === this.summary_tab) {                       
            this.tabIndex = this.summary_tab;
            localStorage.removeItem("summary-tab");
        }
        if (this.permissions.viewSettingsReductiontypes) {
            await this.getReductionTypes();
        }
        this.closing = true;


    },

    methods: {
        addRow() {
            this.paymentSummaryItems.push({ invoice_id: null, invoice_number: '', amount_received: 0, payment_date: null, is_manual: true, sort_order: this.paymentSummaryItems.length + 1 });
        },
        removeRow(i) {
            this.paymentSummaryItems.splice(i, 1);
        },
        getGroupKey(item) {
            if (!item) return null; // Handle undefined
            const isYear = this.summary?.group_by_year || this.studentPaymentSummary?.GroupByYear;
            const isCustom = this.summary?.custom_grouping || this.studentPaymentSummary?.CustomGrouping;
            if (isYear) return item.year || 'no_year';
            if (isCustom) return item.group_number?.toString() || 'unspecified';
            return null;
        },

        getGroupItems(item) {
            const key = this.getGroupKey(item);
            if (!key) return this.paymentSummaryItems;
            return this.paymentSummaryItems.filter(i => this.getGroupKey(i) === key);
        },

        moveRowUp(item) {
            const group = this.getGroupItems(item);
            const idx = group.indexOf(item);
            if (idx > 0) {
                const prev = group[idx - 1];
                // Swap sort_order
                const temp = item.sort_order || 0;
                this.$set(item, 'sort_order', prev.sort_order || 0);
                this.$set(prev, 'sort_order', temp);
                // Re-sort and re-index
                this.resortItems();
            }
        },

        moveRowDown(item) {
            const group = this.getGroupItems(item);
            const idx = group.indexOf(item);
            if (idx < group.length - 1) {
                const next = group[idx + 1];
                // Swap sort_order
                const temp = item.sort_order || 0;
                this.$set(item, 'sort_order', next.sort_order || 0);
                this.$set(next, 'sort_order', temp);
                // Re-sort and re-index
                this.resortItems();
            }
        },

        resortItems() {
            const isYear = this.studentPaymentSummary?.GroupByYear;
            const isCustom = this.studentPaymentSummary?.CustomGrouping;

            // 1. Sort the array
            this.paymentSummaryItems.sort((a, b) => {
                const keyA = this.getGroupKey(a);
                const keyB = this.getGroupKey(b);
                
                // If not grouped, just sort by sort_order
                if (!isYear && !isCustom) {
                    return (a.sort_order || 0) - (b.sort_order || 0);
                }

                // Sort by group first
                if (keyA !== keyB) {
                    if (keyA === 'unspecified' || keyA === 'no_year') return 1;
                    if (keyB === 'unspecified' || keyB === 'no_year') return -1;
                    return keyA - keyB;
                }
                // Then by sort_order
                return (a.sort_order || 0) - (b.sort_order || 0);
            });

            // 2. Re-index sort_order to be sequential (1, 2, 3...) within groups
            // We must track the current group to reset the counter
            let currentGroup = null;
            let counter = 1;

            this.paymentSummaryItems.forEach(item => {
                const itemGroup = this.getGroupKey(item);
                
                if (itemGroup !== currentGroup) {
                    currentGroup = itemGroup;
                    counter = 1; // Reset counter for new group
                }
                
                this.$set(item, 'sort_order', counter);
                counter++;
            });
        },

        // Drag & Drop Handlers
        onDragStart(event, item) {
            event.dataTransfer.setData('text/plain', item.invoice_number || item.amount_received);
            this.draggingItem = item;
            event.target.style.opacity = '0.5';
        },

        onDragOver(event) {
            event.preventDefault();
        },

        onDrop(event, targetItem) {
            event.preventDefault();
            if (!this.draggingItem || this.draggingItem === targetItem) return;

            // Restrict drag & drop to same group
            if (this.getGroupKey(this.draggingItem) !== this.getGroupKey(targetItem)) {
                return;
            }

            // Swap sort_order values
            const temp = this.draggingItem.sort_order || 0;
            this.$set(this.draggingItem, 'sort_order', targetItem.sort_order || 0);
            this.$set(targetItem, 'sort_order', temp);

            // Re-sort and re-index everything to ensure clean 1,2,3 sequence
            this.resortItems();
            
            this.draggingItem = null;
            document.querySelectorAll('.draggable-row').forEach(el => el.style.opacity = '1');
        },
        async getPaymentData() {
            this.loading = true;

            await axios
                .get(`/api/students/${this.student.ID}/payment-data`, {
                    params: {
                        from: this.studentPaymentSummary.DateFrom || null,
                        to: this.studentPaymentSummary.DateTo || null
                    }
                })
                .then(response => {
                    this.paymentSummaryItems = [];

                    if (response.data.length === 0) {
                        alert(this.$t('No invoices found.'));
                        return;
                    }

                    response.data.forEach((f, index) => {
                        if (
                            f.invoice_id &&
                            !this.paymentSummaryItems.some(it => it.invoice_id === f.invoice_id)
                        ) {
                            // Extract year from payment_date if it exists
                            let year = null;
                            if (f.payment_date) {
                                const momentDate = moment(f.payment_date);
                                if (momentDate.isValid()) {
                                    year = momentDate.format('YYYY');
                                }
                            }
                            this.paymentSummaryItems.push({
                                invoice_id: f.invoice_id,
                                invoice_number: f.invoice_number,
                                amount_received: f.amount_received,
                                payment_date: f.payment_date && moment(f.payment_date).isValid() ? moment(f.payment_date).format(this.dateFormat) : null,
                                currency: f.currency,
                                is_manual: false,
                                year: year,
                                sort_order: index + 1
                            });

                            // Sort items by year (years ascending, null/empty years at end)
                            if (this.studentPaymentSummary.GroupByYear) {
                                this.sortPaymentSummaryItemsByYear();
                            }
                        }
                    });
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        savePaymentSummary() {
            const payload = {
                student_id: this.student.ID,
                summary_date: this.studentPaymentSummary.SummaryDate,
                currency: this.studentPaymentSummary.Currency,
                title: this.studentPaymentSummary.TitleText,
                intro_text: this.studentPaymentSummary.IntroText,
                closing_text: this.studentPaymentSummary.ClosingText,
                status: this.studentPaymentSummary.DefaultStatus,
                group_by_year: this.studentPaymentSummary.GroupByYear || false,
                custom_grouping: this.studentPaymentSummary.CustomGrouping || false,
                grand_total_label: this.studentPaymentSummary.GrandTotalLabel || this.$t('form.student.totalFeesPaidToDate'),
                subtotal_labels: this.subtotalLabelsInput,
                paymentSummaryItems: this.paymentSummaryItems.map(i => ({
                    invoice_id: i.invoice_id,
                    invoice_number: i.invoice_number,
                    amount_received: i.amount_received,
                    payment_date: i.payment_date,
                    is_manual: i.is_manual,
                    year: i.year || null,
                    group_number: i.group_number || null,
                    sort_order: i.sort_order || 0
                }))
            };

            this.isLoading = true;

            axios
                .post('/api/payment-summaries', payload)
                .then((response) => {
                    this.isLoading = false;
                    this.showAlert(response.data.message);
                    this.getStudentPaymentSummaries();
                    this.paymentSummaryItems = [];
                    this.subtotalLabelsInput = {};
                    this.studentPaymentSummary.DateFrom = '';
                    this.studentPaymentSummary.DateTo = '';
                    this.studentPaymentSummary.GroupByYear = false;
                    this.studentPaymentSummary.CustomGrouping = false;
                    this.studentPaymentSummary.GrandTotalLabel = '';
                    this.$refs.paymentSummaryModal.hide();
                })
                .catch((error) => {
                    this.isLoading = false;

                    if (error.response.data.error) {
                        this.showAlert(error.response.data.message, "danger");
                    }
                });
        },
        getStudentPaymentSummaries() {
            this.checkSummaryCall = false;
            if (localStorage.getItem("from")) {
                this.pagination.current_page = localStorage.getItem("page");
                this.tabIndex = 11;
                localStorage.removeItem("from");
            }
            axios
                .get(`/api/payment-summaries/student/${this.student.ID}`)
                .then(res => {
                    this.paymentSummaries = res.data;
                })
                .catch(err => {
                    console.error(err);
                });
        },
        /**
         * Go to Show Summary Page
         */
        goToShowSummary(id) {
            localStorage.setItem("summary-tab", 11);
            this.$router.push({
                name: "PaymentSummaryShow",
                params: {
                    id: id
                },
                query: {
                    origin: 'student'
                }
            });
        },

        /**
         * Go to Summary edit page
         */
        goToEditSummary(id) {
            localStorage.setItem("summary-tab", 11);
            this.$router.push({
                name: 'PaymentSummaryEdit',
                params: {
                    id: id
                },
                query: {
                    origin: 'student'
                }
            });
        },
        /**
         * Delete student Payment Summary
         */
        deleteSummary(sps) {

            var id = sps.id;

            if(sps.status == 'Sent'){
                var conf = confirm(this.$t('form.validation.deleteSentPaymentSummary'));
            } else {
                var conf = confirm(this.$t('form.validation.delete'));
            }

            if (conf === true) {
                this.isLoading = true;
                axios
                    .delete(`/api/payment-summaries/${id}`)
                    .then(response => {
                        this.isLoading = false;
                        const rowIndex = this.paymentSummaries.findIndex(item => item.id === id);
                        if (rowIndex !== -1) {
                            this.paymentSummaries.splice(rowIndex, 1);
                        }
                        this.showAlert(response.data.message);
                        this.getStudentPaymentSummaries();
                    })
                    .catch(error => {
                        if (error.response) {
                            this.isLoading = false;
                            this.showAlert(error.response.data.message, 'danger');
                        } else {
                            this.isLoading = false;
                            this.showAlert(error, 'danger');
                        }
                    });
            }
        },

        handleGroupByYearChange() {
            if (this.studentPaymentSummary.GroupByYear) {
                this.studentPaymentSummary.CustomGrouping = false;
                // Clear group numbers when switching to year grouping
                this.paymentSummaryItems.forEach(item => {
                    item.group_number = null;
                });
            }
        },

        handleCustomGroupingChange() {
            if (this.studentPaymentSummary.CustomGrouping) {
                this.studentPaymentSummary.GroupByYear = false;
                // Clear years when switching to custom grouping
                this.paymentSummaryItems.forEach(item => {
                    item.year = null;
                });
            }
        },

        autoPopulateYearOrGroup(row, idx) {
            if (this.studentPaymentSummary.GroupByYear) {
                this.autoPopulateYear(row, idx);
            }
            // For custom grouping, no auto-population needed
        },

        sortPaymentSummaryItemsByGroup() {
            if (!this.studentPaymentSummary.CustomGrouping) {
                return;
            }

            this.paymentSummaryItems.sort((a, b) => {
                const groupA = a.group_number !== null && a.group_number !== undefined && a.group_number !== '' ? parseInt(a.group_number) : null;
                const groupB = b.group_number !== null && b.group_number !== undefined && b.group_number !== '' ? parseInt(b.group_number) : null;

                // If both have group numbers, sort ascending
                if (groupA !== null && groupB !== null) {
                    return groupA - groupB;
                }

                // If only A has group number, A comes first
                if (groupA !== null && groupB === null) {
                    return -1;
                }

                // If only B has group number, B comes first
                if (groupA === null && groupB !== null) {
                    return 1;
                }

                // If neither has group number, maintain original order
                return 0;
            });

            // Re-index sort_order numbers (1, 2, 3...) after sorting
            this.resortItems();
        },

        getUniqueGroups() {
            const groups = new Set();
            let hasUnspecified = false;

            this.paymentSummaryItems.forEach(item => {
                if (item.group_number !== null && item.group_number !== undefined && item.group_number !== '') {
                    groups.add(item.group_number);
                } else {
                    hasUnspecified = true;
                }
            });

            // Sort groups ascending and add 'unspecified' at the end
            const result = Array.from(groups).sort((a, b) => a - b);
            if (hasUnspecified) {
                result.push('unspecified');
            }

            return result;
        },

        sortPaymentSummaryItemsByYear() {
            if (!this.studentPaymentSummary.GroupByYear) {
                return;
            }

            this.paymentSummaryItems.sort((a, b) => {
                const yearA = a.year && a.year.trim() !== '' ? a.year : null;
                const yearB = b.year && b.year.trim() !== '' ? b.year : null;

                // If both have years, sort ascending
                if (yearA && yearB) {
                    return yearA.localeCompare(yearB);
                }

                // If only A has year, A comes first
                if (yearA && !yearB) {
                    return -1;
                }

                // If only B has year, B comes first
                if (!yearA && yearB) {
                    return 1;
                }

                // If neither has year, maintain original order
                return 0;
            });

            // Re-index sort_order numbers (1, 2, 3...) after sorting
            this.resortItems();
        },

        autoPopulateYear(row, idx) {
            if (!this.studentPaymentSummary.GroupByYear) {
                return;
            }

            if (row.payment_date) {
                let year = '';

                // Handle different date formats
                if (typeof row.payment_date === 'string') {
                    // If it's a string like "03.05.2024" (DD.MM.YYYY)
                    const parts = row.payment_date.split('.');
                    if (parts.length === 3) {
                        year = parts[2]; // Get year from DD.MM.YYYY
                    } else {
                        // Try moment parsing
                        const momentDate = moment(row.payment_date, this.dateFormat);
                        if (momentDate.isValid()) {
                            year = momentDate.format('YYYY');
                        }
                    }
                } else if (row.payment_date instanceof Date) {
                    year = row.payment_date.getFullYear().toString();
                } else {
                    // Try moment parsing as fallback
                    const momentDate = moment(row.payment_date);
                    if (momentDate.isValid()) {
                        year = momentDate.format('YYYY');
                    }
                }

                if (year && year.length === 4 && !isNaN(year)) {
                    this.$set(this.paymentSummaryItems[idx], 'year', year);
                    
                    // Re-sort after year is populated
                    this.sortPaymentSummaryItemsByYear();
                }
            }
        },

        getUniqueYears() {
            const years = new Set();
            let hasNoYear = false;

            this.paymentSummaryItems.forEach(item => {
                if (item.year && item.year.trim() !== '' && item.year.length === 4) {
                    years.add(item.year);
                } else {
                    hasNoYear = true;
                }
            });

            // Sort years ascending and add 'noYear' at the end
            const result = Array.from(years).sort((a, b) => a.localeCompare(b));
            if (hasNoYear) {
                result.push('noYear');
            }

            return result;
        },

        getSubtotalPlaceholder(value, type) {
            if (type === 'year') {
                if (value === 'noYear') {
                    return this.$t('form.student.totalFeesPaid');
                }
                return this.$t('form.student.totalFeesForYear', {year: value});
            } else if (type === 'group') {
                if (value === 'unspecified') {
                    return this.$t('form.student.totalFeesPaid');
                }
                return this.$t('form.student.totalFeesForGroup', {group: value});
            }
            return this.$t('form.student.totalFeesPaid');
        },

        resetStudentData() {
            this.grades = [];
            this.coursesArr = [];
            this.courses2Arr = [];
            this.fpGrades = [];
            this.secondaryGrades = [];
            this.attachments = [];
            this.studentAbsences = {};
            this.studentStatus = [];
            this.studentInvoices = [];
            this.status = {StatusID: "", StatusName: "", StatusComment: "", StatusDate: this.toDayDate()};
            this.image = "/images/student.jpg";
            this.gradingScale = {};  
            this.selectedProgramCode = "";
            this.selectedProgram2Code = "";
            this.foundationProgram = {};
            this.foundationGrades = false;
        },
        handleNoGradingScale(r) {
            this.noGradingScaleRes = r;
        },

        checkLocalGrade2() {
            const programID = this.studentProgram.Program2ID;
            const partnerID = this.student.PartnerID;
            if (!(programID && partnerID)) return;

            const currentProgramCode = this.programs.find(e => e.ID == programID).ProgramCode;
            const currentPartnerCode = this.partners.find(e => e.PartnerID == partnerID).PartnerCode;

            const localScale = GradingScaleResolver.resolveLocal(this.gradingScales, {
                programCode: currentProgramCode,
                partnerCode: currentPartnerCode,
                typeId: this.programTypeId(programID),
                defaultTypeId: this.defaultGradingScaleTypeId,
            });

            this.showSecondaryLocalGrades = !!localScale && !!localScale.local_grading_scale;
        },

        checkLocalGrade() {
            const programID = this.studentProgram.ProgramID;
            const partnerID = this.student.PartnerID;
            if (!(programID && partnerID)) return;

            const currentProgramCode = this.programs.find(e => e.ID == programID).ProgramCode;
            const currentPartnerCode = this.partners.find(e => e.PartnerID == partnerID).PartnerCode;

            const localScale = GradingScaleResolver.resolveLocal(this.gradingScales, {
                programCode: currentProgramCode,
                partnerCode: currentPartnerCode,
                typeId: this.programTypeId(programID),
                defaultTypeId: this.defaultGradingScaleTypeId,
            });

            if (localScale && localScale.local_grading_scale) this.localScale = localScale;
            if (localScale) this.localGradeLabel = localScale.local_grade_name;
            this.showLocalGrades = !!localScale && !!localScale.local_grading_scale;
        },

        /**
         * Delete student invoice
         */
        deleteInvoice(invoice) {

            if (!this.permissions.deleteInvoicesCompanies && !this.permissions.deleteInvoicesStudents) {
                this.showAlert(this.$t('form.validation.cantDeleteInvoice'), 'danger');
                return;
            }
            var index = invoice.ID;

            if (invoice.Status == 3) {
                var conf = confirm(this.$t('form.validation.deleteSentInvoice'));
            } else if (invoice.Status == 4) {
                var conf = confirm(this.$t('form.validation.deletePaidInvoice'));
            } else {
                var conf = confirm(this.$t('form.validation.delete'));
            }

            if (conf === true) {
                this.isLoading = true;
                axios
                    .delete("/api/invoices/" + index)
                    .then(response => {
                        this.isLoading = false;
                        this.studentInvoices.splice(index, 1);
                        this.showAlert(response.data.message);
                        this.getStudentInvoices();
                    })
                    .catch(error => {
                        if (error.response) {
                            this.isLoading = false;
                            this.showAlert(error.response.data.message, 'danger');
                        } else {
                            this.isLoading = false;
                            this.showAlert(error, 'danger');
                        }
                    });
            }
        },
        async getStudentReductionType() {
            this.isLoading = true;

            try {
                const response = await axios.post("/api/reduction-types/student", {
                    student: this.student
                });

                if (response.data.data.reduction_type) {
                    this.student_reduction =
                        response.data.data.reduction_type.reduction_type.name;
                } else {
                    this.student_reduction = "";
                }
            } catch (error) {

                this.isLoading = false;
                console.log('getStudentReductionType(): ', error);
            }

        },
        async getReductionTypes() {
            this.isLoading = true;

            try {
                if (localStorage.getItem("page") != 1) {
                    this.pagination.current_page = 1;
                }

                const response = await axios.get("/api/reduction-types?page=" + this.pagination.current_page);
                this.reduction_types = response.data.data.data;
                await this.getStudentReductionType();
                this.isLoading = false;
            }
            catch (error) {
                this.isLoading = false;
                console.log("error");
            }
        },

        getCurrentUserPartnerCode(PartnerID = null) {
            if (PartnerID) {
                this.CurrentUserPartnerCode;
                this.partners.forEach(obj => {
                    if (PartnerID == obj.PartnerID) {
                        this.CurrentUserPartnerCode = obj.PartnerCode;
                    }
                });
            }
        },
        sendingEvent(file, xhr, formData) {
            formData.append("StudentNumber", this.$route.params.id);
        },

        getAttachmentFileName(file) {
            var file = file;
            if (typeof file === "string") {
                return file.substring(file.lastIndexOf("/") + 1);
            } else {
                return file;
            }
        },

        getFileName(file) {
            var file = file.path ? file.path : file;
            if (typeof file === "string") {
                return file.substring(file.lastIndexOf("/") + 1);
            } else {
                return file;
            }
        },

        /**
         * Upload file error on dropzone
         */
        uploadFileError(file, message) {
            this.showAlert(message.errors, 'danger');
            this.isLoading = false;
        },

        /**
         * Uploaded Attachment Auto-save
         */
        attachmentUploaded(file, data) {
            this.loading = true;
            axios
                .post("/api/students/attachment/file/save", {
                    Name: data.filename,
                    File: `${data.student_number}/${data.id}/${data.filename}`,
                    StudentID: this.student.ID,
                    Description: "",
                    AttachmentDate: this.formatDate(),
                    UploadTimestamp: calculateTimeAsPerTimeZone('+2')
                })
                .then(response => {
                    if (response.data) {
                        this.attachments.push({ ...response.data?.attachment, Name: data.filename, type: file.type });
                        this.showAlert(response.data.message);
                        this.loading = false;
                    }
                })
                .catch(error => {
                    this.showAlert(error.response?.data?.message + ' ' + error.response?.data?.errors?.Name, "danger");
                    this.loading = false;
                });
        },

        uploadedFileSaveInDb(response, type = "") {
            this.loading = true;
            axios
                .post("/api/students/application/file/save", {
                    file: response.filename,
                    StudentID: this.student.ID,
                    type: type,
                    path: response.path

                })
                .then(response => {
                    if (response.data.error) {
                        this.loading = false;
                        this.showAlert(response.data.message, "warning");
                    } else if (response.data.success) {
                        this.loading = false;
                        this.showAlert(response.data.message);
                    }
                })
                .catch(error => {
                    this.loading = false;
                    console.log("error");
                });
        },
        /**
         * Go to program edit screen
         */
        editProgram() {
            if (!this.permissions.viewPrograms) return;

            localStorage.setItem("grades-tab", true);

            let id = this.studentProgram.ProgramID;

            this.$router.push({
                name: "ProgramEdit",
                params: {
                    id: id
                }
            });
        },

        // Add professor logic
        resetModal() {
            this.title = "";
            this.titleState = null;
            this.firstName = "";
            this.firstNameState = null;
            this.lastName = "";
            this.lastNameState = null;
        },

        handleOk(bvModalEvt) {
            bvModalEvt.preventDefault();

            this.handleSubmit();
        },

        handleSubmit() {
            if (!this.checkFormValidity()) return;

            this.saveProfessor();
        },

        checkFormValidity() {
            let valid = this.$refs.form.checkValidity();

            this.titleState = valid;
            this.firstNameState = valid;
            this.lastNameState = valid;

            return valid;
        },

        // add professor logic ends

        newInvoice() {
            if (!this.permissions.createInvoicesStudents) return;

            // save student id into storage
            localStorage.setItem("finance-tab", this.student.ID);
            localStorage.setItem("create-invoice-from-student", true);

            // redirect to create invoice screen
            this.$router.push({
                name: "StudentInvoiceCreate"
            });
        },
        createPaymentPlanInvoicesForSecondary() {
            if (!this.permissions.createInvoicesStudents) return;
            this.isLoading = true;
            for (var i = 0; i < this.studentInvoices.length; i++) {
                if (
                    this.studentInvoices[i].PaymentPlan != null ||
                    this.studentInvoices[i].Installment != null
                ) {
                    this.payment_plan_invoices_exist = 1;
                }
            }
            if (this.payment_plan_invoices_exist == 1) {
                if (
                    confirm(
                        this.$t("form.invoice.paymentPlanBatchAlreadyExists")
                    )
                ) {
                    if (
                        this.deductible_courses_exist &&
                        (this.student.PaymentPlan == "monthly" ||
                            this.student.PaymentPlan == "annual" ||
                            this.student.PaymentPlan == "quarterly")
                    ) {
                        this.showAlert(
                            this.$t(
                                "form.invoice.deductible_credits_not_supported"
                            ),
                            "warning"
                        );
                    }
                    localStorage.setItem("finance-tab", this.student.ID);

                    const student = this.student;
                    student.GlobalDiscount = this.studentFinance.GlobalDiscount;

                    let data = {
                        student: JSON.stringify(student)
                    };

                    axios
                        .post("/api/paymentplan/invoices-for-secondary", data)
                        .then(response => {
                            this.isLoading = false;
                            if (
                                response.status == 203 &&
                                response.data.success == false
                            ) {
                                this.showAlert(response.data.message, "danger");
                                return;
                            }
                            if (response.data) {
                                this.showAlert(response.data.message);

                                this.getStudentInvoices();
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.showAlert(
                                error.response.data.message,
                                "danger"
                            );
                        });
                } else {
                    this.isLoading = false;
                }
            } else {
                // save student id into storage
                localStorage.setItem("finance-tab", this.student.ID);
                let data = {
                    student: JSON.stringify(this.student)
                };
                axios
                    .post("/api/paymentplan/invoices-for-secondary", data)
                    .then(response => {
                        this.isLoading = false;
                        if (
                            response.status == 203 &&
                            response.data.success == false
                        ) {
                            this.showAlert(response.data.message, "danger");
                            return;
                        }
                        if (response.data) {
                            this.getStudentInvoices();
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        this.showAlert(error.response.data.message, "danger");
                    });
            }
        },
        createpaymentplanInvoices() {
            if (!this.permissions.createInvoicesStudents) return;
            this.isLoading = true;
            for (var i = 0; i < this.studentInvoices.length; i++) {
                if (
                    this.studentInvoices[i].PaymentPlan != null ||
                    this.studentInvoices[i].Installment != null
                ) {
                    this.payment_plan_invoices_exist = 1;
                }
            }
            if (this.payment_plan_invoices_exist == 1) {
                if (
                    confirm(
                        this.$t("form.invoice.paymentPlanBatchAlreadyExists")
                    )
                ) {
                    if (
                        this.deductible_courses_exist &&
                        (this.student.PaymentPlan == "monthly" ||
                            this.student.PaymentPlan == "annual" ||
                            this.student.PaymentPlan == "quarterly")
                    ) {
                        this.showAlert(
                            this.$t(
                                "form.invoice.deductible_credits_not_supported"
                            ),
                            "warning"
                        );
                    }
                    localStorage.setItem("finance-tab", this.student.ID);

                    const student = this.student;
                    student.GlobalDiscount = this.studentFinance.GlobalDiscount;

                    let data = {
                        student: JSON.stringify(student)
                    };

                    axios
                        .post("/api/paymentplan/invoices", data)
                        .then(response => {
                            this.isLoading = false;
                            if (
                                response.status == 203 &&
                                response.data.success == false
                            ) {
                                this.showAlert(response.data.message, "danger");
                                return;
                            }
                            if (response.data) {
                                this.showAlert(response.data.message);

                                this.getStudentInvoices();
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.showAlert(
                                error.response.data.message,
                                "danger"
                            );
                        });
                } else {
                    this.isLoading = false;
                }
            } else {
                // save student id into storage
                localStorage.setItem("finance-tab", this.student.ID);
                let data = {
                    student: JSON.stringify(this.student)
                };
                axios
                    .post("/api/paymentplan/invoices", data)
                    .then(response => {
                        this.isLoading = false;
                        if (
                            response.status == 203 &&
                            response.data.success == false
                        ) {
                            this.showAlert(response.data.message, "danger");
                            return;
                        }
                        if (response.data) {
                            this.getStudentInvoices();
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        this.showAlert(error.response.data.message, "danger");
                    });
            }
        },

        createPaymentPlanFPInvoices() {
            if (!this.permissions.createInvoicesStudents) return;
            this.isLoading = true;
            for (var i = 0; i < this.studentInvoices.length; i++) {
                if (
                    this.studentInvoices[i].PaymentPlan != null ||
                    this.studentInvoices[i].Installment != null
                ) {
                    this.payment_plan_invoices_exist = 1;
                }
            }
            if (this.payment_plan_invoices_exist == 1) {
                if (
                    confirm(
                        this.$t("form.invoice.paymentPlanFPBatchAlreadyExists")
                    )
                ) {
                    if (
                        this.deductible_courses_exist &&
                        (this.student.PaymentPlan == "monthly" ||
                            this.student.PaymentPlan == "annual" ||
                            this.student.PaymentPlan == "quarterly")
                    ) {
                        this.showAlert(
                            this.$t(
                                "form.invoice.deductible_credits_not_supported"
                            ),
                            "warning"
                        );
                    }
                    localStorage.setItem("finance-tab", this.student.ID);

                    const student = this.student;
                    student.GlobalDiscount = this.studentFinance.GlobalDiscount;

                    let data = {
                        student: JSON.stringify(student)
                    };

                    axios
                        .post("/api/paymentPlan/invoices/FP", data)
                        .then(response => {
                            this.isLoading = false;
                            if (
                                response.status == 203 &&
                                response.data.success == false
                            ) {
                                this.showAlert(response.data.message, "danger");
                                return;
                            }
                            if (response.data) {
                                this.showAlert(response.data.message);

                                this.getStudentInvoices();
                            }
                        })
                        .catch(error => {
                            this.isLoading = false;
                            this.showAlert(
                                error.response.data.message,
                                "danger"
                            );
                        });
                } else {
                    this.isLoading = false;
                }
            } else {
                // save student id into storage
                localStorage.setItem("finance-tab", this.student.ID);
                let data = {
                    student: JSON.stringify(this.student)
                };
                axios
                    .post("/api/paymentPlan/invoices/FP", data)
                    .then(response => {
                        this.isLoading = false;
                        if (
                            response.status == 203 &&
                            response.data.success == false
                        ) {
                            this.showAlert(response.data.message, "danger");
                            return;
                        }
                        if (response.data) {
                            this.getStudentInvoices();
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        this.showAlert(error.response.data.message, "danger");
                    });
            }
        },

        saveProfessor() {
            this.isLoading = true;

            axios
                .post("/api/professors", {
                    Title: this.title,
                    FirstName: this.firstName,
                    LastName: this.lastName,
                    Type: "student"
                })
                .then(response => {
                    this.isLoading = false;

                    if (response.data.message) {
                        let pro = response.data.data;
                        pro.FullName = `${pro.FirstName} ${pro.LastName}`;
                        this.professor.unshift(pro);

                        this.$nextTick(() =>
                            this.$bvModal.hide("addProfessorModal")
                        );
                        this.showAlert(response.data.message, "info");
                    }
                })
                .catch(error => {
                    this.isLoading = false;
                });
        },

        async createToken(type) {
            let response = await axios.post("/api/api-tokens", {
                type
            });
            let token = "";

            if (response.status == 200) {
                token = response.data.extra[0].token;
            }

            return token;
        },

        async downloadAttachment(file, isDownload = false) {
            let token = await this.createToken("student-attachment");
            if (token == "") return;

            // Encode the file name to handle special characters
            let encodedFileName = encodeURIComponent(file.Name);
            let encodedFilePath = encodeURIComponent(file.File);

            window.open(
                `/students/attachments/${encodedFileName}?id=${file.ID}&file=${encodedFilePath}&token=${token}&download=${isDownload}&type=${file.type}`,
                "_blank"
            );
        },

        async downloadRemarks() {
            let token = await this.createToken("student-remarks");

            if (token == "") return;

            window.open(
                `/students/${this.student.ID}/remarks?token=${token}`,
                "_blank"
            );
        },

        async downloadApplication(file, isDownload = false) {
            let token = await this.createToken("student-application");
            let encodedFilePath = encodeURIComponent(file);
            if (token == "") return;
            window.open(
                `/students/applications?file=${encodedFilePath}&token=${token}&download=${isDownload}`,
                "_blank"
            );
        },

        async downloadZipApplication(file, isDownload = false) {
            let token = await this.createToken("student-application");

            if (token == "") return;
            window.open(
                `/students/applications/zip?StudentNumber=${this.student.StudentNumber}&file=${file}&token=${token}&download=${isDownload}&type=${file.type}`,
                "_blank"
            );
        },

        async exportInvoices() {
            let token = await this.createToken("student-invoices");

            if (token == "") return;

            let url = `/students/${this.student.ID}/invoices?token=${token}`;
            if (this.invoiceType) url += `&type=${this.invoiceType}`;

            window.open(url, "_blank");
        },

        /**
         * Make absence course
         */
        addAbsenseCourse(course) {
            if (course == null) {
                this.studentAbsence.CourseID = null;
                this.studentAbsence.CourseTitle = null;

                return "";
            }

            this.studentAbsence.CourseID = course.CourseID;
            this.studentAbsence.CourseTitle = course.CourseTitle;
        },

        /**
         * Add absence course into student absence list
         */
        addAbsence() {
            this.invalidAbsenceDate =
                this.studentAbsence.Date == null ? true : false;
            this.invalidAbsenceReason =
                this.studentAbsence.Reason == null ||
                    this.studentAbsence.Reason == ""
                    ? true
                    : false;
            this.invalidAbsenceCourse =
                this.studentAbsence.CourseID == null ? true : false;

            if (
                this.invalidAbsenceDate ||
                this.invalidAbsenceReason ||
                this.invalidAbsenceCourse
            ) {
                this.showAlert(this.$t("form.validation.error"), "danger");
                return "";
            }

            // add to list
            this.studentAbsences.push({
                Date: this.studentAbsence.Date,
                Reason: this.studentAbsence.Reason,
                Remarks: this.studentAbsence.Remarks,
                CourseID: this.studentAbsence.CourseID,
                course: {
                    CourseTitle: this.studentAbsence.CourseTitle
                }
            });

            // reset after add
            this.studentAbsence = {
                Date: this.dateFormat ? moment().format(this.dateFormat) : null,
                Reason: null,
                CourseID: null,
                CourseTitle: null,
                Remarks: null
            };

            this.absenceCourse = null;

            this.alert = false;
        },

        /**
         * Remove absence courser from student absence list
         */
        removeAbsence(index) {
            if (confirm(this.$t("form.validation.delete"))) {
                if (!this.studentAbsences[index].id) {
                    this.studentAbsences.splice(index, 1);
                    return "";
                }

                axios
                    .delete(
                        `/api/students/${this.student.ID}/absences/${this.studentAbsences[index].id}`
                    )
                    .then(response => {
                        this.studentAbsences.splice(index, 1);
                        this.showAlert(response.data.message);
                    })
                    .catch(error => {
                        console.log("error");
                    });
            }
        },

        /**
         * Paginate Invoices/Audits
         */
        paginate() {
            this.getStudentInvoices();
        },

        /**
         * Paginate Student/Audits
         */
        paginateAudit() {
            this.getAudits();
        },

        /**
         * Get list of student invoices
         */
        getStudentInvoices() {
            this.checkInvoiceCall = false;
            if (localStorage.getItem("from")) {
                this.pagination.current_page = localStorage.getItem("page");
                this.tabIndex = 10;
                localStorage.removeItem("from");
            }
            if (this.isPartnerSchoolUser) return;

            let url = `/api/students/${this.student.ID}/invoices?page=${this.pagination.current_page}`;

            if (this.invoiceType) url += `&type=${this.invoiceType}`;

            this.isLoading = true;

            axios
                .get(url)
                .then(response => {
                    this.studentInvoices = response.data.data.data;
                    this.pagination = response.data.pagination;
                    this.isLoading = false;

                    localStorage.setItem("page", this.pagination.current_page)

                })
                .catch(err => {
                    this.isLoading = false;
                    console.log("error in getting invoices.")
                });
        },

        /**
         * Go to Show Invoice Page
         */
        goToShow(id, version) {
            if (!this.permissions.viewInvoices) return;
            this.$router.push({
                name: version === "V1" ? "InvoiceShowV1" : "InvoiceShowV2",

                params: {
                    id: id
                }
            });
        },

        /**
         * Go to Invoice edit page
         */
        goToEdit(id) {
            if (!this.permissions.editInvoicesStudents) return;
            localStorage.setItem("finance-tab", this.student.ID);

            this.$router.push({
                name: "StudentInvoiceEdit",
                params: {
                    id: id
                }
            });
        },

        /**
         * Get list of student audits
         */
        async getAudits() {
            if (
                this.isPartnerSchoolUser ||
                this.isRecruitmentManagerUser ||
                this.isFrontOfficeUser
            )
                return;

            this.loadingAudits = true;

            await axios
                .get(
                    `/api/students/${this.student.ID}/audits?page=` +
                    this.pagination_audit.current_page
                )
                .then((response) => {
                    this.loadingAudits = false;
                    this.audits = response.data.data.data;
                    this.pagination_audit = response.data.pagination;
                    if (this.audits[19]) {
                        this.audits[19].newValue = this.formatDate(
                            this.audits[19].newValue
                        );
                    }
                })
                .catch(function (error) {
                    this.loadingAudits = false;
                    console.log("error");
                });
        },

        onCancel() {
            console.log('User cancelled the loader.');
        },

        /**
         * Format Date
         */
        formatDate(format = "YYYY-MM-DD", date) {
            if (date) {
                return moment(date).format(format);
            }
            return null;
        },

        toDayDate() {
            return moment().format(this.dateFormat);
        },

        /**
         * Set Student Profile Photo
         */
        profileUploaded(file, response) {
            this.isLoading = false;
            this.student.Photo =
                response.student_number + "/" + response.filename;
        },

        showSelectedImage() {
            let input = this.$refs.profile_image;
            let file = input.files;
            if (file && file[0]) {
                let reader = new FileReader();
                reader.onload = e => {
                    this.image = e.target.result;
                };
                reader.readAsDataURL(file[0]);
                this.$emit("input", file[0]);
            }

            let fd = new FormData();
            fd.append("file", file[0]);
            fd.append("StudentNumber", this.$route.params.id);

            this.isLoading = true;

            axios
                .post("/api/students/profile-image", fd)
                .then(resp => {
                    this.student.Photo =
                        resp.data.student_number + "/" + resp.data.filename;
                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                    console.log("file not found");
                });
        },

        /**
         * Remove attachmemnt from student attachment list
         */
        removeAttachment(index, attach) {
            let vm = this;

            if (confirm(this.$t("form.validation.delete"))) {
                axios
                    .post("/api/deleteAttachFile", attach)
                    .then(response => {
                        if (response.data.error) {
                            this.showAlert(response.data.message, "warning");
                        } else if (response.data.success) {
                            vm.attachments.splice(index, 1);
                            this.showAlert(response.data.message);
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 403) {
                            this.showAlert(error.response.data.message, "warning");
                        } else {
                            console.log("error", error);
                        }
                    });
            }
        },
        Withdraw(rs) {
            this.studentProgram.Withdraw = rs;
            if (rs == -1) {
                this.withdrawcheckbox = true;
            } else {
                this.withdrawcheckbox = false;
            }
        },

        /**
         * Application Dropzone File(s)
         */
        cvUploaded(file, response) {
            this.isLoading = false;
            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };

            this.studentApplicationNewData.CurriculumVitae.push(
                fileUploaded
            );
            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "CurriculumVitae");

        },
        outlineUploaded(file, response) {
            this.isLoading = false;
            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };

            this.studentApplicationNewData.ResearchInterestOutline.push(
                fileUploaded
            );
            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "ResearchInterestOutline");
        },
        degreeUploaded(file, response) {
            this.isLoading = false;
            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };

            this.studentApplicationNewData.Degree.push(
                fileUploaded
            );
            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "Degree");
        },

        associateDegreeUploaded(file, response) {
            this.isLoading = false;

            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };


            this.studentApplicationNewData.AssociateDegree.push(
                fileUploaded
            );
            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "AssociateDegree");
        },
        transcriptUploaded(file, response) {
            this.isLoading = false;

            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };


            this.studentApplicationNewData.Transcript.push(
                fileUploaded
            );

            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "Transcript");
        },
        passportUploaded(file, response) {
            this.isLoading = false;

            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };


            this.studentApplicationNewData.PassportCopy.push(
                fileUploaded
            );

            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "PassportCopy");
        },
        permitUploaded(file, response) {
            this.isLoading = false;

            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };


            this.studentApplicationNewData.PermitCopy.push(
                fileUploaded
            );

            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "PermitCopy");
        },
        letterUploaded(file, response) {
            this.isLoading = false;
            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };

            this.studentApplicationNewData.Letter.push(
                fileUploaded
            );

            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "Letter");
        },

        pictureUploaded(file, response) {
            this.isLoading = false;
            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };

            this.studentApplicationNewData.Picture.push(
                fileUploaded
            );

            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "Picture");
        },

        additionalDocumentsUploaded(file, response) {
            this.isLoading = false;
            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };

            this.studentApplicationNewData.AdditionalDocuments.push(
                fileUploaded
            );

            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "AdditionalDocuments");
        },

        englishProficiencyUploaded(file, response) {
            this.isLoading = false;

            var fileUploaded =
            {
                path: response.student_number ? `${response.student_number}/${response.id}/${response.filename}` : `${response.id}/${response.filename}`,
                timestamp: calculateTimeAsPerTimeZone('+2')
            };


            this.studentApplicationNewData.EnglishProficiency.push(
                fileUploaded
            );

            this.uploadedFileSaveInDb({ ...response, path: fileUploaded.path }, "EnglishProficiency");
        },

        removeApplicationFile(index, attach, type = null) {
            let vm = this;
            const data = { path: attach, StudentID: this.student.ID };
            if (confirm(this.$t("form.validation.delete"))) {
                axios
                    .post("/api/students/application/file/delete", data)
                    .then(response => {
                        if (response.data.error) {
                            this.showAlert(response.data.message, "warning");
                        } else if (response.data.success) {
                            vm.studentApplication[type].splice(index, 1);
                            this.showAlert(response.data.message);
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 403) {
                            this.showAlert(error.response.data.message, "warning");
                        } else {
                            console.log("error", error);
                        }
                    });
            }
        },

        removeNewApplicationFile(index, attach, type = null) {
            let vm = this;
            const data = { path: attach, StudentID: this.student.ID };

            if (confirm(this.$t("form.validation.delete"))) {
                axios
                    .post("/api/students/application/file/delete", data)
                    .then(response => {
                        if (response.data.error) {
                            this.showAlert(response.data.message, "warning");
                        } else if (response.data.success) {
                            vm.studentApplicationNewData[type].splice(index, 1);
                            this.showAlert(response.data.message);
                        }
                    })
                    .catch(error => {
                        if (error.response && error.response.status === 403) {
                            this.showAlert(error.response.data.message, "warning");
                        } else {
                            console.log("error", error);
                        }
                    });
            }
        },

        /**
         * Thesis evaluation form uploaded
         */
        thesisEvaluationUploaded(file, response) {
            this.isLoading = false;
            this.studentProgram.ThesisEvaluation = `${this.student.StudentNumber}/${response.id}/${response.filename}`;

            this.updateStudent();
        },

        async downloadThesisEvaluation(file, isDownload) {
            let token = await this.createToken("student-thesis");

            if (token == "") return;
            window.open(
                `/students/${this.student.ID}/thesis-evaluation?file=${file}&download=${isDownload}&token=${token}`,
                "_blank"
            );
        },

        /**
         * Add Selected program into student program
         */
        selectProgram(programID) {
            let program = this.programs.find(p => p.ID === programID);

            if (!program) return;

            this.studentProgram.ProgramID = program.ID;
            this.selectedProgramCode = program.ProgramCode;

            this.getProgramCourses();
            this.getSecondaryProgram();
            this.programchanged = 1;
        },

        /**
         * Add Selected secondary program into student secondary program
         */
        selectProgram2(programID) {
            let program = this.secondaryPrograms.find(p => p.ID === programID);

            if (!program) return;

            this.studentProgram.Program2ID = program.ID;
            this.selectedProgram2Code = program.ProgramCode;
            this.getProgramCourses("se");
        },

        /**
         * Get Program Related Courses for Student Grades Dropdown
         */
        getProgramCourses(type = "pr") {
            let id = 0;

            id =
                type == "pr"
                    ? this.studentProgram.ProgramID
                    : this.studentProgram.Program2ID;

            if (!id) return;

            axios
                .get(`/api/programs/${id}/courses`)
                .then(response => {
                    if (type == "pr") {
                        this.courses = response.data;

                        this.courses.map(
                            c =>
                                (c.FullTitle = `${c.CourseCode} - ${c.CourseTitle}`)
                        );
                        this.courses2 = [];
                    } else {
                        this.courses2 = response.data;
                        this.courses2.map(
                            c =>
                                (c.FullTitle = `${c.CourseCode} - ${c.CourseTitle}`)
                        );
                    }
                })
                .catch(error => {
                    console.log(error.response);
                });
        },

        /**
         * Get Secondary Programs related to selected program
         */
        getSecondaryProgram() {
            let code = this.programCodesSecondaryMajor.find(
                code => code == this.selectedProgramCode
            );

            if (!code) {
                this.secondaryPrograms = [];
                return;
            }

            axios
                .get("/api/programs/secondary?code=" + code)
                .then(response => {
                    this.secondaryPrograms = response.data;
                    this.secondaryPrograms = this.secondaryPrograms.map(
                        program => {
                            program.FullTitle = this.$options.filters.program(
                                program
                            );

                            return program;
                        }
                    );
                    // set previously selected program
                    if (this.studentProgram.Program2ID) {
                        this.secondaryPrograms.find(sp => {
                            if (sp.ID === this.studentProgram.Program2ID) {
                                this.selectedProgram2Code = sp.ProgramCode;
                                this.getProgramCourses("se"); // get secondary program courses
                            }
                        });
                    }

                    this.isLoading = false;
                })
                .catch(error => {
                    console.log("error");
                    this.isLoading = false;
                });
        },

        /**
         * Delete individual Student status history entry
         */
        deleteStatus(index) {
            this.studentStatus.splice(index, 1);
            this.student.status.splice(index, 1);
        },
        /**
         * Reset or Selected status
         */
        onChangeStatus() {
            this.statusCreateMode = true;

            if (!this.status) {
                this.status = {
                    StatusID: "",
                    StatusName: "",
                    StatusComment: "",
                    StatusDate: this.toDayDate()
                };

                return;
            }

            this.status.StatusComment = null;
            
            // Assign graduation date dynamically if "Graduated" is selected
            if (this.status.StatusName === "Graduated") {
                this.status.StatusDate = this.studentProgram.GraduationDate ? this.studentProgram.GraduationDate : this.toDayDate();
            } else {
                this.status.StatusDate = this.toDayDate();
            }
        },
        /**
         * select status on unchecking withdrawn checkbox
         */
        onChangeStatusModal() {
            this.statusCreateModeModal = true;
            
            // Set modal date context to graduation date if applicable
            if (this.status && this.status.StatusName === "Graduated") {
                this.statusDate = this.studentProgram.GraduationDate ? this.studentProgram.GraduationDate : this.toDayDate();
                if(this.status) this.status.StatusDate = this.statusDate;
            } else {
                this.statusDate = this.toDayDate();
                if(this.status) this.status.StatusDate = this.statusDate;
            }
        },
        /**
         * Add Status to Student Status List
         */
        async addStatus($event) {
            if (!this.status.StatusID) {
                this.showAlert(
                    this.$t("form.validation.invalidStatus"),
                    "danger"
                );
                return;
            }

            if (this.status.StatusName == "Graduated") {
                if (!(await this.markGraduated(false))) return;
            }

            this.studentStatus.push({
                StudentStatusID: this.status.StatusID,
                StudentStatusName: this.status.StatusName,
                StudentStatusComment: this.status.StatusComment,
                StudentStatusDate: this.status.StatusDate
            });
            this.$bvModal.hide("uncheck-withdraw-modal");
            this.statusCreateMode = false;
            this.statusCreateModeModal = false;
            this.student.CurrentStatus = this.status.StatusID;
            this.saveStatuses($event);
        },

        /**
         * Add Status to Student Status List from Modal
         */
        async addModalStatus(shouldClose = false) {
            if (!this.status.StatusID) {
                this.showAlert(
                    this.$t("form.validation.invalidStatus"),
                    "danger"
                );
                return;
            }

            if (this.status.StatusName == "Graduated") {
                if (!(await this.markGraduated(false))) return;
            }

            this.$bvModal.hide("uncheck-withdraw-modal");
            this.statusCreateMode = false;
            this.statusCreateModeModal = false;
            this.student.CurrentStatus = this.status.StatusID;

            /* If Status in withdram */

            if (this.status.StatusID == 4) {
                this.studentProgram.Withdraw = -1;
            } else {
                this.studentProgram.Withdraw = 0;
            }

            let data = {
                status: {
                    StudentStatusID: this.status.StatusID,
                    StudentStatusName: this.status.StatusName,
                    StudentStatusComment: this.status.StatusComment,
                    StudentStatusDate: this.statusDate
                },
                student: {},
                graduate: 0
            };

            data.student.CurrentStatus = this.student.CurrentStatus;

            // update program & graduation requirements in case of Graduated Status
            if (this.studentProgram.Graduate) {
                data.graduate = 1;
                data.program = JSON.stringify(this.studentProgram);
                data.graduateReq = JSON.stringify(this.studentGraduateReq);
            }
            axios
                .post(`/api/students/${this.student.ID}/status`, data)
                .then(response => {
                    this.isLoading = false;
                    this.withdrawcheckbox_changed = 0;
                    this.withdrawcheckbox = false;
                    this.showAlert(response.data.message);

                    if (response.data.data.graduate == 1) {
                        setTimeout(
                            () =>
                                this.$router.push({
                                    name: "AlumniEdit",
                                    params: [
                                        {
                                            id: this.student.ID
                                        }
                                    ]
                                }),
                            2000
                        );

                        return true;
                    }

                    return this.updateStudent(shouldClose);
                })
                .catch(error => {
                    this.isLoading = false;
                    console.log(error);
                });
        },

        saveStatuses($event) {
            let data = {
                status: [],
                student: {},
                graduate: 0
            };

            this.studentStatus.forEach(status =>
                data.status.push(JSON.stringify(status))
            );
            data.student.CurrentStatus = this.student.CurrentStatus;

            // update program & graduation requirements in case of Graduated Status
            if (this.studentProgram.Graduate) {
                data.graduate = 1;
                data.program = JSON.stringify(this.studentProgram);
                data.graduateReq = JSON.stringify(this.studentGraduateReq);
            }

            axios
                .put(`/api/students/${this.student.ID}/statuses`, data)
                .then(response => {
                    this.isLoading = false;
                    this.updated = true;
                    this.showAlert(response.data.message);
                    if (response.data.data.graduate == 1) {
                        setTimeout(
                            () =>
                                this.$router.push({
                                    name: "AlumniEdit",
                                    params: [
                                        {
                                            id: this.student.ID
                                        }
                                    ]
                                }),
                            2000
                        );

                        return true;
                    }

                    if (response.data.data.statuses.length) {
                        this.studentStatus = [];
                        response.data.data.statuses.map(status => {
                            let s = status.pivot;
                            s.StudentStatusName = status.StatusName;

                            this.studentStatus.push(s);
                        });
                        this.getAudits();
                        if (this.tabIndex == 0) {
                            this.getStudent();
                        } else if (this.tabIndex == 4) {
                            this.updateStudent(false);
                        }
                    }
                    this.closing = true;

                })
                .catch(error => {
                    this.isLoading = false;
                    console.log("error saving statuses");
                });
        },

        /**
         * Update student
         */
        updateStudent(shouldClose = false) {
            this.$v.$touch();

            if (this.disableEditForm) return;

            if (this.$v.$invalid) {
                let errorMsg = "";
                if (this.$v.student.FirstName.$error) {
                    errorMsg = "FirstName";
                }

                if (this.$v.student.LastName.$error) {
                    errorMsg = errorMsg ? errorMsg + ", LastName" : "LastName";
                }

                if (this.$v.student.BirthPlace.$error) {
                    errorMsg = errorMsg
                        ? errorMsg + ", BirthPlace"
                        : "BirthPlace";
                }

                if (this.$v.student.Email.$error) {
                    errorMsg = errorMsg ? errorMsg + ", Email" : "Email";
                }

                if (this.$v.studentProgram.ThesisSubject.$error) {
                    errorMsg = errorMsg
                        ? errorMsg + ", Thesis Subject"
                        : "Thesis Subject";
                }

                if (this.$v.studentProgram.ThesisPercentage.$error) {
                    errorMsg = errorMsg
                        ? errorMsg + ", Thesis Percentage"
                        : "Thesis Percentage";
                }


                if (this.$v.studentProgram.ProgramID.$error) {
                    errorMsg = errorMsg ? errorMsg + ", Program" : "Program";
                };

                if (!this.isPartnerSchoolUser && this.isAccountingUser) {
                    if (this.$v.studentFinance.GlobalDiscount.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", Global Discount"
                            : "Global Discount";
                    }
                    if (this.$v.studentFinance.FullPaymentDiscount.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", Full Payment Discount"
                            : "Full Payment Discount";
                    }
                }

                if (this.$v.grades.$each.$error) {
                    errorMsg = errorMsg
                        ? errorMsg + ", Grade Percentage and Grade"
                        : "Grade Percentage and Grade";
                }
                /* Custom Errors for Business Information */
                if (this.student.MailAddress == 2) {
                    if (this.$v.studentBussiness.CompanyName.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", Company Name (Business Information)"
                            : "Company Name (Business Information)";
                    }

                    if (this.$v.studentBussiness.Department.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", Department (Business Information)"
                            : "Department (Business Information)";
                    }

                    if (this.$v.studentBussiness.Position.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", Position (Business Information)"
                            : "Position (Business Information)";
                    }

                    if (this.$v.studentBussiness.StreetAddress.$error) {
                        errorMsg = errorMsg
                            ? errorMsg +
                            ", Street Address (Business Information)"
                            : "Street Address (Business Information)";
                    }

                    if (this.$v.studentBussiness.City.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", City (Business Information)"
                            : "City (Business Information)";
                    }

                    if (this.$v.studentBussiness.Country.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", Country (Business Information)"
                            : "Country (Business Information)";
                    }
                    if (this.$v.studentBussiness.Zip.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", Zip (Business Information)"
                            : "Zip (Business Information)";
                    }

                    if (this.$v.studentBussiness.Phone.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", Phone (Business Information)"
                            : "Phone (Business Information)";
                    }

                    if (this.$v.studentBussiness.Mobile.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", Mobile (Business Information)"
                            : "Mobile (Business Information)";
                    }

                    if (this.$v.studentBussiness.Email.$error) {
                        errorMsg = errorMsg
                            ? errorMsg + ", Email (Business Information)"
                            : "Email (Business Information)";
                    }
                }

                if (errorMsg !== "") {
                    if (errorMsg == "Global Discount") {
                        this.showAlert(
                            this.$t("form.validation.invalidGlobalDiscount", {
                                errors: errorMsg
                            }),
                            "danger"
                        );
                        return;
                    }
                    this.showAlert(
                        this.$t("form.validation.mandatoryFieldsError", {
                            errors: errorMsg
                        }),
                        "danger"
                    );
                    return;
                }
            }

            this.shouldClose = this.shouldClose
                ? this.shouldClose
                : shouldClose;

            if (this.withdrawcheckbox === true) {
                this.withdrawcheckbox = -1;
                this.studentProgram.Withdraw = -1;
            }

            /* If status removed from withdraw */
            if (
                this.withdrawcheckbox == false &&
                this.withdrawcheckbox_changed == 1
            ) {
                this.withdrawcheckbox = 0;
                this.$bvModal.show("uncheck-withdraw-modal");
                this.withdrawcheckboxChanged = false;
            } else {
                this.isLoading = true;

                let courses = [];
                let fpCourses = [];
                let courses2 = [];
                let attachments = [];

                // Compare with previous status
                if (this.student.CurrentStatus === 4) {
                    this.withdrawcheckbox = true;
                    this.studentProgram.Withdraw = 1;
                }

                this.grades.forEach(course => {
                    if (course.Percentage == "") {
                        course.Percentage = null;
                    }
                    courses.push(JSON.stringify(course));
                });

                this.fpGrades.forEach(fpCourse => {
                    if (fpCourse.Percentage == "") {
                        fpCourse.Percentage = null;
                    }
                    fpCourses.push(JSON.stringify(fpCourse));
                });

                this.secondaryGrades.forEach(course => {
                    if (course.Percentage == "") {
                        course.Percentage = null;
                    }
                    courses2.push(JSON.stringify(course));
                });

                this.attachments.forEach(attach =>
                    attachments.push(JSON.stringify(attach))
                );

                this.studentApplication.ValidResearchInterestOutline =
                    this.studentApplication.ValidResearchInterestOutline == true
                        ? 1
                        : 0;
                const applicationData = {
                    PassportCopy:
                        this.studentApplicationNewData.PassportCopy.length >
                            0
                            ? this.studentApplication.PassportCopy.concat(
                                this.studentApplicationNewData.PassportCopy
                            )
                            : this.studentApplication.PassportCopy,
                    PermitCopy:
                        this.studentApplicationNewData.PermitCopy.length >
                            0
                            ? this.studentApplication.PermitCopy.concat(
                                this.studentApplicationNewData.PermitCopy
                            )
                            : this.studentApplication.PermitCopy,
                    CurriculumVitae:
                        this.studentApplicationNewData.CurriculumVitae.length >
                            0
                            ? this.studentApplication.CurriculumVitae.concat(
                                this.studentApplicationNewData.CurriculumVitae
                            )
                            : this.studentApplication.CurriculumVitae,
                    Degree:
                        this.studentApplicationNewData.Degree.length > 0
                            ? this.studentApplication.Degree.concat(
                                this.studentApplicationNewData.Degree
                            )
                            : this.studentApplication.Degree,
                    Transcript:
                        this.studentApplicationNewData.Transcript.length > 0
                            ? this.studentApplication.Transcript.concat(
                                this.studentApplicationNewData.Transcript
                            )
                            : this.studentApplication.Transcript,
                    Letter:
                        this.studentApplicationNewData.Letter.length > 0
                            ? this.studentApplication.Letter.concat(
                                this.studentApplicationNewData.Letter
                            )
                            : this.studentApplication.Letter,
                    Picture:
                        this.studentApplicationNewData.Picture.length > 0
                            ? this.studentApplication.Picture.concat(
                                this.studentApplicationNewData.Picture
                            )
                            : this.studentApplication.Picture,
                    AdditionalDocuments:
                        this.studentApplicationNewData.AdditionalDocuments
                            .length > 0
                            ? this.studentApplication.AdditionalDocuments.concat(
                                this.studentApplicationNewData
                                    .AdditionalDocuments
                            )
                            : this.studentApplication.AdditionalDocuments,
                    EnglishProficiency:
                        this.studentApplicationNewData.EnglishProficiency
                            .length > 0
                            ? this.studentApplication.EnglishProficiency.concat(
                                this.studentApplicationNewData
                                    .EnglishProficiency
                            )
                            : this.studentApplication.EnglishProficiency,
                    Score: this.studentApplication.Score,
                    AssociateDegree:
                        this.studentApplicationNewData.AssociateDegree.length >
                            0
                            ? this.studentApplication.AssociateDegree.concat(
                                this.studentApplicationNewData.AssociateDegree
                            )
                            : this.studentApplication.AssociateDegree,
                    ValidAssociateDegree: this.studentApplication
                        .ValidAssociateDegree,
                    ResearchInterestOutline:
                        this.studentApplicationNewData.ResearchInterestOutline
                            .length > 0
                            ? this.studentApplication.ResearchInterestOutline.concat(
                                this.studentApplicationNewData
                                    .ResearchInterestOutline
                            )
                            : this.studentApplication.ResearchInterestOutline,
                    ValidResearchInterestOutline: this.studentApplication
                        .ValidResearchInterestOutline,
                    ValidCurriculumVitae: this.studentApplication
                        .ValidCurriculumVitae,
                    ValidDegree: this.studentApplication.ValidDegree,
                    ValidTranscript: this.studentApplication.ValidTranscript,
                    ValidLetter: this.studentApplication.ValidLetter,
                    ValidPicture: this.studentApplication.ValidPicture,
                    ValidEnglishProficiency: this.studentApplication
                        .ValidEnglishProficiency,
                    ValidPassportCopy: this.studentApplication.ValidPassportCopy,
                    ValidPermitCopy: this.studentApplication.ValidPermitCopy,
                };

                if (this.studentProgram.Graduate == 1) {
                    this.studentProgram.Graduate = -1;
                } else {
                    this.studentProgram.Graduate = 0;
                }

                if (this.bookIncludedcheckbox == 1) {
                    this.studentProgram.BooksIncluded = -1;
                } else {
                    this.studentProgram.BooksIncluded = 0;
                }

                this.student.GlobalDiscount = this.studentFinance.GlobalDiscount;
                this.student.FullPaymentDiscount = this.studentFinance.FullPaymentDiscount;

                let data = {
                    student: JSON.stringify(this.student),
                    business: JSON.stringify(this.studentBussiness),
                    admission: JSON.stringify(this.studentAdmission),
                    program: JSON.stringify(this.studentProgram),
                    grades: courses,
                    fpGrades: fpCourses,
                    grades2: courses2,
                    graduateReq: JSON.stringify(this.studentGraduateReq),
                    studentAbsences: this.studentAbsences,
                    attachments: attachments,
                    application: JSON.stringify(applicationData),
                    student_reduction: this.student_reduction
                };

                axios
                    .put(`/api/students/${this.student.ID}`, data)
                    .then(response => {
                        this.isLoading = false;
                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            if (this.shouldClose) {
                                setTimeout(() => {
                                    this.$router.push({
                                        name: 'StudentIndex'
                                    }).catch(() => { });
                                }, 2000);
                                return;
                            }
                            this.studentApplicationNewData = {
                                CurriculumVitae: [],
                                Degree: [],
                                Transcript: [],
                                Letter: [],
                                Picture: [],
                                PassportCopy: [],
                                PermitCopy: [],
                                AdditionalDocuments: [],
                                EnglishProficiency: [],
                                ResearchInterestOutline: [],
                                AssociateDegree: []
                            };
                            var apiRes = response.data;
                            this.setStudentData(apiRes);

                            this.updateCalled = 1;

                            this.getAudits();
                            this.getStudentInvoices();
                            this.closing = true;
                            this.updated = true;
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        if (error.response) {
                            if (error.response.data.error) {
                                this.showAlert(
                                    error.response.data.message,
                                    "danger"
                                );
                            }
                        } else {
                            this.showAlert(error, "danger");
                        }
                    });
            }
        },


        autoSave(field, value) {
            const data = {
                id: this.student.ID,
                data: { [field]: value }
            }

            axios
                .post(`/api/students/auto/save`, data)
                .then(response => console.log(response))
                .catch(error => console.log(error))
        },
        /**
         * Show alert
         */
        showAlert(msg, cls = "success") {
            this.alertMessage = msg;
            this.alertClass = cls;
            this.alert = true;
        },

        /**
         * Partner selected
         */
        selectedPartner() {
            this.student.PartnerCampusID = null;

            this.getCurrentUserPartnerCode(this.student.PartnerID);

            this.fetchPartnerCampus();
        },

        /**
         * Fetch partner campuses for selected partner
         */
        fetchPartnerCampus() {
            if (!this.student.PartnerID) return;

            axios
                .get(`/api/campuses?full&PartnerID=${this.student.PartnerID}`)
                .then(response => (this.partnercampus = response.data))
                .catch(error => console.log("error fetching partner campuses"));
        },

        changeCheck($event) {
            if ($event.target.name == "withdrawcheckbox") {
                this.withdrawcheckbox_changed = 1;
            }
        },
        changeCreditCheck($event) {
            if ($event.target.name == "deductible_credits_checkbox") {
                this.withdrawcheckbox_changed = 1;
            }
        },

        /**
         * Checks Graduation Requirements
         * CurrentUserPartnerCode is SBS
         * For Other PartnerCodes it is optional
         * Following Checks must be Implemented
         * ====================================
         * ProgramCode AAE and BBA:
         * Bachelor Exit Survey
         * Bachelor Exit Exam (CBE) Taken
         * Passing GPA
         * No Financial Obligation to SBS
         * =====================================
         * ProgramCode MBA and EMBA:
         * SentExit Survey
         * Master Exit Exam (CBE) Taken
         * Passing GPA
         * No Financial Obligation to SBS
         * =====================================
         * ProgramCode MSC:
         * Sent Exit Survey
         * Internship Report Submmitted and Passed
         * Passing GPA
         * No Financial Obligation to SBS
         * ====================================
         * ProgramCode DBA:
         * Sent Exit Survey
         * Exit Exam (SBS) Taken
         * Passing GPA
         * No Financial Obligation to SBS
         * ====================================
         */
        checkGraduationRequirements() {
            let res = false;
            let programCode = this.selectedProgramCode;
            let stdGrduationReq = this.studentGraduateReq;

            if (!programCode) {
                alert(this.$t("form.validation.invalidProgram"));
                return false;
            }

            /* This Graduation conditions check is applied only to partner code SBS*/
            if (this.CurrentUserPartnerCode === "SBS") {
                /**
                 * Applied to All ProgramCode:
                 * ===========================
                 * Passing GPA
                 * No Financial Obligation to SBS
                 * ===========================
                 * */

                if (
                    stdGrduationReq.PassingGPA &&
                    stdGrduationReq.FinancialObligations
                ) {
                    if (
                        programCode.toUpperCase() === "AAE" ||
                        programCode.toUpperCase() === "BBA"
                    ) {
                        /**
                         * Program Code AAE and BBA:
                         * =========================
                         * Bachelor Exit Survey
                         * Bachelor Exit Exam (CBE) Taken
                         * ========================
                         * */

                        if (
                            stdGrduationReq.BBAExitSurvey
                        ) {
                            res = true;
                        }
                    } else if (
                        programCode.toUpperCase() === "MBA" ||
                        programCode.toUpperCase() === "EMBA"
                    ) {
                        /**
                         * Sent Exit Survey
                         * Master Exit Exam (CBE) Taken
                         **/
                        if (
                            stdGrduationReq.CEExitSurvey &&
                            stdGrduationReq.MASExitExamSBS
                        ) {
                            res = true;
                        }
                    } else if (programCode.toUpperCase() === "MSC") {
                        /**
                         * Sent Exit Survey
                         * Internship Report Submmitted And Passed
                         **/
                        if (
                            stdGrduationReq.MASExitSurvey &&
                            stdGrduationReq.MSCInternReport
                        ) {
                            res = true;
                        }
                    } else if (programCode == "DBA") {
                        if (
                            stdGrduationReq.DBAExitExamSBS &&
                            stdGrduationReq.DBAExitExamSBSResult
                        ) {
                            res = true;
                        }
                    }
                }
            } else {
                /**
                 *
                 * Optional for PartnerCode other than SBS
                 *
                 */
                res = true;
            }

            return res;
        },

        /**
         * Mark as graduated after successfully check
         */
        async markGraduated(event) {
            if (event) event.target.checked = false;

            if (!this.checkGraduationRequirements()) {
                alert(this.$t("form.validation.invalidExam"));
                return false;
            }

            this.checkInvoiceCall = false;

            let conf = confirm(this.$t("form.validation.graduateCheck"));

            if (conf) {
                if (event) {
                    event.target.checked = true;

                    let status = this.statusList.find(
                        s => s.StatusName == "Graduated"
                    );

                    if (status) {
                        this.studentStatus.push({
                            StudentStatusID: status.StatusID,
                            StudentStatusName: status.StatusName,
                            StudentStatusComment: status.StatusComment,
                            StudentStatusDate: this.studentProgram.GraduationDate ? this.studentProgram.GraduationDate : this.toDayDate()
                        });
                        
                        this.student.CurrentStatus = status.StatusID;
                    }
                }

                this.studentProgram.Graduate = 1;
                if (event) {
                    this.saveStatuses();
                }
            }

            return conf;
        },
        /**
         * Get initials data for form
         */
        async getInitialData() {
            await axios
                .get("/api/students/initial-data")
                .then(response => {
                    let data = response.data;
                    this.userPartnerCode = data.user_partner_code;
                    this.foundationAllowedCodes = data.foundation_program_codes;
                    this.gradingScales = data.grading_scale;
                    this.defaultGradingScaleTypeId = data.default_grading_scale_type_id;
                    this.partners = data.partners;
                    this.countries = data.countries;
                    this.titles = data.titles;
                    this.currencies = data.currencies;
                    this.descriptiveGrades = data.descriptiveGrades;
                    this.ECTSGrades = data.ECTSGrades;
                    this.partnersDisabled = data.partnersDisabled; // disabled partners select
                    this.isAccountingUser = data.isAccountingUser;
                    this.paymentPlans = data.paymentPlans;
                    this.programCodesSecondaryMajor =
                        data.programCodes_secondaryMajor;

                    this.perPageAudits = data.auditsPaginate;

                    this.statusList = data.status;
                    this.statusList.map(status => {
                        status.StatusComment = "";
                        status.StatusDate = this.toDayDate();
                    });

                    this.professor = data.professors;
                    this.professor.map(
                        p => (p.FullName = `${p.FirstName} ${p.LastName}`)
                    );

                    this.programs = data.programs;
                    this.programs.map(
                        p => (p.FullTitle = this.$options.filters.program(p))
                    );
                })
                .catch(error => console.log("error fetching initial data"));
        },

        /**
         * Clear exam after deselect related checkbox
         */
        clearExamScore() {
            if (this.studentGraduateReq.MASExitExamSBS == false) {
                this.studentGraduateReq.MASExitExamSBSResult = null;
            }

            if (this.studentGraduateReq.DBAExitExamSBS == false) {
                this.studentGraduateReq.DBAExitExamSBSResult = null;
            }
        },

        /**
         * Edit check call for currently editing user(s) for same record.
         */

        checkForEdit(refresh = false) {
            if (refresh) this.continueInterVal = true;
            let data = {
                field_id: this.$route.params.id,
                form: this.$route.name,
                refresh: refresh
            };
            axios
                .post("/api/check-for-edit-session", data)
                .then(response => {
                    this.sessionCreated = true;
                    if (response.data.warning == 0) {
                        this.disableEditForm = false;
                        this.showDisableAlert = false;
                        if (this.firstLoad) {
                            this.firstLoad = false;
                        }
                    }

                    if (response.data.warning == -1) {
                        this.disableEditForm = false;
                        this.showDisableAlert = false;
                    }

                    if (response.data.warning == 1) {
                        this.firstLoad = false;
                        this.disableEditFormMessage = response.data.message;
                        this.disableEditForm = true;
                        this.showDisableAlert = true;
                        this.continueInterVal = false;
                    }

                    if (response.data.warning == 2) {
                        let msg = response.data.message;
                        if (this.firstLoad) {
                            msg.replace("re-open", "open");
                        }
                        this.sessionCreated = false;
                        this.disableEditFormMessage = msg;
                        this.disableEditForm = true;
                        this.showDisableAlert = true;
                    }
                    if (response.data.warning == 3) {
                        this.disableEditForm = false;
                        this.showDisableAlert = true;
                        this.disableEditFormMessage = response.data.message;
                    }
                })
                .catch(error => {
                    console.log("error");
                });
        },
        programTypeId(programId) {
            if (!programId) {
                console.warn('programTypeId: missing programId');
                return null;
            }

            const p = (this.programs || []).find(
                p => Number(p.ID) === Number(programId)
            );

            return p && p.GradingScaleTypeID
                ? Number(p.GradingScaleTypeID)
                : null;
        },
        /**
         * Populate gradingScale based on current student's program and partner
         */
         populateGradingScaleForCurrentStudent(programCode, partnerCode, programId = null) {
            if (!this.gradingScales || !programCode) return;
            this.$delete(this.gradingScale, programCode);
            const typeId = this.programTypeId(programId);
            const scale = GradingScaleResolver.resolve(this.gradingScales, {
                programCode,
                partnerCode,
                typeId,
                defaultTypeId: this.defaultGradingScaleTypeId,
            });
            if (scale) this.$set(this.gradingScale, programCode, scale.grading_scale);
        },
        /**
         * Populate gradingScale for Foundation Program
         */
         populateGradingScaleForFoundationProgram(programCode, partnerCode, programId = null) {
            if (!this.gradingScales || !programCode) return;
            this.$delete(this.gradingScale, programCode);
            const scale = GradingScaleResolver.resolve(this.gradingScales, {
                programCode, partnerCode,
                typeId: this.programTypeId(programId),
                defaultTypeId: this.defaultGradingScaleTypeId,
            });
            if (scale) this.$set(this.gradingScale, programCode, scale.grading_scale);
        },
        /**
         * setting student data from response
         */
        async setStudentData(response) {
            this.student = response.data.student;
            localStorage.setItem("get-student", JSON.stringify(response.data.student));
            if (this.student.FullPaymentDiscount == null) {
                this.studentFinance.FullPaymentDiscount = this.defaultFullPaymentDiscount;
            } else {
                this.studentFinance.FullPaymentDiscount = this.student.FullPaymentDiscount;
            }

            this.deductible_courses_exist =
                response.data.deductible_courses_exist;
            this.studentFinance.GlobalDiscount = this.student.GlobalDiscount;
            this.getStudentInvoices();
            this.getStudentPaymentSummaries();
            this.tuitionFee = response.data.tuitionfee;
            this.payment_plan_invoices_exist =
                response.data.payment_plan_invoices_exist;
            this.getCurrentUserPartnerCode(this.student.PartnerID);
            if (this.student.BirthDate) {
                this.student.BirthDate = this.student.BirthDate
                    ? moment(this.student.BirthDate).format(
                        this.dateFormat
                    )
                    : this.student.BirthDate;
            }
            if (this.student.PermitExpiry) {
                this.student.PermitExpiry = this.student.PermitExpiry
                    ? moment(this.student.PermitExpiry).format(this.dateFormat)
                    : this.student.PermitExpiry;
            }
            if (this.student.PassportExpiry) {
                this.student.PassportExpiry = this.student.PassportExpiry
                    ? moment(this.student.PassportExpiry).format(this.dateFormat)
                    : this.student.PassportExpiry;
            }
            if (response.data.program) {
                let program = response.data.program;
                this.selectedProgramCode = program.ProgramCode;
                
                // Get partner code from CURRENT student data
                const studentPartnerCode = this.student.PartnerID 
                    ? this.partners.find(p => p.PartnerID === this.student.PartnerID)?.PartnerCode 
                    : null;

                if (response.data.program.BillingCycle == "inherit") {
                    this.paymentPlanToShow = 0;
                }

                let student = JSON.parse(localStorage.getItem("get-student"));
                let id = student.programs[0].FoundationID;
                if (this.foundationAllowedCodes.includes(student.programs[0].ProgramCode) && id != null) {
                    this.foundationGrades = true;
                    this.foundationProgram = this.programs.find(p => p.ID === id);

                    axios
                        .get(`/api/programs/${id}/courses`)
                        .then(response => {
                            this.fpCourses = response.data;
                            this.fpCourses.map(
                                c =>
                                    (c.FullTitle = `${c.CourseCode} - ${c.CourseTitle}`)
                            );
                        })
                        .catch(error => {
                            console.log(error.response);
                        });
                }

                if (response.data.grades) {
                    if (response.data.grades.length != 0) {
                        for (
                            var i = 0;
                            i < response.data.grades.length;
                            i++
                        ) {
                            if (
                                response.data.program.ProgramCode ==
                                "EMBA" &&
                                response.data.grades[i].CourseCode ==
                                "THE770"
                            ) {
                                this.gradeDetails =
                                    response.data.grades[i].pivot;
                            } else if (
                                response.data.program.ProgramCode ==
                                "DBA" &&
                                response.data.grades[i].CourseCode ==
                                "DOC700"
                            ) {
                                this.gradeDetails =
                                    response.data.grades[i].pivot;
                            } else if (
                                (response.data.program.ProgramCode ==
                                    "AAE" ||
                                    response.data.program.ProgramCode ==
                                    "BBA") &&
                                response.data.grades[i].CourseCode ==
                                "THE350"
                            ) {
                                this.gradeDetails =
                                    response.data.grades[i].pivot;
                            } else if (
                                response.data.program.ProgramCode !=
                                "EMBA" &&
                                response.data.program.ProgramCode !=
                                "DBA" &&
                                response.data.program.ProgramCode !=
                                "BBA" &&
                                response.data.program.ProgramCode !=
                                "AAE" &&
                                response.data.grades[i].CourseCode ==
                                "THE755"
                            ) {
                                this.gradeDetails =
                                    response.data.grades[i].pivot;
                            }
                        }
                    }

                    if (response.data.gpa.gpa) {
                        this.gpa = response.data.gpa.gpa;
                    }

                    if (response.data.localGpa.local_gpa) {
                        this.localGpa = response.data.localGpa.local_gpa;
                    }

                    if (response.data.fp_gpa) {
                        this.fpGpa = response.data.fp_gpa.gpa;
                    }

                    if (response.data.fp_localGpa) {
                        this.fpLocalGpa = response.data.fp_localGpa.local_gpa;
                    }
                }
            }

            if (this.student.Photo) {
                this.getImage(
                    `/api/students/${this.student.ID}/profile-image`
                );
            }

            if (this.student.ProgramStart) {
                this.student.ProgramStart = this.student.ProgramStart
                    ? moment(this.student.ProgramStart).format(
                        this.dateFormat
                    )
                    : this.student.ProgramStart;
            }

            if (response.data.business != null) {
                this.studentBussiness = response.data.business;
            }

            if (response.data.admission != null) {
                this.studentAdmission = response.data.admission;
            }

            if (response.data.program) {
                let program = response.data.program;

                this.studentPaymentSummary.IntroText = `We herewith confirm receipt of the following payments to date, toward tuition fees, regarding the ${program.ProgramTitle} ${program.ProgramCode} (${program.ProgramType}) program you are currently enrolled in:`;

                this.selectedProgramCode = program.ProgramCode;               
                // Assign the pivot data
                this.studentProgram = program.pivot;
                this.studentProgram.FoundationID = program.FoundationID;
                
                if (program.pivot.Withdraw == -1) {
                    this.withdrawcheckbox = true;
                } else {
                    this.withdrawcheckbox = false;
                }
                if (program.pivot.BooksIncluded == -1) {
                    this.bookIncludedcheckbox = true;
                } else {
                    this.bookIncludedcheckbox = false;
                }

                // Format the date for the datepicker
                if (this.studentProgram.GraduationDate) {
                    this.studentProgram.GraduationDate = moment(this.studentProgram.GraduationDate).format(this.dateFormat);
                }

                await this.getProgramCourses();

                if (this.studentProgram.Program2ID) {
                    await this.getSecondaryProgram(this.studentProgram.Program2ID);
                }

                if (this.studentProgram.Graduate != -1) {
                    this.studentProgram.Graduate = null;
                }
            }

            if (response.data.gradutionReq != null) {
                this.studentGraduateReq = response.data.gradutionReq;

                if (this.studentGraduateReq.DBAEApprovalDate) {
                    this.studentGraduateReq.DBAEApprovalDate = this
                        .studentGraduateReq.DBAEApprovalDate
                        ? moment(
                            this.studentGraduateReq.DBAEApprovalDate
                        ).format(this.dateFormat)
                        : this.studentGraduateReq.DBAEApprovalDate;
                }

                if (this.studentGraduateReq.DBAStatsExamDate) {
                    this.studentGraduateReq.DBAStatsExamDate = this
                        .studentGraduateReq.DBAStatsExamDate
                        ? moment(
                            this.studentGraduateReq.DBAStatsExamDate
                        ).format(this.dateFormat)
                        : this.studentGraduateReq.DBAStatsExamDate;
                }

                if (this.studentGraduateReq.DBACompsDate) {
                    this.studentGraduateReq.DBACompsDate = this
                        .studentGraduateReq.DBACompsDate
                        ? moment(
                            this.studentGraduateReq.DBACompsDate
                        ).format(this.dateFormat)
                        : this.studentGraduateReq.DBACompsDate;
                }

                if (this.studentGraduateReq.DBAMADate) {
                    this.studentGraduateReq.DBAMADate = this
                        .studentGraduateReq.DBAMADate
                        ? moment(
                            this.studentGraduateReq.DBAMADate
                        ).format(this.dateFormat)
                        : this.studentGraduateReq.DBAMADate;
                }

                if (this.studentGraduateReq.DBADODDate) {
                    this.studentGraduateReq.DBADODDate = this
                        .studentGraduateReq.DBADODDate
                        ? moment(
                            this.studentGraduateReq.DBADODDate
                        ).format(this.dateFormat)
                        : this.studentGraduateReq.DBADODDate;
                }

                if (this.studentGraduateReq.DBADegreeIssueDate) {
                    this.studentGraduateReq.DBADegreeIssueDate = this
                        .studentGraduateReq.DBADegreeIssueDate
                        ? moment(
                            this.studentGraduateReq.DBADegreeIssueDate
                        ).format(this.dateFormat)
                        : this.studentGraduateReq.DBADegreeIssueDate;
                }
            }

            // Status
            if (response.data.status) {
                if (response.data.status.length != 0) {
                    this.studentStatus = [];
                    response.data.status.map(status => {
                        let s = status.pivot;
                        s.StudentStatusName = status.StatusName;

                        this.studentStatus.push(s);
                    });

                    if (this.studentStatus.length) {
                        let currentStatus = this.studentStatus.find(
                            s =>
                                s.StudentStatusID ==
                                this.student.CurrentStatus
                        );

                        if (currentStatus) {
                            this.status = {
                                StatusComment: null,
                                StatusDate: this.toDayDate(),
                                StatusID: currentStatus.StudentStatusID,
                                StatusName: currentStatus.StudentStatusName
                            };
                        }
                    }
                }
            }

            // Grades
            if (response.data.grades) {
                if (response.data.grades.length != 0) {
                    this.grades = [];

                    response.data.grades.map(course => {
                        let c = course.pivot;
                        c.CourseTitle = course.CourseTitle;
                        c.FullTitle = `${course.CourseCode} - ${course.CourseTitle}`;
                        c.FinalExameDate = this.convertDate(
                            c.FinalExameDate
                        );
                        if (c.Percentage == null && c.Grade == null && c.DescriptiveGrade == null && parseFloat(c.LocalGrade) < 4.0 && this.student.PartnerID == 1) {
                            c.DescriptiveGrade = "F";
                        }

                        this.grades.push(c);
                    });
                }
            }

            // Foundation Program Grades
            if (response.data.fp_grades) {
                if (response.data.fp_grades.length != 0) {
                    this.fpGrades = [];

                    response.data.fp_grades.map(course => {
                        let c = course.pivot;
                        c.CourseTitle = course.CourseTitle;
                        c.FullTitle = `${course.CourseCode} - ${course.CourseTitle}`;
                        c.FinalExameDate = this.convertDate(
                            c.FinalExameDate
                        );
                        if (c.Percentage == null && c.Grade == null && c.DescriptiveGrade == null && parseFloat(c.LocalGrade) < 4.0 && this.student.PartnerID == 1) {
                            c.DescriptiveGrade = "F";
                        }

                        this.fpGrades.push(c);
                    });
                }
            }

            // Secondary Grades
            if (response.data.secondary_grades) {
                if (response.data.secondary_grades.length != 0) {
                    this.secondaryGrades = [];

                    response.data.secondary_grades.map(course => {
                        let c = course.pivot;
                        c.CourseTitle = course.CourseTitle;
                        c.FullTitle = `${course.CourseCode} - ${course.CourseTitle}`;
                        c.FinalExameDate = this.convertDate(
                            c.FinalExameDate
                        );

                        if (c.Percentage == null && c.Grade == null && this.student.PartnerID == 1 && parseFloat(c.LocalGrade) < 4) {
                            c.DescriptiveGrade = "F";
                        }
                        this.secondaryGrades.push(c);
                    });
                }
            }


            // Attachments
            if (response.data.attachments) {
                if (response.data.attachments.length != 0) {
                    this.attachments = [];

                    response.data.attachments.map(attach => {
                        let a = attach;
                        a.UploadTimestamp = a.UploadTimestamp ? moment(a.UploadTimestamp).format(this.datetimeFormat) : null;
                        a.Name = this.getAttachmentFileName(a.File);

                        this.attachments.push(a);
                    });
                }
            }


            // Student Absences
            if (response.data.studentAbsences) {
                if (response.data.studentAbsences.length != 0) {
                    this.studentAbsences = response.data.studentAbsences;
                    for (var i = 0; i < this.studentAbsences.length; i++) {
                        this.studentAbsences[i].Date = moment(
                            this.studentAbsences[i].Date
                        ).format(this.dateFormat);
                    }
                }
            }


            if (response.data.application != null) {
                this.studentApplication.TS = response.data.application.TS;
                this.studentApplication.CurriculumVitae = response.data
                    .application.CurriculumVitae
                    ? response.data.application.CurriculumVitae
                    : [];
                this.studentApplication.Degree = response.data
                    .application.Degree
                    ? response.data.application.Degree
                    : [];
                this.studentApplication.Transcript = response.data
                    .application.Transcript
                    ? response.data.application.Transcript
                    : [];
                this.studentApplication.Letter = response.data
                    .application.Letter
                    ? response.data.application.Letter
                    : [];
                this.studentApplication.Picture = response.data
                    .application.Picture
                    ? response.data.application.Picture
                    : [];
                this.studentApplication.PermitCopy = response
                    .data.application.PermitCopy
                    ? response.data.application.PermitCopy
                    : [];

                this.studentApplication.PassportCopy = response
                    .data.application.PassportCopy
                    ? response.data.application.PassportCopy
                    : [];

                this.studentApplication.AdditionalDocuments = response
                    .data.application.AdditionalDocuments
                    ? response.data.application.AdditionalDocuments
                    : [];
                this.studentApplication.Score = response.data
                    .application.Score
                    ? response.data.application.Score
                    : "";
                this.studentApplication.EnglishProficiency = response
                    .data.application.EnglishProficiency
                    ? response.data.application.EnglishProficiency
                    : [];
                this.studentApplication.ResearchInterestOutline = response
                    .data.application.ResearchInterestOutline
                    ? response.data.application.ResearchInterestOutline
                    : [];
                this.studentApplication.ValidCurriculumVitae = response
                    .data.application.ValidCurriculumVitae
                    ? response.data.application.ValidCurriculumVitae
                    : false;
                this.studentApplication.ValidDegree = response.data
                    .application.ValidDegree
                    ? response.data.application.ValidDegree
                    : false;
                this.studentApplication.ValidTranscript = response.data
                    .application.ValidTranscript
                    ? response.data.application.ValidTranscript
                    : false;
                this.studentApplication.ValidLetter = response.data
                    .application.ValidLetter
                    ? response.data.application.ValidLetter
                    : false;
                this.studentApplication.ValidPicture = response.data
                    .application.ValidPicture
                    ? response.data.application.ValidPicture
                    : false;
                this.studentApplication.ValidEnglishProficiency = response
                    .data.application.ValidEnglishProficiency
                    ? response.data.application.ValidEnglishProficiency
                    : false;
                this.studentApplication.ValidResearchInterestOutline = response
                    .data.application.ValidResearchInterestOutline
                    ? response.data.application
                        .ValidResearchInterestOutline
                    : false;
                this.studentApplication.ValidAssociateDegree = response
                    .data.application.ValidAssociateDegree
                    ? response.data.application.ValidAssociateDegree
                    : false;
                this.studentApplication.ValidPassportCopy = response
                    .data.application.ValidPassportCopy
                    ? response.data.application.ValidPassportCopy
                    : false;
                this.studentApplication.ValidPermitCopy = response
                    .data.application.ValidPermitCopy
                    ? response.data.application.ValidPermitCopy
                    : false;
                this.studentApplication.AssociateDegree = response.data
                    .application.AssociateDegree
                    ? response.data.application.AssociateDegree
                    : [];
                if (
                    typeof this.studentApplication
                        .ResearchInterestOutline == "string" &&
                    this.studentApplication.ResearchInterestOutline !=
                    ""
                ) {
                    this.studentApplication.ResearchInterestOutline = JSON.parse(
                        this.studentApplication.ResearchInterestOutline
                    );
                }
                if (
                    typeof this.studentApplication
                        .AdditionalDocuments == "string" &&
                    this.studentApplication.AdditionalDocuments != ""
                ) {
                    this.studentApplication.AdditionalDocuments = JSON.parse(
                        this.studentApplication.AdditionalDocuments
                    );
                }
                if (
                    typeof this.studentApplication.Picture ==
                    "string" &&
                    this.studentApplication.Picture != ""
                ) {
                    this.studentApplication.Picture = JSON.parse(
                        this.studentApplication.Picture
                    );
                }
                if (
                    typeof this.studentApplication.Letter == "string" &&
                    this.studentApplication.Letter != ""
                ) {
                    this.studentApplication.Letter = JSON.parse(
                        this.studentApplication.Letter
                    );
                }
                if (
                    typeof this.studentApplication.Transcript ==
                    "string" &&
                    this.studentApplication.Transcript != ""
                ) {
                    this.studentApplication.Transcript = JSON.parse(
                        this.studentApplication.Transcript
                    );
                }
                if (
                    typeof this.studentApplication.Degree == "string" &&
                    this.studentApplication.Degree != ""
                ) {
                    this.studentApplication.Degree = JSON.parse(
                        this.studentApplication.Degree
                    );
                }
                if (
                    typeof this.studentApplication.CurriculumVitae ==
                    "string" &&
                    this.studentApplication.CurriculumVitae != ""
                ) {
                    this.studentApplication.CurriculumVitae = JSON.parse(
                        this.studentApplication.CurriculumVitae
                    );
                }
                if (
                    typeof this.studentApplication.EnglishProficiency ==
                    "string" &&
                    this.studentApplication.EnglishProficiency != ""
                ) {
                    this.studentApplication.EnglishProficiency = JSON.parse(
                        this.studentApplication.EnglishProficiency
                    );
                }
                if (
                    typeof this.studentApplication.AssociateDegree ==
                    "string" &&
                    this.studentApplication.AssociateDegree != ""
                ) {
                    this.studentApplication.AssociateDegree = JSON.parse(
                        this.studentApplication.AssociateDegree
                    );
                }

                if (
                    typeof this.studentApplication.PassportCopy ==
                    "string" &&
                    this.studentApplication.PassportCopy != ""
                ) {
                    this.studentApplication.PassportCopy = JSON.parse(
                        this.studentApplication.PassportCopy
                    );
                }

                if (
                    typeof this.studentApplication.PermitCopy ==
                    "string" &&
                    this.studentApplication.PermitCopy != ""
                ) {
                    this.studentApplication.PermitCopy = JSON.parse(
                        this.studentApplication.PermitCopy
                    );
                }
                if (
                    typeof this.studentApplication
                        .ResearchInterestOutline == "object" &&
                    this.studentApplication.ResearchInterestOutline !=
                    ""
                ) {
                    this.studentApplication.ResearchInterestOutline = Object.values(
                        this.studentApplication.ResearchInterestOutline
                    );
                }
                if (
                    typeof this.studentApplication
                        .AdditionalDocuments == "object" &&
                    this.studentApplication.AdditionalDocuments != ""
                ) {
                    this.studentApplication.AdditionalDocuments = Object.values(
                        this.studentApplication.AdditionalDocuments
                    );
                }

                if (
                    typeof this.studentApplication
                        .PassportCopy == "object" &&
                    this.studentApplication.PassportCopy != ""
                ) {
                    this.studentApplication.PassportCopy = Object.values(
                        this.studentApplication.PassportCopy
                    );
                }

                if (
                    typeof this.studentApplication
                        .PermitCopy == "object" &&
                    this.studentApplication.PermitCopy != ""
                ) {
                    this.studentApplication.PermitCopy = Object.values(
                        this.studentApplication.PermitCopy
                    );
                }

                if (
                    typeof this.studentApplication.Picture ==
                    "object" &&
                    this.studentApplication.Picture != ""
                ) {
                    this.studentApplication.Picture = Object.values(
                        this.studentApplication.Picture
                    );
                }
                if (
                    typeof this.studentApplication.Letter == "object" &&
                    this.studentApplication.Letter != ""
                ) {
                    this.studentApplication.Letter = Object.values(
                        this.studentApplication.Letter
                    );
                }
                if (
                    typeof this.studentApplication.Transcript ==
                    "object" &&
                    this.studentApplication.Transcript != ""
                ) {
                    this.studentApplication.Transcript = Object.values(
                        this.studentApplication.Transcript
                    );
                }
                if (
                    typeof this.studentApplication.Degree == "object" &&
                    this.studentApplication.Degree != ""
                ) {
                    this.studentApplication.Degree = Object.values(
                        this.studentApplication.Degree
                    );
                }
                if (
                    typeof this.studentApplication.CurriculumVitae ==
                    "object" &&
                    this.studentApplication.CurriculumVitae != ""
                ) {
                    this.studentApplication.CurriculumVitae = Object.values(
                        this.studentApplication.CurriculumVitae
                    );
                }
                if (
                    typeof this.studentApplication.EnglishProficiency ==
                    "object" &&
                    this.studentApplication.EnglishProficiency != ""
                ) {
                    this.studentApplication.EnglishProficiency = Object.values(
                        this.studentApplication.EnglishProficiency
                    );
                }
                if (
                    typeof this.studentApplication.AssociateDegree ==
                    "object" &&
                    this.studentApplication.AssociateDegree != ""
                ) {
                    this.studentApplication.AssociateDegree = Object.values(
                        this.studentApplication.AssociateDegree
                    );
                }
            }
        },

        /**
         * Get student
         */
        async getStudent(isCheckCall = false) {
            this.firstLoad = false;
            this.isLoading = true;
            try {
                const response = await axios.get(
                    "/api/students/" + this.$route.params.id + "/edit"
                );
                if (response.data) {
                    this.student = response.data.student;

                    if (this.student.programs) {
                        this.program1Type = this.student.programs[0].ProgramType;
                        if (this.student.programs2.length > 0) {
                            this.program2Type = this.student.programs2[0].ProgramType;
                        }
                        this.coursesArr = this.student.course;
                        this.courses2Arr = this.student.course2;
                    } else {
                        console.log('No program assigned to record.');
                    }

                    if (this.student.RecordType === "alumni") {
                        this.checkForEdit(false);
                        this.$router.push({
                            name: "AlumniEdit",
                            params: [
                                {
                                    id: this.student.ID
                                }
                            ]
                        });
                    }

                    if (localStorage.getItem("create-invoice-from-student")) {
                        if (
                            JSON.parse(
                                localStorage
                                    .getItem("create-invoice-from-student")
                                    .toLowerCase()
                            )
                        ) {
                            this.tabIndex = this.finance_tab;
                        }
                    }
                    localStorage.setItem("create-invoice-from-student", false);

                    // setting data instead of api call to getStudent
                    var apiResponse = response;
                    this.setStudentData(apiResponse);

                    // Fetch Partner Call here to prevent v-select issue
                    if (this.updateCalled == 0) {
                        if (!isCheckCall) this.fetchPartnerCampus();
                    }
                    this.updateCalled = 0;
                    if (!this.permissions.editStudentsProgram) {
                        this.$refs.thesisEvaluationDropzone.disable();
                    }
                    setTimeout(() => {
                        this.isLoading = false;
                    }, 3000);
                }
            } catch (error) {
                console.log(error);
            }
        },

        convertDate(date) {
            if (date) {
                return moment(date).format(this.dateFormat);
            } else {
                return null;
            }
        },
        // get student profile image
        getImage(url) {
            axios
                .get(url, {
                    responseType: "arraybuffer"
                })
                .then(response => {
                    this.image = this.imageEncode(response);
                });
        },

        // encode image to base64
        imageEncode(response) {
            let arrayBuffer = response.data;
            let b64encoded = btoa(
                [].reduce.call(
                    new Uint8Array(arrayBuffer),
                    (p, c) => p + String.fromCharCode(c),
                    ""
                )
            );
            let mimetype = response.headers["content-type"].toLowerCase();

            return `data:${mimetype};base64,${b64encoded}`;
        }
    },

    beforeRouteLeave(to, from, next) {

        clearInterval(this.interval);

        if (this.closing || this.updated) next();
        else {

            const answer = window.confirm(this.$t("leavePrompt"));

            if (answer) {
                next();
            } else {
                localStorage.removeItem("grades-tab");
                localStorage.removeItem("finance-tab");
                localStorage.removeItem("summary-tab");
                localStorage.removeItem("from");
                localStorage.removeItem("page")
                next(false);
            }
        }
    }
};
</script>

<style scoped>
::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: black !important;
}

::-moz-placeholder {
    /* Firefox 19+ */
    color: black !important;
}

:-ms-input-placeholder {
    /* IE 10+ */
    color: black !important;
}

:-moz-placeholder {
    /* Firefox 18- */
    color: black !important;
}

body {
    background-color: #e2e2e2;
}

#dropzone2 {
    padding: 0;
    margin: 0;
}

#app {
    padding: 20px;
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    max-width: 100%;
    max-height: 500px;
}

.disabledProgram {
    pointer-events: none !important;
}

.disabledAttachment {
    pointer-events: none;
}

.disabledGraduation {
    pointer-events: none;
}

.disabledAbsence {
    pointer-events: none;
}

.disabledAdmission {
    pointer-events: none;
}

.disabledAdmission {
    pointer-events: none;
}

.disabledRemarks {
    pointer-events: none;
}

.disabledGrade {
    pointer-events: none;
}

.disabledBusiness {
    pointer-events: none;
}

.disabledPersonal {
    pointer-events: none;
}

.overlay-row {
    cursor: not-allowed;
    background: #eee;
}

input[type="date"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    display: none;
}

.custom-validate {
    display: block !important;
}

.grades-btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 5px;
    background-color: #fff;
    padding: 2rem;
}

.grades-btns button,
.gpa-box {
    min-width: 150px;
}

.gpa-box {
    display: inline-block;
    font-size: 110%;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 0.35rem;
    margin-top: 1rem;
}

@media only screen and (min-width: 1900px) {
    .grades-btns {
        flex-direction: row;
        justify-content: space-between;
    }

    .gpa-box {
        padding: 2rem;
        margin-top: 0;
    }
}
</style>